import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

import * as JSPHP from "../../CaptureExecLocalDatabaseMobx/JSPHP.js";
import * as CEGeneralReact from "../../CaptureExecGeneral/CEGeneralReact.js";
import * as CEIconsReact from '../../CaptureExecGeneral/CEIconsReact.js';
import * as LibraryReact from "../../Library/LibraryReact.js";
import * as JSFUNC from "../../Library/JSFUNC.js";

import * as OpenCaptureReact from "../OpenCapture/OpenCaptureReact.js";


//Search Fields Capture Summary Tables
export const NumberOfAssignedCapturesCountButton = inject("CapturesMobx")(observer(
class NumberOfAssignedCapturesCountButton extends Component { //props: p_partialNumMatchingCaptures, p_matchingCaptureIDsArray, p_floatingBoxTitle
  onclick_num_captures_assigned = () => {
    const p_matchingCaptureIDsArray = this.props.p_matchingCaptureIDsArray;
    const p_floatingBoxTitle = this.props.p_floatingBoxTitle;

    this.props.CapturesMobx.a_set_view_specified_captures_in_floating_box_search_fields_capture_summary_table_capture_ids_array_and_floating_box_title(p_matchingCaptureIDsArray, p_floatingBoxTitle);
  }

  render() {
    const p_partialNumMatchingCaptures = this.props.p_partialNumMatchingCaptures;
    const p_matchingCaptureIDsArray = this.props.p_matchingCaptureIDsArray;
    const p_floatingBoxTitle = this.props.p_floatingBoxTitle;

    const partialNumMatchingCapturesDecimalTrim = JSFUNC.round_number_to_num_decimals_if_needed(p_partialNumMatchingCaptures, 1);

    return(
      <LibraryReact.InteractiveDiv
        p_class="textCenter bgBlueGradient hoverLightBlueGradient border bevelBorderColors cursorPointer"
        p_styleObj={{width:"6em", borderRadius:"0.5em"}}
        f_onClick={this.onclick_num_captures_assigned}>
        <LibraryReact.NowrapEllipsis p_fontClass="fontBold fontWhite">
          {partialNumMatchingCapturesDecimalTrim}
        </LibraryReact.NowrapEllipsis>
      </LibraryReact.InteractiveDiv>
    );
  }
}));


export const ViewSpecifiedCapturesInFloatingBoxSearchFieldsCaptureSummaryTable = inject("CaptureExecMobx", "OpenCaptureMobx", "CapturesMobx", "UserMobx")(observer(
class ViewSpecifiedCapturesInFloatingBoxSearchFieldsCaptureSummaryTable extends Component {
  onclick_capture_open_capture = (i_captureID) => {
    this.props.OpenCaptureMobx.a_open_single_capture(i_captureID);
  }

  onclick_close_view_search_results_captures = () => {
    this.props.CapturesMobx.a_set_view_specified_captures_in_floating_box_search_fields_capture_summary_table_capture_ids_array_and_floating_box_title(undefined, undefined);
  }

  render() {
    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const o_viewSpecifiedCapturesInFloatingBoxSearchFieldsCaptureSummaryTableFloatingBoxTitle = this.props.CapturesMobx.o_viewSpecifiedCapturesInFloatingBoxSearchFieldsCaptureSummaryTableFloatingBoxTitle;
    const c_viewSpecifiedCapturesInFloatingBoxSearchFieldsCstTableObjOrUndefined = this.props.CapturesMobx.c_viewSpecifiedCapturesInFloatingBoxSearchFieldsCstTableObjOrUndefined;
    const c_userCanMassEditAndMassDeleteCaptureTableTF = this.props.UserMobx.c_userCanMassEditAndMassDeleteCaptureTableTF;

    if(c_viewSpecifiedCapturesInFloatingBoxSearchFieldsCstTableObjOrUndefined === undefined) {
      return(null);
    }

    const searchFieldsFilteredCstMaskedCaptureValuesArrayOfObjs = c_viewSpecifiedCapturesInFloatingBoxSearchFieldsCstTableObjOrUndefined.searchFieldsFilteredCstMaskedCaptureValuesArrayOfObjs;
    const searchFieldsCstSumRowColumnsArrayOfObjsOrUndefined = c_viewSpecifiedCapturesInFloatingBoxSearchFieldsCstTableObjOrUndefined.searchFieldsCstSumRowColumnsArrayOfObjsOrUndefined;
    const searchFieldsExpandedCstColumnsArrayOfObjs = c_viewSpecifiedCapturesInFloatingBoxSearchFieldsCstTableObjOrUndefined.searchFieldsExpandedCstColumnsArrayOfObjs;
    const sortFieldIDOrUndefined = c_viewSpecifiedCapturesInFloatingBoxSearchFieldsCstTableObjOrUndefined.sortFieldIDOrUndefined;
    const sortIsAscTFOrUndefined = c_viewSpecifiedCapturesInFloatingBoxSearchFieldsCstTableObjOrUndefined.sortIsAscTFOrUndefined;
    const numCaptures = c_viewSpecifiedCapturesInFloatingBoxSearchFieldsCstTableObjOrUndefined.numCaptures;

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="large"
        p_title={o_viewSpecifiedCapturesInFloatingBoxSearchFieldsCaptureSummaryTableFloatingBoxTitle}
        p_zIndexWithinParentOrUndefinedForceFront={1}
        f_onClickCancel={this.onclick_close_view_search_results_captures}>
        {(searchFieldsExpandedCstColumnsArrayOfObjs.length === 0) ? (
          <CEGeneralReact.EmptyScreenWhite p_fontClass="">
            {"--Your " + c_productStylingObj.productName + " Admin has not added any columns to this Capture Table view--"}
          </CEGeneralReact.EmptyScreenWhite>
        ) : (
          <>
            <div className="flex00a displayFlexRow">
              <div className="flex11a displayFlexColumnVc lrMedPad textRight">
                <LibraryReact.NowrapEllipsis p_fontClass="font12 fontBold fontItalic fontTextLighter">
                  {numCaptures + " " + JSFUNC.plural(numCaptures, "Capture", "Captures")}
                </LibraryReact.NowrapEllipsis>
              </div>
              {(c_userCanMassEditAndMassDeleteCaptureTableTF) &&
                <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"2.5em"}}>
                  <CaptureTableExportCsvMassEditMassDeleteVerticalDotsMenu
                    p_sortedFilteredMaskedCaptureValuesArrayOfObjs={searchFieldsFilteredCstMaskedCaptureValuesArrayOfObjs}
                    p_cstSumRowColumnsArrayOfObjsOrUndefined={searchFieldsCstSumRowColumnsArrayOfObjsOrUndefined}
                    p_expandedCstColumnsArrayOfObjs={searchFieldsExpandedCstColumnsArrayOfObjs}
                    p_filterName={o_viewSpecifiedCapturesInFloatingBoxSearchFieldsCaptureSummaryTableFloatingBoxTitle}
                    p_exportToCsvOptionTF={true}
                  />
                </div>
              }
            </div>
            <div className="flex11a xyScroll lrMedPad hugeBottomPad">
              <SearchFieldsCaptureSummaryTable
                p_filteredCstMaskedCaptureValuesArrayOfObjs={searchFieldsFilteredCstMaskedCaptureValuesArrayOfObjs}
                p_cstSumRowColumnsArrayOfObjsOrUndefined={searchFieldsCstSumRowColumnsArrayOfObjsOrUndefined}
                p_expandedCstColumnsArrayOfObjs={searchFieldsExpandedCstColumnsArrayOfObjs}
                p_initialSortFieldID={sortFieldIDOrUndefined}
                p_initialSortIsAscTF={sortIsAscTFOrUndefined}
                p_checkedCaptureIDsArray={undefined}
                p_maxNumCapturesShown={undefined}
                f_onClickCapture={this.onclick_capture_open_capture}
                f_onClickCheckBox={undefined}
              />
            </div>
          </>
        )}
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));


export const SearchFieldsCaptureSummaryTable = inject("CaptureExecMobx", "CapturesMobx")(observer(
class SearchFieldsCaptureSummaryTable extends Component { //props: p_filteredCstMaskedCaptureValuesArrayOfObjs, p_cstSumRowColumnsArrayOfObjsOrUndefined, p_expandedCstColumnsArrayOfObjs, p_initialSortFieldID, p_initialSortIsAscTF, p_checkedCaptureIDsArray, p_maxNumCapturesShown, f_onClickCapture(i_cpatureID), f_onClickCheckBox(i_cpatureID)
  //p_filteredCstMaskedCaptureValuesArrayOfObjs   (use a copied arrayOfObjs var and not a MobX observable which throws an error when sorted within this function)
  //p_cstSumRowColumnsArrayOfObjsOrUndefined      (optional) array of sumRowColumnObjs (with fields sumValueMaskPlainText, sumValueMask)
  //p_expandedCstColumnsArrayOfObjs               columns
  //p_initialSortFieldID                          (optional) initial sort field
  //p_initialSortIsAscTF                          (optional) initial sort direction of initial sort field
  //p_checkedCaptureIDsArray                      (optional) creates an extra first column with checkboxes controlled by this input when provided
  //p_maxNumCapturesShown                         [default: 50] max # captures drawn before the 'Show All' button is clicked

  constructor(props) {
    super(props);

    const p_initialSortFieldID = this.props.p_initialSortFieldID;
    const p_initialSortIsAscTF = this.props.p_initialSortIsAscTF;

    this.state = {
      s_sortCapturesHeaderSortFieldID: p_initialSortFieldID,
      s_sortCapturesHeaderIsAscTF: p_initialSortIsAscTF,
      s_showAllCapturesTF: false
    }
  }

  componentDidUpdate(prevProps) {
    if(this.props.p_filteredCstMaskedCaptureValuesArrayOfObjs.length !== prevProps.p_filteredCstMaskedCaptureValuesArrayOfObjs.length) {
      this.setState({s_showAllCapturesTF: false});
    }
  }

  onclick_header_column = (i_sortFieldID) => { //when clicking a header, switch to that header, if the header is the same as it was before, flip the direction
    this.setState((i_state, i_props) => ({
      s_sortCapturesHeaderSortFieldID: i_sortFieldID,
      s_sortCapturesHeaderIsAscTF: ((i_state.s_sortCapturesHeaderSortFieldID === i_sortFieldID) ? (!i_state.s_sortCapturesHeaderIsAscTF) : (true))
    }));
  }

  onclick_show_all_captures = () => {
    this.setState({s_showAllCapturesTF: true});
  }

  render() {
    const s_sortCapturesHeaderSortFieldID = this.state.s_sortCapturesHeaderSortFieldID;
    const s_sortCapturesHeaderIsAscTF = this.state.s_sortCapturesHeaderIsAscTF;
    const s_showAllCapturesTF = this.state.s_showAllCapturesTF;

    const p_filteredCstMaskedCaptureValuesArrayOfObjs = this.props.p_filteredCstMaskedCaptureValuesArrayOfObjs;
    const p_cstSumRowColumnsArrayOfObjsOrUndefined = this.props.p_cstSumRowColumnsArrayOfObjsOrUndefined;
    const p_expandedCstColumnsArrayOfObjs = this.props.p_expandedCstColumnsArrayOfObjs;
    const p_initialSortFieldID = this.props.p_initialSortFieldID;
    const p_initialSortIsAscTF = this.props.p_initialSortIsAscTF;
    const p_checkedCaptureIDsArray = this.props.p_checkedCaptureIDsArray;
    const p_maxNumCapturesShown = JSFUNC.prop_value(this.props.p_maxNumCapturesShown, 50);

    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;

    if(p_expandedCstColumnsArrayOfObjs.length === 0) {
      return(
        <CEGeneralReact.EmptyScreenWhite p_fontClass="">
          {"--Your " + c_productStylingObj.productName + " Admin has not added any columns to this Capture Table view--"}
        </CEGeneralReact.EmptyScreenWhite>
      );
    }
    
    const checkboxColumnWidthEm = 3;

    const numCaptures = p_filteredCstMaskedCaptureValuesArrayOfObjs.length;
    const maxNumCapturesShown = ((s_showAllCapturesTF) ? (JSFUNC.sort_max_mysqli_int()) : (p_maxNumCapturesShown));
    const includeCheckboxColumnTF = JSFUNC.is_array(p_checkedCaptureIDsArray);

    //compute the full width of the table by adding each column width
    const tableWidthEm = JSFUNC.sum_of_arrayOfObjs_int_or_decimal_column(p_expandedCstColumnsArrayOfObjs, "width_em");
    var tableWidthWithCheckboxColumnEm = tableWidthEm;
    if(includeCheckboxColumnTF) {
      tableWidthWithCheckboxColumnEm += checkboxColumnWidthEm;
    }

    if(s_sortCapturesHeaderSortFieldID !== undefined) {
      const sortPropertyName = s_sortCapturesHeaderSortFieldID + "SORT";
      JSFUNC.sort_arrayOfObjs(p_filteredCstMaskedCaptureValuesArrayOfObjs, sortPropertyName, s_sortCapturesHeaderIsAscTF);
    }

    return(
      <>
        <div className="displayFlexRow bgBlueGradient borderB1ddd" style={{height:"2.3em", width:tableWidthWithCheckboxColumnEm + "em"}}>
          {(includeCheckboxColumnTF) &&
            <div className="flex00a" style={{flexBasis:"3em", borderRight:"solid 1px #eee"}} />
          }
          {p_expandedCstColumnsArrayOfObjs.map((m_expandedCstColumnObj, m_index) =>
            <SearchFieldsCaptureSummaryTableHeaderColumn
              key={m_expandedCstColumnObj.id}
              p_expandedCstColumnObj={m_expandedCstColumnObj}
              p_columnIndex={m_index}
              p_sortCapturesHeaderSortFieldID={s_sortCapturesHeaderSortFieldID}
              p_sortCapturesHeaderIsAscTF={s_sortCapturesHeaderIsAscTF}
              f_onClick={this.onclick_header_column}
            />
          )}
        </div>
        {(JSFUNC.is_array(p_cstSumRowColumnsArrayOfObjsOrUndefined)) &&
          <div className={"displayFlexRow borderB1ddd " + c_productStylingObj.cstSumRowBgClass} style={{height:"1.6em", width:tableWidthWithCheckboxColumnEm + "em"}}>
            {(includeCheckboxColumnTF) &&
              <div className="flex00a" style={{flexBasis:"3em", borderRight:"solid 1px #eee"}} />
            }
            {p_cstSumRowColumnsArrayOfObjsOrUndefined.map((m_cstSumRowColumnObj, m_index) =>
              <div
                key={p_expandedCstColumnsArrayOfObjs[m_index].id}
                className={"flex00a " + ((p_expandedCstColumnsArrayOfObjs[m_index].sumRowTF) ? ("displayFlexColumnVc " + c_productStylingObj.cstSumRowSumColumnBgClass + " lrMedPad " + p_expandedCstColumnsArrayOfObjs[m_index].cstCellAlignClass) : (""))}
                style={{flexBasis:p_expandedCstColumnsArrayOfObjs[m_index].width_em + "em", borderLeft:"solid 1px transparent"}}
                title={((p_expandedCstColumnsArrayOfObjs[m_index].sumRowTF) ? ("Sum of column '" + p_expandedCstColumnsArrayOfObjs[m_index].fieldDisplayName + "': " + m_cstSumRowColumnObj.sumValueMaskPlainText) : (undefined))}>
                {(p_expandedCstColumnsArrayOfObjs[m_index].sumRowTF) &&
                  <LibraryReact.NowrapEllipsis p_fontClass="fontAlmostWhite">
                    {m_cstSumRowColumnObj.sumValueMask}
                  </LibraryReact.NowrapEllipsis>
                }
              </div>
            )}
          </div>
        }
        {p_filteredCstMaskedCaptureValuesArrayOfObjs.map((m_cstMaskedCaptureValuesObj, m_index) =>
          (m_index < maxNumCapturesShown) &&
          <SearchFieldsCaptureSummaryTableSingleCapture
            key={m_cstMaskedCaptureValuesObj.id}
            p_cstMaskedCaptureValuesObj={m_cstMaskedCaptureValuesObj}
            p_expandedCstColumnsArrayOfObjs={p_expandedCstColumnsArrayOfObjs}
            p_tableWidthEm={tableWidthEm}
            p_checkedCaptureIDsArray={p_checkedCaptureIDsArray}
            p_checkboxColumnWidthEm={checkboxColumnWidthEm}
            f_onClick={this.props.f_onClickCapture}
            f_onClickCheckBox={this.props.f_onClickCheckBox}
          />
        )}
        {(numCaptures > maxNumCapturesShown) &&
          <ShowAllCapturesButtonAndMessage
            p_numFilteredCaptures={numCaptures}
            p_maxNumCapturesDrawn={maxNumCapturesShown}
            f_onClickShowAllCaptures={this.onclick_show_all_captures}
          />
        }
      </>
    );
  }
}));

class SearchFieldsCaptureSummaryTableHeaderColumn extends Component { //props: p_expandedCstColumnObj, p_columnIndex, p_sortCapturesHeaderSortFieldID, p_sortCapturesHeaderIsAscTF, f_onClick
  onclick_header_column = () => {
    const p_expandedCstColumnObj = this.props.p_expandedCstColumnObj;
    
    if(JSFUNC.is_function(this.props.f_onClick)) {
      this.props.f_onClick(p_expandedCstColumnObj.capture_field_id);
    }
  }

  render() {
    const p_expandedCstColumnObj = this.props.p_expandedCstColumnObj;
    const p_columnIndex = this.props.p_columnIndex;
    const p_sortCapturesHeaderSortFieldID = this.props.p_sortCapturesHeaderSortFieldID;
    const p_sortCapturesHeaderIsAscTF = this.props.p_sortCapturesHeaderIsAscTF;

    var isSortedTF = false;
    var isSortedAscTF = true;
    if(p_expandedCstColumnObj.capture_field_id === p_sortCapturesHeaderSortFieldID) {
      isSortedTF = true;
      isSortedAscTF = p_sortCapturesHeaderIsAscTF;
    }

    return (
      <div
        className="flex00a displayFlexRow lrPad hoverLightBlueGradient cursorPointer"
        style={{flexBasis:p_expandedCstColumnObj.width_em + "em", borderLeft:((p_columnIndex > 0) ? ("solid 1px #eee") : (undefined))}}
        title={p_expandedCstColumnObj.fieldDisplayName}
        onClick={this.onclick_header_column}>
        <div className="flex00a displayFlexColumnHcVc textCenter" style={{flexBasis:"1em"}}>
          <CEGeneralReact.HeaderSortArrow p_isSortedTF={isSortedTF} p_sortedAscTF={isSortedAscTF} />
        </div>
        <div className="flex11a displayFlexColumnVc lrPad">
          <LibraryReact.NowrapEllipsis p_fontClass="fontItalic fontWhite">
            {p_expandedCstColumnObj.fieldDisplayName}
          </LibraryReact.NowrapEllipsis>
        </div>
      </div>
    );
  }
}


const SearchFieldsCaptureSummaryTableSingleCapture = inject("CapturesMobx", "OpenCaptureMobx")(observer(
class SearchFieldsCaptureSummaryTableSingleCapture extends Component { //props: p_cstMaskedCaptureValuesObj, p_expandedCstColumnsArrayOfObjs, p_tableWidthEm, p_checkedCaptureIDsArray, p_checkboxColumnWidthEm, f_onClick(i_captureID), f_onClickCheckBox(i_cpatureID)
  onclick_capture_result = () => {
    if(JSFUNC.is_function(this.props.f_onClick)) {
      this.props.f_onClick(this.props.p_cstMaskedCaptureValuesObj.id);
    }
  }

  onclick_checkbox = () => {
    if(JSFUNC.is_function(this.props.f_onClickCheckBox)) {
      this.props.f_onClickCheckBox(this.props.p_cstMaskedCaptureValuesObj.id);
    }
  }

  render() {
    const p_cstMaskedCaptureValuesObj = this.props.p_cstMaskedCaptureValuesObj;
    const p_expandedCstColumnsArrayOfObjs = this.props.p_expandedCstColumnsArrayOfObjs;
    const p_tableWidthEm = this.props.p_tableWidthEm;
    const p_checkedCaptureIDsArray = this.props.p_checkedCaptureIDsArray;
    const p_checkboxColumnWidthEm = JSFUNC.prop_value(this.props.p_checkboxColumnWidthEm, 3);

    const o_openCaptureID = this.props.OpenCaptureMobx.o_openCaptureID;
    const c_singleCaptureIsOpenTF = this.props.OpenCaptureMobx.c_singleCaptureIsOpenTF;

    const singleCaptureIsCurrentlyOpenTF = (c_singleCaptureIsOpenTF && (p_cstMaskedCaptureValuesObj.id === o_openCaptureID));
    const canClickTF = (JSFUNC.is_function(this.props.f_onClick) && !singleCaptureIsCurrentlyOpenTF);

    const searchResultCaptureItemRow = (
      <div
        className={"displayFlexRowVc border bevelBorderColors " + ((singleCaptureIsCurrentlyOpenTF) ? ("bgPanelLightGray") : ("bgWhite hoverLighterBlueGradient")) + " " + ((canClickTF) ? ("cursorPointer") : (""))}
        style={{height:"2em", width:p_tableWidthEm + "em"}}
        onClick={((canClickTF) ? (this.onclick_capture_result) : (undefined))}>
        {p_expandedCstColumnsArrayOfObjs.map((m_expandedCstColumnObj) =>
          <div
            key={m_expandedCstColumnObj.id}
            className={"flex00a lrPad " + m_expandedCstColumnObj.cstCellAlignClass} style={{flexBasis:m_expandedCstColumnObj.width_em + "em"}}
            title={p_cstMaskedCaptureValuesObj[m_expandedCstColumnObj.capture_field_id + "MASKPT"]}>
            <LibraryReact.NowrapEllipsis>
              {p_cstMaskedCaptureValuesObj[m_expandedCstColumnObj.capture_field_id + "MASKNCL"]}
            </LibraryReact.NowrapEllipsis>
          </div>
        )}
      </div>
    );

    if(JSFUNC.is_array(p_checkedCaptureIDsArray)) {
      return(
        <div className="displayFlexRow">
          <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:p_checkboxColumnWidthEm + "em"}}>
            <LibraryReact.CheckBox
              p_u0_s1_p2_du3_ds4={((JSFUNC.in_array(p_cstMaskedCaptureValuesObj.id, p_checkedCaptureIDsArray)) ? (1) : (0))}
              p_sizeEm={1.3}
              f_onClick={this.onclick_checkbox}
            />
          </div>
          <div className="flex11a">
            {searchResultCaptureItemRow}
          </div>
        </div>
      );
    }

    return(searchResultCaptureItemRow);
  }
}));






//Capture Summary Table/Gantt Chart/Progress Chart
export const CapturesTab = inject("CaptureExecMobx")(observer(
class CapturesTab extends Component { //props: p_capturesViewFlag
  render() {
    const p_capturesViewFlag = this.props.p_capturesViewFlag; //"captureTable", "stage", "priority", "ganttChart", "progressChart"

    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;

    const controlsIncludeMassEditDeleteDotsTF = (p_capturesViewFlag === "captureTable");

    return(
      <div className={"flex11a displayFlexColumn " + c_productStylingObj.capturesTabEmptyBgClass}>
        <CapturesTabControls p_includeMassEditDeleteDotsTF={controlsIncludeMassEditDeleteDotsTF} />
        <CapturesView p_capturesViewFlag={p_capturesViewFlag} />
        <CreateNewCaptureFloatingBox />
      </div>
    );
  }
}));


const CapturesView = inject("CaptureExecMobx", "CapturesMobx")(observer(
class CapturesView extends Component { //props: p_capturesViewFlag
  render() {
    const p_capturesViewFlag = this.props.p_capturesViewFlag;

    const o_loadingThroughPhase1CompleteTF = this.props.CaptureExecMobx.o_loadingThroughPhase1CompleteTF;
    const c_userQuickAccessMasterPresetIDsArray = this.props.CapturesMobx.c_userQuickAccessMasterPresetIDsArray;
    const c_selectedQuickAccessExpandedCaptureTableMasterPresetObj = this.props.CapturesMobx.c_selectedQuickAccessExpandedCaptureTableMasterPresetObj;
    const c_selectedQuickAccessExpandedCstColumnPresetObj = this.props.CapturesMobx.c_selectedQuickAccessExpandedCstColumnPresetObj;
    const c_selectedQuickAccessExpandedFilterPresetObj = this.props.CapturesMobx.c_selectedQuickAccessExpandedFilterPresetObj;
    const c_expandedCstColumnsArrayOfObjs = this.props.CapturesMobx.c_expandedCstColumnsArrayOfObjs;
    const c_captureTableCurrentlyProcessingCapturesTF = this.props.CapturesMobx.c_captureTableCurrentlyProcessingCapturesTF;

    if(!o_loadingThroughPhase1CompleteTF) {
      return(
        <CEGeneralReact.EmptyScreenGray>
          <div>{"Loading CaptureExec..."}</div>
          <div>
            <CEGeneralReact.LoadingAnimation
              p_frameDelay={0}
              p_class=""
              p_styleObj={{}}
            />
          </div>
        </CEGeneralReact.EmptyScreenGray>
      );
    }

    //user has 0 View Buttons added to their Quick Access bar
    if(c_userQuickAccessMasterPresetIDsArray.length === 0) {
      return(
        <CEGeneralReact.EmptyScreenGray>
          <div className="microBottomMargin">{"You currently do not have any Capture Table View Buttons added to your Quick Access bar to view filtered lists of Captures."}</div>
          <div>{"In the Preset Editor tool (gray funnel button at the top), you can click any of the 'Add to Quick Access' buttons next to the View Buttons to add them to your bar."}</div>
        </CEGeneralReact.EmptyScreenGray>
      );
    }

    //selected master preset does not exist
    if(!c_selectedQuickAccessExpandedCaptureTableMasterPresetObj.existsTF) {
      return(
        <CEGeneralReact.EmptyScreenGray>
          <div className="microBottomMargin">{"Selected Capture Table View Button does not exist."}</div>
          <div className="microBottomMargin">{"Select a different preset, or create a new one using the Preset Editor tool above."}</div>
          <div>{"In the Preset Editor tool (gray funnel button at the top), you can remove this invalid preset from your quick access bar to stop seeing this message."}</div>
        </CEGeneralReact.EmptyScreenGray>
      );
    }

    //if cstColumns or filter presets for the master do not exist, show a fullscreen error (ok to not have a sort preset defined)
    if(!c_selectedQuickAccessExpandedCstColumnPresetObj.existsTF || !c_selectedQuickAccessExpandedFilterPresetObj.existsTF) {
      const presetObjsArray = [c_selectedQuickAccessExpandedCstColumnPresetObj, c_selectedQuickAccessExpandedFilterPresetObj];
      const labelsArray = ["Table Columns", "Capture Filter"];
      return(
        <CEGeneralReact.EmptyScreenGray>
          <div className="medBottomMargin">
            <div className="microBottomMargin">
              {"Capture Table View Button '"}<font className="fontBold">{c_selectedQuickAccessExpandedCaptureTableMasterPresetObj.name}</font>{"' has preset components that are invalid."}
            </div>
            <div>
              {"Open the Preset Editor tool above to fix the following issues:"}
            </div>
          </div>
          {presetObjsArray.map((m_presetObj, m_index) =>
            (!m_presetObj.existsTF) &&
            <div className="medBottomMargin">
              <font className="fontBold">
                {labelsArray[m_index] + " Preset was removed from the system and needs a replacement."}
              </font>
            </div>
          )}
        </CEGeneralReact.EmptyScreenGray>
      );
    }

    //if a mass edit is running, don't draw the capture summary table to avoid all the time rendering after each change/delete
    if(c_captureTableCurrentlyProcessingCapturesTF) {
      return(
        <CEGeneralReact.EmptyScreenGray>
          <div>{"Processing Captures..."}</div>
          <CEGeneralReact.LoadingAnimation />
        </CEGeneralReact.EmptyScreenGray>
      );
    }

    if(p_capturesViewFlag === "captureTable") {
      if(c_expandedCstColumnsArrayOfObjs.length === 0) { //no columns in the cstColumns preset part of the View Button is an error specific to the captures table
        return(
          <CEGeneralReact.EmptyScreenGray>
            <div>{"The selected View Button"}</div>
            <div className="microTopMargin fontBold">{"'" + c_selectedQuickAccessExpandedCaptureTableMasterPresetObj.name + "'"}</div>
            <div className="microTopMargin">{((c_selectedQuickAccessExpandedCstColumnPresetObj.id > 0) ? ("is using the Columns Preset '" + c_selectedQuickAccessExpandedCstColumnPresetObj.name + "', which contains 0 columns.") : ("does not have a Column Preset assigned, leaving 0 columns for this table."))}</div>
            <div className="medTopMargin">{"Select another Capture Table filter, or use the Edit Filters interface to create one."}</div>
          </CEGeneralReact.EmptyScreenGray>
        );
      }

      return(<CaptureTable />);
    }
    
    if((p_capturesViewFlag === "stage") || (p_capturesViewFlag === "priority")) {
      return(<StageOrPriorityView p_capturesViewFlag={p_capturesViewFlag} />);
    }

    if((p_capturesViewFlag === "ganttChart") || (p_capturesViewFlag === "progressChart")) {
      const ganttTrueProgressFalse = (p_capturesViewFlag !== "progressChart");
      return(<TimelineChart p_ganttTrueProgressFalse={ganttTrueProgressFalse} />);
    }

    if(p_capturesViewFlag === "idiqsTaskOrders") {
      return(<IDIQTaskOrdersView />);
    }

    return(
      <CEGeneralReact.EmptyScreenGray>
        {"Unknown View Flag '" + p_capturesViewFlag + "'"}
      </CEGeneralReact.EmptyScreenGray>
    );
  }
}));





//======================================================================================================================================
//======================================================================================================================================
//Main Controls (View Buttons)
//======================================================================================================================================
//======================================================================================================================================

const CapturesTabControls = inject("CaptureExecMobx", "CapturesMobx", "UserMobx")(observer(
class CapturesTabControls extends Component { //props: p_includeMassEditDeleteDotsTF
  render() {
    const p_includeMassEditDeleteDotsTF = this.props.p_includeMassEditDeleteDotsTF;

    const c_isMobileOrTabletTF = this.props.CaptureExecMobx.c_isMobileOrTabletTF;
    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const c_selectedLeftNavIsCaptureTableViewTF = this.props.CaptureExecMobx.c_selectedLeftNavIsCaptureTableViewTF;
    const c_selectedLeftNavIsStageViewTF = this.props.CaptureExecMobx.c_selectedLeftNavIsStageViewTF;
    const c_selectedLeftNavIsGanttChartViewTF = this.props.CaptureExecMobx.c_selectedLeftNavIsGanttChartViewTF;
    const c_selectedLeftNavIsProgressChartViewTF = this.props.CaptureExecMobx.c_selectedLeftNavIsProgressChartViewTF;
    const c_selectedLeftNavIsIDIQsTaskOrdersViewTF = this.props.CaptureExecMobx.c_selectedLeftNavIsIDIQsTaskOrdersViewTF;
    const c_userQuickAccessCaptureTablePresetsArrayOfObjs = this.props.CapturesMobx.c_userQuickAccessCaptureTablePresetsArrayOfObjs;
    const c_selectedQuickAccessExpandedCaptureTableMasterPresetObj = this.props.CapturesMobx.c_selectedQuickAccessExpandedCaptureTableMasterPresetObj;
    const c_expandedCstColumnsArrayOfObjs = this.props.CapturesMobx.c_expandedCstColumnsArrayOfObjs;
    const c_cstSortedFilteredMaskedCaptureValuesArrayOfObjs = this.props.CapturesMobx.c_cstSortedFilteredMaskedCaptureValuesArrayOfObjs;
    const c_cstSumRowColumnsArrayOfObjsOrUndefined = this.props.CapturesMobx.c_cstSumRowColumnsArrayOfObjsOrUndefined;
    const c_numFilteredCaptures = this.props.CapturesMobx.c_numFilteredCaptures;
    const c_userCanSwitchToCSTCellEditModeTF = this.props.UserMobx.c_userCanSwitchToCSTCellEditModeTF;
    
    var inlineEditHoverText = "Turning on 'Inline Edit' will enable direct edit of Capture field values by clicking on individual cells.\nEach Capture can still be opened using the red icon on the left.";

    var rowSizeHoverText = "Use these sizes to adjust the row height of the ";
    if(c_selectedLeftNavIsCaptureTableViewTF) { rowSizeHoverText += "Capture Table"; }
    else if(c_selectedLeftNavIsStageViewTF) { rowSizeHoverText += "Stage View Capture boxes"; }
    else if(c_selectedLeftNavIsGanttChartViewTF) { rowSizeHoverText += "Gantt Chart"; }
    else if(c_selectedLeftNavIsProgressChartViewTF) { rowSizeHoverText += "Progress Chart"; }

    var numCapturesWidthEm = 8;
    var numCapturesFontSizeClass = "font15";
    var capturesStringFontSizeClass = "font12";
    if(c_isMobileOrTabletTF) {
      numCapturesWidthEm = 5;
      numCapturesFontSizeClass = "font11";
      capturesStringFontSizeClass = "font09";
    }
    const captureCapturesString = JSFUNC.plural(c_numFilteredCaptures, "Capture", "Captures");
    const inMasterButtonNameLabel = "in '" + c_selectedQuickAccessExpandedCaptureTableMasterPresetObj.name + "'";

    return(
      <div className="flex00a displayFlexRow bgWhite" style={{height:"5.3em", borderBottom:"solid 1px #ccc"}}>
        <CreateNewCaptureButton />
        {(c_productStylingObj.capturesTabMasterPresetEditorButtonTF) &&
          <div className="flex00a displayFlexRowVc lrMedPad">
            <MasterPresetsEditorButton
              p_selectedPresetType="master"
              p_selectedPresetID={c_selectedQuickAccessExpandedCaptureTableMasterPresetObj.id}
            />
          </div>
        }
        <div className="flex11a displayFlexRowVc xyScroll">
          {c_userQuickAccessCaptureTablePresetsArrayOfObjs.map((m_captureTablePresetObj) =>
            <QuickAccessMasterPresetButton
              key={m_captureTablePresetObj.id + JSFUNC.key_rand()}
              p_captureTablePresetObj={m_captureTablePresetObj}
            />
          )}
        </div>
        {(c_selectedLeftNavIsCaptureTableViewTF && c_userCanSwitchToCSTCellEditModeTF) &&
          <div className="flex00a displayFlexColumn borderL1ddd lrPad" title={inlineEditHoverText}>
            <div className="flex00a textCenter" style={{marginTop:"0.8em"}}>
              <font className="font09 fontItalic fontTextLight">
                {"Inline Edit"}
              </font>
            </div>
          <div className="flex00a displayFlexColumnHcVc" style={{marginTop:"0.7em"}}>
            <CaptureTableEditCellsModeSwitch />
          </div>
          </div>
        }
        <div className="flex00a displayFlexColumn borderL1ddd lrPad" title={(c_selectedLeftNavIsIDIQsTaskOrdersViewTF) ? ("") : (rowSizeHoverText)}>
          {(c_selectedLeftNavIsIDIQsTaskOrdersViewTF) ? (
            <div style={{width:"4.5em", height:"4em"}} />
          ) : (
            <>
              <div className="flex00a textCenter" style={{marginTop:"0.8em"}}>
                <font className="font09 fontItalic fontTextLight">
                  {"Row Size"}
                </font>
              </div>
              <div className="flex00a displayFlexColumnHcVc" style={{marginTop:"0.4em"}}>
                <CapturesTableOrChartRowHeightControlSelect />
              </div>
            </>
          )}
        </div>
        <div
          className="flex00a displayFlexColumnHcVc borderL1ddd lrPad textCenter"
          style={{flexBasis:numCapturesWidthEm + "em"}}
          title={c_numFilteredCaptures + " " + captureCapturesString + " " + inMasterButtonNameLabel}>
          <div className="flex00a">
            <font className={numCapturesFontSizeClass + " fontBold fontTextLighter"}>
              {c_numFilteredCaptures}
            </font>
          </div>
          <div className="flex00a">
            <font className={capturesStringFontSizeClass + " fontItalic fontTextLighter"}>
              {captureCapturesString}
            </font>
          </div>
          {(!c_isMobileOrTabletTF) &&
            <>
              <div className="microTopMargin" />
              <LibraryReact.NowrapEllipsis p_fontClass="font09 fontItalic fontTextLighter">{inMasterButtonNameLabel}</LibraryReact.NowrapEllipsis>
            </>
          }
        </div>
        <div className="flex00a displayFlexColumnHcVc borderL1ddd" style={{flexBasis:"2em"}}>
          {(p_includeMassEditDeleteDotsTF) &&
            <CaptureTableExportCsvMassEditMassDeleteVerticalDotsMenu
              p_sortedFilteredMaskedCaptureValuesArrayOfObjs={c_cstSortedFilteredMaskedCaptureValuesArrayOfObjs}
              p_cstSumRowColumnsArrayOfObjsOrUndefined={c_cstSumRowColumnsArrayOfObjsOrUndefined}
              p_expandedCstColumnsArrayOfObjs={c_expandedCstColumnsArrayOfObjs}
              p_filterName={"'" + c_selectedQuickAccessExpandedCaptureTableMasterPresetObj.name + "'"}
              p_exportToCsvOptionTF={true}
            />
          }
        </div>
      </div>
    );
  }
}));

const CreateNewCaptureButton = inject("CaptureExecMobx", "CapturesMobx", "UserMobx")(observer(
class CreateNewCaptureButton extends Component {
  onclick_create_new_capture = () => {
    this.props.CapturesMobx.a_set_create_new_capture_is_open_tf(true);
  }

  render() {
    const c_isMobileOrTabletTF = this.props.CaptureExecMobx.c_isMobileOrTabletTF;
    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const c_userCanCreateNewCapturesTF = this.props.UserMobx.c_userCanCreateNewCapturesTF;

    if(!c_userCanCreateNewCapturesTF) {
      return(null);
    }

    const captureSizeEm = ((c_isMobileOrTabletTF) ? (2.8) : (3));
    const sizeEm = ((c_isMobileOrTabletTF) ? (3.5) : (3.8));

    return(
      <div className="flex00a displayFlexColumnHcVc borderR1ddd" style={{flexBasis:(sizeEm + ((c_isMobileOrTabletTF) ? (0.8) : (1.6))) + "em"}}>
        {(c_userCanCreateNewCapturesTF) &&
          <div
            className={"displayFlexColumnHcVc " + c_productStylingObj.capturesTabCreateNewCaptureButtonBgClass + " cursorPointer"}
            style={{width:sizeEm + "em", height:sizeEm + "em"}}
            title={"Create a new capture"}
            onClick={this.onclick_create_new_capture}>
            <CEIconsReact.SvgCapture
              p_sizeEm={captureSizeEm}
              p_color="eeeeee"
              p_plusTF={true}
            />
          </div>
        }
      </div>
    );
  }
}));


export const MasterPresetsEditorButton = inject("CapturesMobx")(observer(
class MasterPresetsEditorButton extends Component { //props: p_selectedPresetType, p_selectedPresetID
  onclick_editor_button = () => {
    const p_selectedPresetType = this.props.p_selectedPresetType;
    const p_selectedPresetID = this.props.p_selectedPresetID;
    
    this.props.CapturesMobx.a_set_capture_table_preset_editor_open_tf(true);

    if(JSFUNC.string_is_filled_out_tf(p_selectedPresetType) && (JSFUNC.select_int_is_filled_out_tf(p_selectedPresetID) || (JSFUNC.is_number_not_nan(p_selectedPresetID) && (p_selectedPresetID <= -100)))) {
      this.props.CapturesMobx.a_set_preset_editor_open_preset_type_and_id(p_selectedPresetType, p_selectedPresetID);
    }
  }

  render() {
    const p_selectedPresetType = this.props.p_selectedPresetType;
    const p_selectedPresetID = this.props.p_selectedPresetID;

    return(
      <ButtonCreateEditFilters
        p_sizeEm={3}
        p_title="Create/Edit Capture Table Presets (Columns/Filters/Sorts)"
        f_onClick={this.onclick_editor_button}
      />
    );
  }
}));


const QuickAccessMasterPresetButton = inject("CaptureExecMobx", "CapturesMobx")(observer(
class QuickAccessMasterPresetButton extends Component { //props: p_captureTablePresetObj
  onclick_preset = () => {
    this.props.CapturesMobx.a_set_captures_tab_selected_view_button(this.props.p_captureTablePresetObj.id);
  }

  render() {
    const p_captureTablePresetObj = this.props.p_captureTablePresetObj;

    const c_isMobileOrTabletTF = this.props.CaptureExecMobx.c_isMobileOrTabletTF;
    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const c_selectedQuickAccessExpandedCaptureTableMasterPresetObj = this.props.CapturesMobx.c_selectedQuickAccessExpandedCaptureTableMasterPresetObj;

    const isSelectedTF = (c_selectedQuickAccessExpandedCaptureTableMasterPresetObj.id === p_captureTablePresetObj.id);

    var buttonWidth = "9.5em";
    var buttonHeight = "3.9em";
    var nameMaxHeight = "3.5em"
    if(c_isMobileOrTabletTF) {
      buttonWidth = "7em";
      buttonHeight = "3.5em";
      nameMaxHeight = "2.5em"
    }

    var masterPresetButtonTitle = p_captureTablePresetObj.name;
    if(JSFUNC.string_is_filled_out_tf(p_captureTablePresetObj.description)) {
      masterPresetButtonTitle += "\n\n" + p_captureTablePresetObj.description;
    }

    return(
      <div
        className={"flex00a displayFlexRowVc lrMedPad textCenter " + ((isSelectedTF) ? (c_productStylingObj.capturesTabMasterButtonSelectedBgClass) : (c_productStylingObj.capturesTabMasterButtonUnselectedBgClass + " cursorPointer"))}
        style={{flexBasis:buttonWidth, height:buttonHeight, marginRight:"0.4em"}}
        title={masterPresetButtonTitle}
        onClick={((isSelectedTF) ? (undefined) : (this.onclick_preset))}>
        <LibraryReact.MaxHeightWrap p_maxHeight={nameMaxHeight} p_fontClass={((isSelectedTF) ? (c_productStylingObj.capturesTabMasterButtonSelectedFontClass) : (c_productStylingObj.capturesTabMasterButtonUnselectedFontClass))}>
          {p_captureTablePresetObj.name}
        </LibraryReact.MaxHeightWrap>
      </div>
    );
  }
}));


const CapturesTableOrChartRowHeightControlSelect = inject("CaptureExecMobx", "CapturesMobx", "UserMobx")(observer(
class CapturesTableOrChartRowHeightControlSelect extends Component {
  onselect_table_or_chart_row_size = (i_selectedCaptureTableRowHeightEmDecimal) => {
    const c_selectedLeftNavIsStageViewTF = this.props.CaptureExecMobx.c_selectedLeftNavIsStageViewTF;
    const c_selectedLeftNavIsPriorityViewTF = this.props.CaptureExecMobx.c_selectedLeftNavIsPriorityViewTF;
    const c_selectedLeftNavIsGanttChartViewTF = this.props.CaptureExecMobx.c_selectedLeftNavIsGanttChartViewTF;
    const c_selectedLeftNavIsProgressChartViewTF = this.props.CaptureExecMobx.c_selectedLeftNavIsProgressChartViewTF;

    var rowHeightFieldDbName = "cst_row_height_em";
    var rowHeightFieldIdsb = "d";
    if(c_selectedLeftNavIsStageViewTF || c_selectedLeftNavIsPriorityViewTF) {
      rowHeightFieldDbName = "stage_view_box_size";
      rowHeightFieldIdsb = "i";
    }
    else if(c_selectedLeftNavIsGanttChartViewTF) {
      rowHeightFieldDbName = "capture_chart_gantt_size";
      rowHeightFieldIdsb = "i";
    }
    else if(c_selectedLeftNavIsProgressChartViewTF) {
      rowHeightFieldDbName = "capture_chart_progress_size";
      rowHeightFieldIdsb = "i";
    }

    this.props.UserMobx.a_update_logged_in_user_per_email_field(rowHeightFieldDbName, i_selectedCaptureTableRowHeightEmDecimal, rowHeightFieldIdsb);
  }

  render() {
    const c_selectedLeftNavIsStageViewTF = this.props.CaptureExecMobx.c_selectedLeftNavIsStageViewTF;
    const c_selectedLeftNavIsPriorityViewTF = this.props.CaptureExecMobx.c_selectedLeftNavIsPriorityViewTF;
    const c_selectedLeftNavIsGanttChartViewTF = this.props.CaptureExecMobx.c_selectedLeftNavIsGanttChartViewTF;
    const c_selectedLeftNavIsProgressChartViewTF = this.props.CaptureExecMobx.c_selectedLeftNavIsProgressChartViewTF;
    const c_cstRowHeightFieldTypeObj = this.props.CapturesMobx.c_cstRowHeightFieldTypeObj;
    const c_stageViewBoxSizeFieldTypeObj = this.props.CapturesMobx.c_stageViewBoxSizeFieldTypeObj;
    const c_ganttChartRowHeightFieldTypeObj = this.props.CapturesMobx.c_ganttChartRowHeightFieldTypeObj;
    const c_progressChartRowHeightFieldTypeObj = this.props.CapturesMobx.c_progressChartRowHeightFieldTypeObj;
    const c_userStageViewBoxSize = this.props.UserMobx.c_userStageViewBoxSize;

    var capturesTableOrChartRowHeightFieldTypeObj = c_cstRowHeightFieldTypeObj;
    var capturesTableOrChartUserRowHeightEm = this.props.UserMobx.c_userCaptureTableRowHeightEm;
    if(c_selectedLeftNavIsStageViewTF || c_selectedLeftNavIsPriorityViewTF) {
      capturesTableOrChartRowHeightFieldTypeObj = c_stageViewBoxSizeFieldTypeObj;
      capturesTableOrChartUserRowHeightEm = c_userStageViewBoxSize;
    }
    else if(c_selectedLeftNavIsGanttChartViewTF) {
      capturesTableOrChartRowHeightFieldTypeObj = c_ganttChartRowHeightFieldTypeObj;
      capturesTableOrChartUserRowHeightEm = this.props.UserMobx.c_combinedUserObj.capture_chart_gantt_size;
    }
    else if(c_selectedLeftNavIsProgressChartViewTF) {
      capturesTableOrChartRowHeightFieldTypeObj = c_progressChartRowHeightFieldTypeObj;
      capturesTableOrChartUserRowHeightEm = this.props.UserMobx.c_combinedUserObj.capture_chart_progress_size;
    }

    return(
      <div style={{width:"4.5em"}}>
        <CEGeneralReact.GenericInputOrSelectFromInputType
          p_fieldTypeObj={capturesTableOrChartRowHeightFieldTypeObj}
          p_valueRaw={capturesTableOrChartUserRowHeightEm}
          p_selectDisplayMaskOverwrite={JSFUNC.num2str(capturesTableOrChartUserRowHeightEm)}
          f_onChangeOrOnSelect={this.onselect_table_or_chart_row_size}
        />
      </div>
    );
  }
}));


const CaptureTableEditCellsModeSwitch = inject("UserMobx")(observer(
class CaptureTableEditCellsModeSwitch extends Component {
  onswitch_cst_edit_cells_mode = () => {
    const c_userCSTEditCellsModeTF = this.props.UserMobx.c_userCSTEditCellsModeTF;
    const updatedCSTEditCellsMode01 = ((c_userCSTEditCellsModeTF) ? (0) : (1));
    this.props.UserMobx.a_update_logged_in_user_per_email_field("cst_edit_cells_mode_01", updatedCSTEditCellsMode01, "i");
  }

  render() {
    const c_userCSTEditCellsModeTF = this.props.UserMobx.c_userCSTEditCellsModeTF;

    return(
      <CEGeneralReact.SwitchWithTextAndConfirmBox
        p_isOnTF={c_userCSTEditCellsModeTF}
        p_sizeEm={2.8}
        p_onColor="996066"
        f_onSwitch={this.onswitch_cst_edit_cells_mode}
      />
    );
  }
}));


const CaptureTableExportCsvMassEditMassDeleteVerticalDotsMenu = inject("CaptureExecMobx", "CapturesMobx", "UserMobx")(observer(
class CaptureTableExportCsvMassEditMassDeleteVerticalDotsMenu extends Component { //props: p_sortedFilteredMaskedCaptureValuesArrayOfObjs, p_cstSumRowColumnsArrayOfObjsOrUndefined, p_expandedCstColumnsArrayOfObjs, p_filterName, p_exportToCsvOptionTF
  constructor(props) {
    super(props);
    this.state = {
      s_exportToCsvFloatingBoxIsOpenTF: false,
      s_massEditFloatingBoxIsOpenTF: false
    }
  }

  onclick_open_export_to_csv_floating_box = () => {
    this.setState({s_exportToCsvFloatingBoxIsOpenTF:true});
    this.props.CapturesMobx.a_set_capture_table_csv_is_generating_flag("init");
  }

  onclick_close_export_to_csv_floating_box = () => {
    this.setState({s_exportToCsvFloatingBoxIsOpenTF:false});
    this.props.CapturesMobx.a_set_capture_table_csv_is_generating_flag("init");
  }

  onclick_open_mass_edit_floating_box = () => {
    this.setState({s_massEditFloatingBoxIsOpenTF:true});
  }

  onclick_close_mass_edit_floating_box = () => {
    this.setState({s_massEditFloatingBoxIsOpenTF:false});
  }

  onclick_delete_all_captures_in_capture_table = () => {
    const p_sortedFilteredMaskedCaptureValuesArrayOfObjs = this.props.p_sortedFilteredMaskedCaptureValuesArrayOfObjs;
    const p_filterName = this.props.p_filterName;
    const floatingBoxTitle = "Deleting Captures in " + p_filterName;
    this.props.CapturesMobx.a_delete_all_captures_in_capture_table(p_sortedFilteredMaskedCaptureValuesArrayOfObjs, floatingBoxTitle);
  }

  render() {
    const s_exportToCsvFloatingBoxIsOpenTF = this.state.s_exportToCsvFloatingBoxIsOpenTF;
    const s_massEditFloatingBoxIsOpenTF = this.state.s_massEditFloatingBoxIsOpenTF;

    const p_sortedFilteredMaskedCaptureValuesArrayOfObjs = this.props.p_sortedFilteredMaskedCaptureValuesArrayOfObjs;
    const p_cstSumRowColumnsArrayOfObjsOrUndefined = this.props.p_cstSumRowColumnsArrayOfObjsOrUndefined;
    const p_expandedCstColumnsArrayOfObjs = this.props.p_expandedCstColumnsArrayOfObjs;
    const p_filterName = this.props.p_filterName;
    const p_exportToCsvOptionTF = this.props.p_exportToCsvOptionTF;

    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const c_userCanMassEditAndMassDeleteCaptureTableTF = this.props.UserMobx.c_userCanMassEditAndMassDeleteCaptureTableTF;

    //if user can't export to CSV or mass edit/delete, don't draw the vertical dots menu
    if(!p_exportToCsvOptionTF && !c_userCanMassEditAndMassDeleteCaptureTableTF) {
      return(null);
    }

    //if p_sortedFilteredMaskedCaptureValuesArrayOfObjs is not an array, also return null
    if(!JSFUNC.is_array(p_sortedFilteredMaskedCaptureValuesArrayOfObjs)) {
      return(null);
    }

    const numCapturesInTable = p_sortedFilteredMaskedCaptureValuesArrayOfObjs.length;

    //set up Capture Table vertical dots menu
    var captureTableMenuItemsArrayOfObjs = [];

    //export to .csv
    if(p_exportToCsvOptionTF) {
      captureTableMenuItemsArrayOfObjs.push({
        displayName: "Export Capture Table to .csv",
        functionOnClickMenuItem: this.onclick_open_export_to_csv_floating_box
      });
    }

    //Capture Table operations only available to Admins (mass edit, mass delete)
    if(c_userCanMassEditAndMassDeleteCaptureTableTF) {
      //mass edit
      captureTableMenuItemsArrayOfObjs.push({
        displayName: "Mass Edit a Field",
        functionOnClickMenuItem: this.onclick_open_mass_edit_floating_box
      });

      //delete all
      if(c_productStylingObj.capturesTabCstCanDeleteAllCapturesInTableTF) { //not available in SAM Gov Tracker
        const captureCapturesString = JSFUNC.plural(numCapturesInTable, "Capture", "Captures");

        var deleteAllCapturesConfirmType = "confirmDelete";
        var deleteAllCapturesConfirmMessage = "Are you sure you want to delete the " + numCapturesInTable + " " + captureCapturesString + " shown in the selected table (" + p_filterName + ")?";
        deleteAllCapturesConfirmMessage += "\n\nThis action will also remove all data and documents associated with each deleted capture."
        if(numCapturesInTable === 0) {
          deleteAllCapturesConfirmType = "cancel";
          deleteAllCapturesConfirmMessage = "No Captures to delete in the selected table (" + p_filterName + ")";
        }

        captureTableMenuItemsArrayOfObjs.push({
          displayName: "Delete All Captures in Table",
          confirmType: deleteAllCapturesConfirmType,
          confirmTitle: "Delete All Captures in Table",
          confirmButton1Name: "Delete " + numCapturesInTable + " " + captureCapturesString,
          confirmMessage: deleteAllCapturesConfirmMessage,
          functionOnClickConfirmButton: this.onclick_delete_all_captures_in_capture_table
        });
      }
    }

    return(
      <>
        <CEGeneralReact.VerticalDotsMenu
          p_menuItemsArrayOfObjs={captureTableMenuItemsArrayOfObjs}
        />
        {(s_exportToCsvFloatingBoxIsOpenTF) &&
          <CaptureTableExportToCsvFloatingBox
            p_sortedFilteredMaskedCaptureValuesArrayOfObjs={p_sortedFilteredMaskedCaptureValuesArrayOfObjs}
            p_cstSumRowColumnsArrayOfObjsOrUndefined={p_cstSumRowColumnsArrayOfObjsOrUndefined}
            p_expandedCstColumnsArrayOfObjs={p_expandedCstColumnsArrayOfObjs}
            p_filterName={p_filterName}
            f_onClickClose={this.onclick_close_export_to_csv_floating_box}
          />
        }
        {(s_massEditFloatingBoxIsOpenTF) &&
          <CaptureTableMassEditFloatingBox
            p_sortedFilteredMaskedCaptureValuesArrayOfObjs={p_sortedFilteredMaskedCaptureValuesArrayOfObjs}
            p_filterName={p_filterName}
            f_onClickClose={this.onclick_close_mass_edit_floating_box}
          />
        }
      </>
    );
  }
}));

const CaptureTableExportToCsvFloatingBox = inject("CapturesMobx")(observer(
class CaptureTableExportToCsvFloatingBox extends Component { //props: p_sortedFilteredMaskedCaptureValuesArrayOfObjs, p_cstSumRowColumnsArrayOfObjsOrUndefined, p_expandedCstColumnsArrayOfObjs, p_filterName, f_onClickClose
  constructor(props) {
    super(props);
    this.state = {
      s_exportToCsvFetchFullTextareasTF: false
    }
  }

  onswitch_fetch_full_textareas_tf = () => {
    this.setState({s_exportToCsvFetchFullTextareasTF:!this.state.s_exportToCsvFetchFullTextareasTF});
  }

  onclick_generate_download_capture_table_report_csv = () => {
    const s_exportToCsvFetchFullTextareasTF = this.state.s_exportToCsvFetchFullTextareasTF;

    const p_sortedFilteredMaskedCaptureValuesArrayOfObjs = this.props.p_sortedFilteredMaskedCaptureValuesArrayOfObjs;
    const p_cstSumRowColumnsArrayOfObjsOrUndefined = this.props.p_cstSumRowColumnsArrayOfObjsOrUndefined;
    const p_expandedCstColumnsArrayOfObjs = this.props.p_expandedCstColumnsArrayOfObjs;
    const p_filterName = this.props.p_filterName;

    this.props.CapturesMobx.a_generate_and_download_capture_table_report_csv(p_sortedFilteredMaskedCaptureValuesArrayOfObjs, p_cstSumRowColumnsArrayOfObjsOrUndefined, p_expandedCstColumnsArrayOfObjs, p_filterName, s_exportToCsvFetchFullTextareasTF);
  }

  render() {
    const s_exportToCsvFetchFullTextareasTF = this.state.s_exportToCsvFetchFullTextareasTF;

    const p_sortedFilteredMaskedCaptureValuesArrayOfObjs = this.props.p_sortedFilteredMaskedCaptureValuesArrayOfObjs;
    const p_cstSumRowColumnsArrayOfObjsOrUndefined = this.props.p_cstSumRowColumnsArrayOfObjsOrUndefined;
    const p_expandedCstColumnsArrayOfObjs = this.props.p_expandedCstColumnsArrayOfObjs;
    const p_filterName = this.props.p_filterName;

    const o_captureTableCsvIsGeneratingFlag = this.props.CapturesMobx.o_captureTableCsvIsGeneratingFlag;

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="confirmBox"
        p_title="Export Capture Table to .csv"
        f_onClickCancel={this.props.f_onClickClose}>
        <div className="flex11a displayFlexColumn smallFullPad">
          <div className="">
            <font className="">
              {"Clicking 'Export to .csv' will create and offer for download a .csv file of all data cells in the current Capture Table '" + p_filterName + "'."}
            </font>
          </div>
          <div className="medTopMargin">
            <font className="">
              {"The .csv file can be opened using spreadsheet software external to CaptureExec."}
            </font>
          </div>
          <div className="bigTopMargin hugeBottomMargin lrMargin borderT1bbb borderB1bbb tbMedPad">
            <CEGeneralReact.SwitchWithTextAndConfirmBox
              p_isOnTF={s_exportToCsvFetchFullTextareasTF}
              p_onText="Incorporate the full text from large text data columns (Description of Work, Notepad, etc)"
              p_offText="[default] Keep large text data columns (Description of Work, Notepad, etc) truncated at 100 characters"
              p_tabIndex={1}
              p_title="Switch this setting to select if large text data columns will fetch the full length text, or only use the first 100 characters when writing the .csv file"
              f_onSwitch={this.onswitch_fetch_full_textareas_tf}
            />
          </div>
          <div className="flex00a displayFlexColumn hugeTopMargin" style={{flexBasis:"3em"}}>
            {(o_captureTableCsvIsGeneratingFlag === "init") && 
              <div className="flex11a displayFlexRowHcVc">
                <div className="flex00a lrMedMargin">
                  <CEGeneralReact.CEButton
                    p_type="blue"
                    p_text="Export to .csv"
                    p_tabIndex={2}
                    f_onClick={this.onclick_generate_download_capture_table_report_csv}
                  />
                </div>
                <div className="flex00a lrMedMargin">
                  <CEGeneralReact.CEButton
                    p_type="gray"
                    p_text="Cancel"
                    p_tabIndex={3}
                    f_onClick={this.props.f_onClickClose}
                  />
                </div>
              </div>
            }
            {(o_captureTableCsvIsGeneratingFlag === "generating") && 
              <div className="flex11a displayFlexColumnHc textCenter">
                <LibraryReact.NowrapEllipsis p_fontClass="fontItalic fontTextLight">
                  {"Generating .csv file of Capture Table '" + p_filterName + "'"}
                </LibraryReact.NowrapEllipsis>
                <div className="flex00a displayFlexColumnHcVc">
                  <CEGeneralReact.LoadingAnimation />
                </div>
              </div>
            }
            {(o_captureTableCsvIsGeneratingFlag === "success") && 
              <div className="flex11a displayFlexRowHcVc">
                <div className="flex00a lrMedMargin">
                  <CEGeneralReact.CEButton
                    p_type="gray"
                    p_text="Close"
                    p_tabIndex={3}
                    f_onClick={this.props.f_onClickClose}
                  />
                </div>
              </div>
            }
          </div>
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));

const CaptureTableMassEditFloatingBox = inject("CapturesMobx", "DatabaseMobx")(observer(
class CaptureTableMassEditFloatingBox extends Component { //props: p_sortedFilteredMaskedCaptureValuesArrayOfObjs, p_filterName, f_onClickClose
  constructor(props) {
    super(props);
    this.state = {
      s_selectedCaptureFieldID: undefined,
      s_selectedOrEnteredCaptureFieldValueRaw: undefined,
      s_sendMassEditNotificationsTF: false
    }
  }

  onselect_capture_field = (i_fieldID) => {
    const c_fieldMapOfArchiveDate = this.props.DatabaseMobx.c_fieldMapOfArchiveDate;

    var initialValueAfterFieldSelection = undefined;
    if(i_fieldID === c_fieldMapOfArchiveDate.get("id")) { //archive date field selected, inject today's date
      initialValueAfterFieldSelection = JSFUNC.now_dateYmd();
    }
    else { //any other mass editable field selected
      //set the selected/entered value to the blankValue for the given field type
      const selectedExpandedCaptureFieldMap = this.props.DatabaseMobx.c_tbl_captures_fields.get(i_fieldID);
      if(selectedExpandedCaptureFieldMap !== undefined) {
        const selectedCaptureFieldFieldTypeObj = selectedExpandedCaptureFieldMap.get("fieldTypeObj");
        if(selectedCaptureFieldFieldTypeObj !== undefined) {
          initialValueAfterFieldSelection = selectedCaptureFieldFieldTypeObj.blankValue;
        }
      }
    }
    
    this.onchange_capture_field_value_raw(initialValueAfterFieldSelection);

    this.setState({s_selectedCaptureFieldID:i_fieldID});
  }

  onchange_capture_field_value_raw = (i_newValue) => {
    this.setState({s_selectedOrEnteredCaptureFieldValueRaw:i_newValue});
  }

  onswitch_send_mass_edit_notifications_tf = () => {
    this.setState({s_sendMassEditNotificationsTF:!this.state.s_sendMassEditNotificationsTF});
  }

  onclick_mass_edit_field_for_all_captures_in_capture_table = () => {
    const s_selectedCaptureFieldID = this.state.s_selectedCaptureFieldID;
    const s_selectedOrEnteredCaptureFieldValueRaw = this.state.s_selectedOrEnteredCaptureFieldValueRaw;
    const s_sendMassEditNotificationsTF = this.state.s_sendMassEditNotificationsTF;

    const p_sortedFilteredMaskedCaptureValuesArrayOfObjs = this.props.p_sortedFilteredMaskedCaptureValuesArrayOfObjs;

    const c_selectedQuickAccessExpandedCaptureTableMasterPresetObj = this.props.CapturesMobx.c_selectedQuickAccessExpandedCaptureTableMasterPresetObj;
    const c_tbl_captures_fields = this.props.DatabaseMobx.c_tbl_captures_fields;

    const selectedExpandedCaptureFieldMap = c_tbl_captures_fields.get(s_selectedCaptureFieldID);
    if(selectedExpandedCaptureFieldMap !== undefined) {
      //close the mass edit floating box to make way for the mass edit progress floating box
      if(JSFUNC.is_function(this.props.f_onClickClose)) {
        this.props.f_onClickClose();
      }

      const floatingBoxTitle = "Editing Captures in Capture Table '" + c_selectedQuickAccessExpandedCaptureTableMasterPresetObj.name + "'";

      //call the recursive mass edit for the currently open master button table of captures
      this.props.CapturesMobx.a_mass_edit_field_for_all_captures_in_capture_table(p_sortedFilteredMaskedCaptureValuesArrayOfObjs, selectedExpandedCaptureFieldMap, s_selectedOrEnteredCaptureFieldValueRaw, s_sendMassEditNotificationsTF, floatingBoxTitle, undefined);
    }
  }

  render() {
    const s_selectedCaptureFieldID = this.state.s_selectedCaptureFieldID;
    const s_selectedOrEnteredCaptureFieldValueRaw = this.state.s_selectedOrEnteredCaptureFieldValueRaw;
    const s_sendMassEditNotificationsTF = this.state.s_sendMassEditNotificationsTF;

    const p_sortedFilteredMaskedCaptureValuesArrayOfObjs = this.props.p_sortedFilteredMaskedCaptureValuesArrayOfObjs;
    const p_filterName = this.props.p_filterName;

    const c_fieldMapOfCaptureID = this.props.DatabaseMobx.c_fieldMapOfCaptureID;
    const c_fieldMapOfCaptureManagers = this.props.DatabaseMobx.c_fieldMapOfCaptureManagers;
    const c_fieldMapOfContractEndDate = this.props.DatabaseMobx.c_fieldMapOfContractEndDate;
    const c_fieldMapOfLastChangedDate = this.props.DatabaseMobx.c_fieldMapOfLastChangedDate;
    const c_fieldMapOfArchiveDate = this.props.DatabaseMobx.c_fieldMapOfArchiveDate;

    var selectedCaptureFieldIsCaptureManagersTF = false;
    var selectedCaptureFieldIsContractManagerTF = false;
    var selectedCaptureFieldIsArchiveDateTF = false;
    if(s_selectedCaptureFieldID === c_fieldMapOfCaptureManagers.get("id")) { selectedCaptureFieldIsCaptureManagersTF = true; }
    else if(s_selectedCaptureFieldID === c_fieldMapOfArchiveDate.get("id")) { selectedCaptureFieldIsArchiveDateTF = true; }

    const numCapturesInTable = p_sortedFilteredMaskedCaptureValuesArrayOfObjs.length;

    //if selected Capture Team or Contracts Manager field to mass edit, show switch for sending notifications
    var selectedExpandedCaptureFieldMap = undefined;
    var selectedCaptureFieldIsValidTF = false;
    var button1Type = "blue";
    var button1Name = "Edit " + numCapturesInTable + " " + JSFUNC.plural(numCapturesInTable, "Capture", "Captures");
    var button1Title = undefined;
    if(JSFUNC.select_int_is_filled_out_tf(s_selectedCaptureFieldID)) {
      selectedExpandedCaptureFieldMap = this.props.DatabaseMobx.c_tbl_captures_fields.get(s_selectedCaptureFieldID);
      selectedCaptureFieldIsValidTF = (selectedExpandedCaptureFieldMap !== undefined);
    }

    if(!selectedCaptureFieldIsValidTF) {
      button1Type = "blueDisabled";
      button1Title = "First select a Capture Field to apply this mass edit to";
    }

    //input for value for this selected field to write into each mass edited capture
    var inputNewValueComponent = null;
    if(selectedCaptureFieldIsValidTF) { //archive date forces the value to be today's date and displays a message, all other mass edit fields have their specific value type ready for custom input
      inputNewValueComponent = (
        <>
          <CEGeneralReact.GenericInputOrSelectFromInputType
            p_fieldTypeObj={selectedExpandedCaptureFieldMap.get("fieldTypeObj")}
            p_valueRaw={s_selectedOrEnteredCaptureFieldValueRaw}
            p_valuesToNotIncludeArray={undefined}
            p_tabIndex={2}
            p_errorTF={undefined}
            f_onChangeOrOnSelect={this.onchange_capture_field_value_raw}
          />
          {(selectedCaptureFieldIsArchiveDateTF) &&
            <div className="microTopMargin">
              <font className="fontItalic fontTextLighter">
                {"Each Capture will be archived with this date as the " + c_fieldMapOfArchiveDate.get("display_name") + ". These Captures will still be visible in your Capture Table until your next login, where they will then be treated like other archived Captures."}
              </font>
            </div>
          }
        </>
      );
    }
    else {
      inputNewValueComponent = (
        <div className="">
          <font className="fontItalic fontTextLighter">
            {"--Select a Capture Field above--"}
          </font>
        </div>
      );
    }

    //switch for notifications only shows up when Capture Managers or Contracts Manager is selected (only fields so far that when edited using OpenCaptureMobx a_details_update_field_value(), send out notifications, if more are added, add them here)
    var sendMassEditNotificationsSwitchComponent = null;
    if(selectedCaptureFieldIsValidTF) {
      if(selectedCaptureFieldIsCaptureManagersTF || selectedCaptureFieldIsContractManagerTF) {
        const selectedCaptureFieldDisplayName = selectedExpandedCaptureFieldMap.get("display_name");
        sendMassEditNotificationsSwitchComponent = (
          <div className="bigTopMargin hugeBottomMargin lrMargin borderT1bbb borderB1bbb tbMedPad">
            <CEGeneralReact.SwitchWithTextAndConfirmBox
              p_isOnTF={s_sendMassEditNotificationsTF}
              p_onText={"Send notifications/emails of these changes per Capture to affected " + selectedCaptureFieldDisplayName}
              p_offText={"Do not send any notifications/emails to " + selectedCaptureFieldDisplayName + " regarding changed Captures"}
              p_tabIndex={3}
              p_title="Switch this setting to change if the notifications/emails normally sent to Capture Managers or Contract Managers should be sent for each Capture affected by this mass edit"
              f_onSwitch={this.onswitch_send_mass_edit_notifications_tf}
            />
          </div>
        );
      }
    }

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="smallVertical"
        p_title="Mass Edit a Field in Current Capture Table"
        f_onClickCancel={this.props.f_onClickClose}>
        <div className="flex11a displayFlexColumn medFullPad">
          <div className="smallBottomMargin lrBigMargin">
            <font className="fontItalic">
              {"This mass edit feature allows you to choose a particular Capture Field and set a new value. That new value will be overwritten for that field into every Capture seen in the currently selected table (" + p_filterName + ")."}
            </font>
          </div>
          <div className="border1bbb bgLightestGray medFullPad">
            <div className="microBottomMargin">
              <font className="font11 fontBold fontTextLight">
                {"Select a Capture Field"}
              </font>
            </div>
            <div className="microBottomMargin">
              <font className="fontItalic fontTextLight">
                {"If you cannot find a field you are looking for in the list, it is likely that field either cannot be edited (like '" + c_fieldMapOfCaptureID.get("display_name") + "' or '" + c_fieldMapOfLastChangedDate.get("display_name") + "') or is a computed field (like '" + c_fieldMapOfContractEndDate.get("display_name") + "')"}
              </font>
            </div>
            <CEGeneralReact.GenericInputOrSelectFromInputType
              p_fieldTypeObj={this.props.DatabaseMobx.c_selectMassEditableCaptureFieldFieldTypeObj}
              p_valueRaw={s_selectedCaptureFieldID}
              p_valuesToNotIncludeArray={undefined}
              p_tabIndex={1}
              p_errorTF={undefined}
              f_onChangeOrOnSelect={this.onselect_capture_field}
            />
            <div className="bigTopMargin microBottomMargin">
              <font className="font11 fontBold fontTextLight">
                {"Choose/Enter a Value"}
              </font>
            </div>
            {inputNewValueComponent}
          </div>
          {sendMassEditNotificationsSwitchComponent}
          <div className="flex00a displayFlexRowHcVc hugeTopMargin" style={{flexBasis:"3em"}}>
            <div className="flex00a lrMedMargin">
              <CEGeneralReact.CEButton
                p_type={button1Type}
                p_text={button1Name}
                p_title={button1Title}
                p_tabIndex={4}
                f_onClick={this.onclick_mass_edit_field_for_all_captures_in_capture_table}
              />
            </div>
            <div className="flex00a lrMedMargin">
              <CEGeneralReact.CEButton
                p_type="gray"
                p_text="Cancel"
                p_tabIndex={5}
                f_onClick={this.props.f_onClickClose}
              />
            </div>
          </div>
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));

export const ProcessMultipleCapturesProgressFloatingBox = inject("CapturesMobx", "DatabaseMobx")(observer(
class ProcessMultipleCapturesProgressFloatingBox extends Component {
  onclick_close_capture_table_processing_captures_floating_box = () => {
    this.props.CapturesMobx.a_set_capture_table_processing_captures_obj_or_undefined(undefined);
  }

  onclick_cancel_capture_table_processing_loop = () => {
    this.props.CapturesMobx.a_set_capture_table_processing_captures_attempt_to_cancel_flag_tf(true);
  }

  render() {
    const o_captureTableProcessingCapturesObjOrUndefined = this.props.CapturesMobx.o_captureTableProcessingCapturesObjOrUndefined;

    if(o_captureTableProcessingCapturesObjOrUndefined === undefined) {
      return(null);
    }

    const floatingBoxTitle = o_captureTableProcessingCapturesObjOrUndefined.floatingBoxTitle;
    const editingDeletingString = o_captureTableProcessingCapturesObjOrUndefined.editingDeletingString;
    const editedDeletedString = o_captureTableProcessingCapturesObjOrUndefined.editedDeletedString;
    const progressColor = o_captureTableProcessingCapturesObjOrUndefined.progressColor;
    const expandedCaptureFieldMap = o_captureTableProcessingCapturesObjOrUndefined.expandedCaptureFieldMap;
    const valueRaw = o_captureTableProcessingCapturesObjOrUndefined.valueRaw;
    const currentlyProcessingCaptureName = o_captureTableProcessingCapturesObjOrUndefined.currentlyProcessingCaptureName;
    const currentlyProcessingCaptureNumber = o_captureTableProcessingCapturesObjOrUndefined.currentlyProcessingCaptureNumber;
    const totalNumCapturesToProcess = o_captureTableProcessingCapturesObjOrUndefined.totalNumCapturesToProcess;
    const successCaptureNamesArray = o_captureTableProcessingCapturesObjOrUndefined.successCaptureNamesArray;
    const failedCaptureNamesArray = o_captureTableProcessingCapturesObjOrUndefined.failedCaptureNamesArray;

    //in progress processing a capture
    if(currentlyProcessingCaptureNumber > 0) {
      const progressTextHtml = (
        <>
          <div className="smallBottomMargin">
            <font className="">
              {editingDeletingString + " Capture " + currentlyProcessingCaptureNumber + " of " + totalNumCapturesToProcess}
            </font>
          </div>
          <div className="">
            <font className="fontItalic">
              {"'" + currentlyProcessingCaptureName + "'"}
            </font>
          </div>
        </>
      );
      
      return(
        <CEGeneralReact.RecursiveProgressBarFloatingBox
          p_floatingBoxTitle={floatingBoxTitle}
          p_progressTextHtmlOrUndefined={progressTextHtml}
          p_currentItemNumber={currentlyProcessingCaptureNumber}
          p_totalNumItems={totalNumCapturesToProcess}
          p_progressColor={progressColor}
          f_onClickCancel={this.onclick_cancel_capture_table_processing_loop}
        />
      );
    }

    //success box at end of loops (-1 flag that all captures have been processed or cancellation flag is true)
    const numSuccessCaptures = successCaptureNamesArray.length;
    const numFailedCaptures = failedCaptureNamesArray.length;

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="smallVertical"
        p_title={floatingBoxTitle}
        f_onClickCancel={this.onclick_close_capture_table_processing_captures_floating_box}>
        <div className="flex11a yScroll medFullPad">
          <div className="smallBottomMargin textCenter">
            <font className="font11 fontBold fontItalic fontGreen">
              {"Successfully " + editedDeletedString + " " + numSuccessCaptures + " " + JSFUNC.plural(numSuccessCaptures, "Capture", "Captures")}
            </font>
            {(expandedCaptureFieldMap !== undefined) &&
              <>
                <div className="">
                  <font className="fontItalic fontTextLighter">
                    {"Capture Field: '" + expandedCaptureFieldMap.get("display_name") + "'"}
                  </font>
                </div>
                <div className="">
                  <font className="fontItalic fontTextLighter">
                    {"New Value: " + this.props.DatabaseMobx.value_mask_plaintext_from_value_raw_and_field_type_obj(valueRaw, expandedCaptureFieldMap.get("fieldTypeObj"))}
                  </font>
                </div>
              </>
            }
          </div>
          {successCaptureNamesArray.map((m_captureName) =>
            <div className="">
              <font className="">
                {m_captureName}
              </font>
            </div>
          )}
          {(numFailedCaptures > 0) &&
            <>
              <div className="hugeTopMargin smallBottomMargin textCenter">
                <font className="font11 fontBold fontItalic fontRed">
                  {numFailedCaptures + " " + JSFUNC.plural(numFailedCaptures, "Capture was", "Captures were") + " not successfully " + editedDeletedString}
                </font>
              </div>
              {failedCaptureNamesArray.map((m_captureName) =>
                <div className="">
                  <font className="fontRed">
                    {m_captureName}
                  </font>
                </div>
              )}
            </>
          }
        </div>
        <div className="flex00a displayFlexColumnHcVc borderT1bbb tbPad">
          <CEGeneralReact.CEButton
            p_type="gray"
            p_text="Close"
            f_onClick={this.onclick_close_capture_table_processing_captures_floating_box}
          />
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));


function ButtonCreateEditFilters(props) { //props: p_sizeEm, p_title, f_onClick
  const lineColor = "#888";
  const lineWidthPercent = 8;
  const plusColor = "#77c";
  const plusWidthPercent = 6;
  return(
    <div
      className="border bevelBorderColors borderRadius05 bgLighterGray hoverLighterBlueGradient cursorPointer"
      style={{width:props.p_sizeEm + "em", height:props.p_sizeEm + "em"}}
      title={props.p_title}
      onClick={props.f_onClick}>
      <svg width="100%" height="100%">
        <LibraryReact.SvgHLine p_x1p={10} p_x2p={90} p_ycp={20} p_widthP={lineWidthPercent} p_color={lineColor} />
        <LibraryReact.SvgHLine p_x1p={20} p_x2p={80} p_ycp={35} p_widthP={lineWidthPercent} p_color={lineColor} />
        <LibraryReact.SvgHLine p_x1p={30} p_x2p={70} p_ycp={50} p_widthP={lineWidthPercent} p_color={lineColor} />
        <LibraryReact.SvgHLine p_x1p={35} p_x2p={65} p_ycp={65} p_widthP={lineWidthPercent} p_color={lineColor} />
        <LibraryReact.SvgHLine p_x1p={35} p_x2p={65} p_ycp={80} p_widthP={lineWidthPercent} p_color={lineColor} />
        <LibraryReact.SvgHLine p_x1p={70} p_x2p={90} p_ycp={75} p_widthP={plusWidthPercent} p_color={plusColor} />
        <LibraryReact.SvgVLine p_y1p={65} p_y2p={85} p_xcp={80} p_widthP={plusWidthPercent} p_color={plusColor} />
      </svg>
    </div>
  );
}










//======================================================================================================================================
//======================================================================================================================================
//Captures Table View
//======================================================================================================================================
//======================================================================================================================================

const CaptureTable = inject("CaptureExecMobx", "CapturesMobx", "UserMobx")(observer(
class CaptureTable extends Component {
  constructor(props) {
    super(props);
    this.cstHeaderRow = React.createRef();
    this.state = {
      s_cstBodyScrollLeft: 0
    }
  }

  ondrop_column_resize = (i_draggedColumnTblFCstColumnsID, event) => {
    this.props.CapturesMobx.a_cst_column_resize(i_draggedColumnTblFCstColumnsID, event.clientX);
  }

  onscroll_cst_header_row = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.cstHeaderRow.current.scrollLeft = this.state.s_cstBodyScrollLeft;
  }

  onscroll_cst_body = (i_newBodyScrollLeft) => {
    this.cstHeaderRow.current.scrollLeft = i_newBodyScrollLeft;
    this.setState({s_cstBodyScrollLeft:i_newBodyScrollLeft});
  }

  render() {
    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const c_expandedCstColumnsArrayOfObjs = this.props.CapturesMobx.c_expandedCstColumnsArrayOfObjs;
    const c_captureTableTotalWidthEm = this.props.CapturesMobx.c_captureTableTotalWidthEm;
    const c_selectedQuickAccessExpandedCstColumnPresetObj = this.props.CapturesMobx.c_selectedQuickAccessExpandedCstColumnPresetObj;
    const c_cstSumRowColumnsArrayOfObjsOrUndefined = this.props.CapturesMobx.c_cstSumRowColumnsArrayOfObjsOrUndefined;
    const c_userCaptureTableRowHeightOptionsObj = this.props.UserMobx.c_userCaptureTableRowHeightOptionsObj;
    const c_userCSTEditCellsModeTF = this.props.UserMobx.c_userCSTEditCellsModeTF;

    const canResizeColumnsTF = this.props.UserMobx.user_id_is_one_of_logged_in_user_per_email_multilogin_tf(c_selectedQuickAccessExpandedCstColumnPresetObj.user_id);

    const cstEditCellsModeOpenCaptureColumnWidthEm = 2;
    
    return(
      <div className="flex11a displayFlexColumn" style={{border:"solid 1px #ccc"}}>
        <div
          ref={this.cstHeaderRow}
          className="flex00a xScrollHidden"
          onScroll={this.onscroll_cst_header_row}>
          <CEGeneralReact.CE3Drag3Drop3Shell3
            p_uniqueString="cstHeadersDragDrop"
            p_itemID={undefined}
            p_draggableTF={false}
            p_droppableTF={canResizeColumnsTF}
            p_dropZoneIsInvisibleOverlayTF={false}
            p_dropZoneOversizeWidthEm={undefined}
            p_class={"displayFlexRow " + c_productStylingObj.cstColumnHeaderRowBgClass + " borderB1ddd " + ((canResizeColumnsTF) ? ("cursorGrab") : (""))}
            p_styleObj={{height:c_userCaptureTableRowHeightOptionsObj.headerHeightEm + "em", width:c_captureTableTotalWidthEm + "em"}}
            p_title={undefined}
            p_dragOverClass={undefined}
            p_dragOverStyleObj={undefined}
            f_onDropMatchingItem={this.ondrop_column_resize}>
            {(c_userCSTEditCellsModeTF) &&
              <div className="flex00a" style={{width:cstEditCellsModeOpenCaptureColumnWidthEm + "em"}} />
            }
            {c_expandedCstColumnsArrayOfObjs.map((m_expandedCstColumnObj) =>
              <CaptureTableColumnHeader
                key={"cstH" + m_expandedCstColumnObj.id + JSFUNC.key_rand()}
                p_expandedCstColumnObj={m_expandedCstColumnObj}
                p_canResizeColumnsTF={canResizeColumnsTF}
              />
            )}
          </CEGeneralReact.CE3Drag3Drop3Shell3>
          {(JSFUNC.is_array(c_cstSumRowColumnsArrayOfObjsOrUndefined)) &&
            <div className={"displayFlexRow borderB1ddd " + c_productStylingObj.cstSumRowBgClass} style={{height:"1.8em", width:c_captureTableTotalWidthEm + "em"}}>
              {(c_userCSTEditCellsModeTF) &&
                <div className="flex00a" style={{width:cstEditCellsModeOpenCaptureColumnWidthEm + "em"}} />
              }
              {c_cstSumRowColumnsArrayOfObjsOrUndefined.map((m_cstSumRowColumnObj, m_index) =>
                <div
                  key={"cstSR" + m_cstSumRowColumnObj.id + JSFUNC.key_rand()}
                  className={"flex00a " + ((m_cstSumRowColumnObj.sumRowTF) ? ("displayFlexColumnVc " + c_productStylingObj.cstSumRowSumColumnBgClass + " lrMedPad " + c_expandedCstColumnsArrayOfObjs[m_index].cstCellAlignClass) : (""))}
                  style={{flexBasis:c_expandedCstColumnsArrayOfObjs[m_index].width_em + "em", borderLeft:"solid 1px transparent"}}
                  title={((m_cstSumRowColumnObj.sumRowTF) ? ("Sum of column '" + c_expandedCstColumnsArrayOfObjs[m_index].fieldDisplayName + "': " + m_cstSumRowColumnObj.sumValueMaskPlainText) : (undefined))}>
                  {(m_cstSumRowColumnObj.sumRowTF) &&
                    <LibraryReact.NowrapEllipsis p_fontClass="fontAlmostWhite">
                      {m_cstSumRowColumnObj.sumValueMask}
                    </LibraryReact.NowrapEllipsis>
                  }
                </div>
              )}
            </div>
          }
        </div>
        <CaptureTableBody
          p_cstEditCellsModeOpenCaptureColumnWidthEm={cstEditCellsModeOpenCaptureColumnWidthEm}
          f_onScrollCstBody={this.onscroll_cst_body}
        />
      </div>
    );
  }
}));

const CaptureTableBody = inject("CaptureExecMobx", "CapturesMobx")(observer(
class CaptureTableBody extends Component { //props: p_cstEditCellsModeOpenCaptureColumnWidthEm, f_onScrollCstBody
  constructor(props) {
    super(props);
    this.cstBody = React.createRef();
  }

  onscroll_cst_body = (event) => {
    if(JSFUNC.is_function(this.props.f_onScrollCstBody)) {
      this.props.f_onScrollCstBody(this.cstBody.current.scrollLeft);
    }
  }

  onclick_show_all_captures = () => {
    const c_selectedLeftNavIsProgressChartViewTF = this.props.CaptureExecMobx.c_selectedLeftNavIsProgressChartViewTF;

    const maxTrueResetFalse = true;
    this.props.CapturesMobx.a_set_cst_or_chart_max_num_captures_drawn(maxTrueResetFalse, c_selectedLeftNavIsProgressChartViewTF);
  }

  render() {
    const p_cstEditCellsModeOpenCaptureColumnWidthEm = this.props.p_cstEditCellsModeOpenCaptureColumnWidthEm;

    const o_cstOrChartMaxNumCapturesDrawn = this.props.CapturesMobx.o_cstOrChartMaxNumCapturesDrawn;
    const c_selectedQuickAccessExpandedCaptureTableMasterPresetObj = this.props.CapturesMobx.c_selectedQuickAccessExpandedCaptureTableMasterPresetObj;
    const c_cstSortedFilteredMaskedCaptureValuesArrayOfObjs = this.props.CapturesMobx.c_cstSortedFilteredMaskedCaptureValuesArrayOfObjs;
    const c_numFilteredCaptures = this.props.CapturesMobx.c_numFilteredCaptures;

    if(c_numFilteredCaptures === 0) {
      return(
        <CEGeneralReact.EmptyScreenGray p_fontClass="font12">
          {"0 captures using filter '" + c_selectedQuickAccessExpandedCaptureTableMasterPresetObj.name + "'"}
        </CEGeneralReact.EmptyScreenGray>
      );
    }

    return(
      <div
        ref={this.cstBody}
        className="flex11a xyScroll yScrollBottomPad"
        onScroll={this.onscroll_cst_body}>
        {c_cstSortedFilteredMaskedCaptureValuesArrayOfObjs.map((m_cstMaskedCaptureValuesObj, m_index) =>
          (m_index < o_cstOrChartMaxNumCapturesDrawn) &&
          <CaptureTableRow
            key={"cstR" + m_cstMaskedCaptureValuesObj.id + JSFUNC.key_rand()}
            p_cstMaskedCaptureValuesObj={m_cstMaskedCaptureValuesObj}
            p_cstEditCellsModeOpenCaptureColumnWidthEm={p_cstEditCellsModeOpenCaptureColumnWidthEm}
          />
        )}
        <ShowAllCapturesButtonAndMessage
          p_numFilteredCaptures={c_numFilteredCaptures}
          p_maxNumCapturesDrawn={o_cstOrChartMaxNumCapturesDrawn}
          f_onClickShowAllCaptures={this.onclick_show_all_captures}
        />
      </div>
    );
  }
}));

function ShowAllCapturesButtonAndMessage(props) { //props: p_numFilteredCaptures, p_maxNumCapturesDrawn, f_onClickShowAllCaptures
  if(props.p_numFilteredCaptures <= props.p_maxNumCapturesDrawn) {
    return(null);
  }

  return(
    <div className="displayFlexRow smallFullPad" style={{backgroundColor:"#ccc"}}>
      <div className="flex00a lrMargin">
        <CEGeneralReact.CEButton
          p_type="blue"
          p_text={"Show All " + props.p_numFilteredCaptures + " Captures"}
          f_onClick={props.f_onClickShowAllCaptures}
        />
      </div>
      <div className="flex11a lrMargin">
        <font className="fontItalic">
          <div>{"This is the first " + props.p_maxNumCapturesDrawn + " captures matching your filter/sort. You can click to display all matching captures."}</div>
          <div>{"If displaying too many on the screen freezes your browser, close it and log back in."}</div>
        </font>
      </div>
    </div>
  );
}

const CaptureTableColumnHeader = inject("CaptureExecMobx", "CapturesMobx", "UserMobx")(observer(
class CaptureTableColumnHeader extends Component { //props: p_expandedCstColumnObj, p_canResizeColumnsTF
  onclick_column_header_to_sort = () => {
    const p_expandedCstColumnObj = this.props.p_expandedCstColumnObj;
    this.props.CapturesMobx.a_cst_column_sort_override(p_expandedCstColumnObj.capture_field_id);
  }

  ondrop_column_resize = (i_draggedColumnTblFCstColumnsID, event) => {
    this.props.CapturesMobx.a_cst_column_resize(i_draggedColumnTblFCstColumnsID, event.clientX);
  }

  onclick_open_hot_filter_floating_box = (event) => {
    const p_expandedCstColumnObj = this.props.p_expandedCstColumnObj;
    event.preventDefault();
    event.stopPropagation();
    this.props.CapturesMobx.a_set_capture_table_column_editing_hot_filter_capture_field_id_or_undefined(p_expandedCstColumnObj.capture_field_id);
  }

  onclick_close_hot_filter_floating_box = () => {
    this.props.CapturesMobx.a_set_capture_table_column_editing_hot_filter_capture_field_id_or_undefined(undefined);
  }

  render() {
    const p_expandedCstColumnObj = this.props.p_expandedCstColumnObj;
    const p_canResizeColumnsTF = this.props.p_canResizeColumnsTF;

    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const o_captureTableColumnsEngagedHotFiltersPerFieldIDMapOfMaps = this.props.CapturesMobx.o_captureTableColumnsEngagedHotFiltersPerFieldIDMapOfMaps;
    const o_captureTableColumnEditingHotFilterCaptureFieldIDOrUndefined = this.props.CapturesMobx.o_captureTableColumnEditingHotFilterCaptureFieldIDOrUndefined;
    const c_sortsArrayOfObjs = this.props.CapturesMobx.c_sortsArrayOfObjs;
    const c_userCaptureTableRowHeightOptionsObj = this.props.UserMobx.c_userCaptureTableRowHeightOptionsObj;

    var bgColorClass = c_productStylingObj.cstColumnHeaderBgClass; //column not sorted
    var fontClass = c_productStylingObj.cstColumnHeaderFontClass;
    var sortIsAscTF = undefined; //undefined means the column is not sorted
    for(let s = 0; s < c_sortsArrayOfObjs.length; s++) {
      if(p_expandedCstColumnObj.capture_field_id === c_sortsArrayOfObjs[s].capture_field_id) { //this is one of possibly several sorted columns
        bgColorClass = ((s === 0) ? (c_productStylingObj.cstColumnHeaderSortedPrimaryBgClass) : (c_productStylingObj.cstColumnHeaderSortedSecondaryBgClass)); //primary or secondary sort column
        fontClass = c_productStylingObj.cstColumnHeaderSortedFontClass;
        sortIsAscTF = c_sortsArrayOfObjs[s].is_asc_01; //sort arrow direction
        break; //can't have the same capture_field_id sorted more than once, break after finding it
      }
    }

    const columnHasEngagedHotFilterTF = o_captureTableColumnsEngagedHotFiltersPerFieldIDMapOfMaps.has(p_expandedCstColumnObj.capture_field_id);
    const hotFilterFloatingBoxIsOpenTF = (p_expandedCstColumnObj.fieldExistsTF && (o_captureTableColumnEditingHotFilterCaptureFieldIDOrUndefined === p_expandedCstColumnObj.capture_field_id));

    return (
      <>
        <div
          className={"flex00a displayFlexRow borderL1bbb " + bgColorClass}
          style={{flexBasis:p_expandedCstColumnObj.width_em + "em"}}>
          <div
            className="flex11a displayFlexRow cursorPointer"
            style={{position:"relative"}}
            title={p_expandedCstColumnObj.fieldDisplayName + "\n[click to sort table by this column]"}
            onClick={this.onclick_column_header_to_sort}>
            <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"1.2em", marginLeft:"0.15em"}}>
              <CEGeneralReact.HeaderSortArrow
                p_isSortedTF={(sortIsAscTF !== undefined)}
                p_sortedAscTF={sortIsAscTF}
              />
            </div>
            <div className="flex11a displayFlexRowVc textCenter" style={{marginRight:((p_canResizeColumnsTF) ? ("1.65em") : ("1.95em"))}}>
              {(c_userCaptureTableRowHeightOptionsObj.headerTextMaxHeightTrueNowrapFalse) ? (
                <LibraryReact.MaxHeightWrap p_maxHeight={c_userCaptureTableRowHeightOptionsObj.headerTextMaxHeightEm + "em"} p_fontClass={fontClass}>
                  {p_expandedCstColumnObj.fieldDisplayName}
                </LibraryReact.MaxHeightWrap>
              ) : (
                <LibraryReact.NowrapEllipsis p_fontClass={fontClass}>
                  {p_expandedCstColumnObj.fieldDisplayName}
                </LibraryReact.NowrapEllipsis>
              )}
            </div>
            <div
              className="positionAbsolute displayFlexColumnHcVc border1bbb cursorPointer"
              style={{right:"0.15em", bottom:"0.15em", width:"1.1em", height:"1.1em", borderRadius:"0.15em", backgroundColor:"#" + (columnHasEngagedHotFilterTF ? ("f0d030") : ("184080"))}}
              title={"Apply secondary Hot Filter for Capture Field '" + p_expandedCstColumnObj.fieldDisplayName + "'"}
              onClick={this.onclick_open_hot_filter_floating_box}>
              <CEIconsReact.SvgFunnelSolid p_sizeEm={0.9} p_color="ffffff" />
            </div>
          </div>
          {(p_canResizeColumnsTF) &&
            <CEGeneralReact.CE3Drag3Drop3Shell3
              p_uniqueString="cstHeadersDragDrop"
              p_itemID={p_expandedCstColumnObj.id}
              p_draggableTF={true}
              p_droppableTF={false}
              p_dropZoneIsInvisibleOverlayTF={false}
              p_dropZoneOversizeWidthEm={undefined}
              p_class="flex00a cursorLRResizeArrows"
              p_styleObj={{flexBasis:"0.75em", borderLeft:"solid 1px #99b"}}
              p_title={"Click, drag left or right, and release to change width of column '" + p_expandedCstColumnObj.fieldDisplayName + "'"}
              p_dragOverClass={undefined}
              p_dragOverStyleObj={undefined}
              f_onDropMatchingItem={this.ondrop_column_resize}
            />
          }
        </div>
        {(hotFilterFloatingBoxIsOpenTF) &&
          <CaptureTableColumnHeaderHotFilterFloatingBox
            p_expandedCstColumnObj={p_expandedCstColumnObj}
            f_onClickClose={this.onclick_close_hot_filter_floating_box}
          />
        }
      </>
    );
  }
}));

const CaptureTableColumnHeaderHotFilterFloatingBox = inject("CapturesMobx")(observer(
class CaptureTableColumnHeaderHotFilterFloatingBox extends Component { //props: p_expandedCstColumnObj, f_onClickClose
  onchange_hot_filter_operator_or_values = (i_updatedOperatorAndValuesObj) => {
    const p_expandedCstColumnObj = this.props.p_expandedCstColumnObj;
    this.props.CapturesMobx.a_set_capture_table_hot_filter_operator_and_or_value(p_expandedCstColumnObj, i_updatedOperatorAndValuesObj);
  }

  onclick_clear_hot_filter = () => {
    const p_expandedCstColumnObj = this.props.p_expandedCstColumnObj;
    this.props.CapturesMobx.a_set_capture_table_hot_filter_operator_and_or_value(p_expandedCstColumnObj, undefined);
  }

  render() {
    const p_expandedCstColumnObj = this.props.p_expandedCstColumnObj;
    const f_onClickClose = this.props.f_onClickClose;
    
    const o_captureTableColumnsEngagedHotFiltersPerFieldIDMapOfMaps = this.props.CapturesMobx.o_captureTableColumnsEngagedHotFiltersPerFieldIDMapOfMaps;

    var hotFilterSelectedOperatorString = "";
    var hotFilterSelectedValueOrValuesString = "";
    const columnHotFilterMapOrUndefined = o_captureTableColumnsEngagedHotFiltersPerFieldIDMapOfMaps.get(p_expandedCstColumnObj.capture_field_id);
    if(columnHotFilterMapOrUndefined !== undefined) {
      hotFilterSelectedOperatorString = columnHotFilterMapOrUndefined.get("hotFilterSelectedOperatorString");
      hotFilterSelectedValueOrValuesString = columnHotFilterMapOrUndefined.get("hotFilterSelectedValueOrValuesString");
    }

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="confirmBox"
        p_title="Apply Column Hot Filter"
        f_onClickSave={f_onClickClose}>
        <div className="tbPad lrMedPad">
          <LibraryReact.DivFont p_class="textCenter" p_fontClass="fontItalic fontTextLighter">
            {"Hot Filters apply a secondary level of filtering to the Capture Table on top of your selected filter"}
          </LibraryReact.DivFont>
          <div className="flex00a displayFlexRow medTopMargin">
            <div className="flex11a displayFlexRowVc medRightMargin">
              <LibraryReact.DivFont p_class="" p_fontClass="font11">
                {"Capture Field: "}<span className="fontBold fontBlue">{p_expandedCstColumnObj.fieldDisplayName}</span>
              </LibraryReact.DivFont>
            </div>
            <div className="flex00a">
              <CEGeneralReact.ClearXWithLabel
                p_labelText="Clear Filter"
                p_class="border1ddd bgLightestestGray tbMicroPad lrMedPad hoverFontUnderline"
                p_fontClass="fontTextLight"
                p_tabIndex={undefined}
                p_title="Clear this column Hot Filter"
                f_onClick={this.onclick_clear_hot_filter}
              />
            </div>
          </div>
          <div className="displayFlexColumnHcVc smallTopMargin medBottomMargin">
            <div className="flex00a border1bbb bgLightestGray medFullPad" style={{width:"100%", maxWidth:"40em"}}>
              <SingleCaptureFieldOperatorValuesSelector
                p_fieldTypeObj={p_expandedCstColumnObj.expandedCaptureFieldMap.get("fieldTypeObj")}
                p_selectedOperator={hotFilterSelectedOperatorString}
                p_selectedValueOrValuesString={hotFilterSelectedValueOrValuesString}
                p_canEditTF={true}
                f_onChangeOperatorOrValues={this.onchange_hot_filter_operator_or_values}
              />
            </div>
          </div>
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));

const CaptureTableRow = inject("CapturesMobx", "OpenCaptureMobx", "UserMobx")(observer(
class CaptureTableRow extends Component { //props: p_cstMaskedCaptureValuesObj, p_cstEditCellsModeOpenCaptureColumnWidthEm
  onclick_open_capture = () => {
    this.props.OpenCaptureMobx.a_open_single_capture(this.props.p_cstMaskedCaptureValuesObj.id);
  }

  render() {
    const p_cstMaskedCaptureValuesObj = this.props.p_cstMaskedCaptureValuesObj;
    const p_cstEditCellsModeOpenCaptureColumnWidthEm = this.props.p_cstEditCellsModeOpenCaptureColumnWidthEm;

    const c_expandedCstColumnsArrayOfObjs = this.props.CapturesMobx.c_expandedCstColumnsArrayOfObjs;
    const c_captureTableTotalWidthEm = this.props.CapturesMobx.c_captureTableTotalWidthEm;
    const c_userCaptureTableRowHeightEm = this.props.UserMobx.c_userCaptureTableRowHeightEm;
    const c_userCSTEditCellsModeTF = this.props.UserMobx.c_userCSTEditCellsModeTF;

    const openCaptureTitle = "Click to open Capture '" + p_cstMaskedCaptureValuesObj.captureFullName + "'";

    return(
      <div
        className="displayFlexRow bgWhite borderB1ddd hoverLighterBlueGradient"
        style={{height:c_userCaptureTableRowHeightEm + "em", width:c_captureTableTotalWidthEm + "em"}}>
        {(c_userCSTEditCellsModeTF) &&
          <div
            className="flex00a displayFlexColumn bgRedCapture hoverRedCapture cursorPointer"
            style={{width:p_cstEditCellsModeOpenCaptureColumnWidthEm + "em"}}
            title={openCaptureTitle}
            onClick={this.onclick_open_capture}>
            <div className="flex11a displayFlexColumnHcVc borderR1bbb">
              <CEIconsReact.SvgOpenCapture
                p_sizeEm={1.6}
                p_color="fff"
              />
            </div>
          </div>
        }
        {c_expandedCstColumnsArrayOfObjs.map((m_expandedCstColumnObj) =>
          <CaptureTableCell
            key={"cstC" + m_expandedCstColumnObj.id + JSFUNC.key_rand()}
            p_expandedCstColumnObj={m_expandedCstColumnObj}
            p_cstMaskedCaptureValuesObj={p_cstMaskedCaptureValuesObj}
          />
        )}
      </div>
    );
  }
}));


const CaptureTableCell = inject("OpenCaptureMobx", "DatabaseMobx", "UserMobx", "CapturesMobx")(observer(
class CaptureTableCell extends Component {  //props: p_expandedCstColumnObj, p_cstMaskedCaptureValuesObj
  constructor(props) {
    super(props);
    this.state = {
      s_editCellFloatingBoxIsOpenTF: false 
    };
  }

  onclick_open_capture = () => {
    this.props.OpenCaptureMobx.a_open_single_capture(this.props.p_cstMaskedCaptureValuesObj.id);
  }

  onselect_cst_capture_favorite_or_priority_level = (i_selectedFieldValueRaw) => {
    const p_expandedCstColumnObj = this.props.p_expandedCstColumnObj;
    const p_cstMaskedCaptureValuesObj = this.props.p_cstMaskedCaptureValuesObj;

    this.props.OpenCaptureMobx.a_details_update_field_value(p_expandedCstColumnObj.expandedCaptureFieldMap, i_selectedFieldValueRaw, p_cstMaskedCaptureValuesObj.id);
  }

  onclick_edit_cell = () => {
    const p_expandedCstColumnObj = this.props.p_expandedCstColumnObj;
    const p_cstMaskedCaptureValuesObj = this.props.p_cstMaskedCaptureValuesObj;

    const k_cardIDAdvanceStage = this.props.DatabaseMobx.k_cardIDAdvanceStage;
    const k_cardIDDealShaping = this.props.DatabaseMobx.k_cardIDDealShaping;
    const k_cardIDTeammates = this.props.DatabaseMobx.k_cardIDTeammates;
    const k_cardIDNotepad = this.props.DatabaseMobx.k_cardIDNotepad;
    const c_companyPwinUsersCanEditTF = this.props.DatabaseMobx.c_companyPwinUsersCanEditTF;
    const c_fieldMapOfStage = this.props.DatabaseMobx.c_fieldMapOfStage;
    const c_fieldMapOfShapingTotalProgress = this.props.DatabaseMobx.c_fieldMapOfShapingTotalProgress;
    const c_fieldMapOfShapingStageProgress = this.props.DatabaseMobx.c_fieldMapOfShapingStageProgress;
    const c_fieldMapOfPwin = this.props.DatabaseMobx.c_fieldMapOfPwin;
    const c_fieldMapOfOurPrimeSubTeammateAllocation = this.props.DatabaseMobx.c_fieldMapOfOurPrimeSubTeammateAllocation;
    const c_fieldMapOfRecentPinnedNoteStamp = this.props.DatabaseMobx.c_fieldMapOfRecentPinnedNoteStamp;

    //editing a stage/dealshaping cell opens that capture into the Advance Stage/Deal Shaping card
    var cellFieldIsStageTF = false;
    var cellFieldIsTotalShapingProgressTF = false;
    var cellFieldIsStageShapingProgressTF = false;
    var cellFieldIsPwinTF = false;
    var cellFieldIsOurPrimeSubTeammateAllocationTF = false;
    var cellFieldIsRecentPinnedNotestampTF = false;
    if(p_expandedCstColumnObj.capture_field_id === c_fieldMapOfStage.get("id")) { cellFieldIsStageTF = true; }
    else if(p_expandedCstColumnObj.capture_field_id === c_fieldMapOfShapingTotalProgress.get("id")) { cellFieldIsTotalShapingProgressTF = true; }
    else if(p_expandedCstColumnObj.capture_field_id === c_fieldMapOfShapingStageProgress.get("id")) { cellFieldIsStageShapingProgressTF = true; }
    else if(p_expandedCstColumnObj.capture_field_id === c_fieldMapOfPwin.get("id")) { cellFieldIsPwinTF = true; }
    else if(p_expandedCstColumnObj.capture_field_id === c_fieldMapOfOurPrimeSubTeammateAllocation.get("id")) { cellFieldIsOurPrimeSubTeammateAllocationTF = true; }
    else if(p_expandedCstColumnObj.capture_field_id === c_fieldMapOfRecentPinnedNoteStamp.get("id")) { cellFieldIsRecentPinnedNotestampTF = true; }

    if(cellFieldIsStageTF || cellFieldIsTotalShapingProgressTF || cellFieldIsStageShapingProgressTF || (cellFieldIsPwinTF && !c_companyPwinUsersCanEditTF) || cellFieldIsOurPrimeSubTeammateAllocationTF || cellFieldIsRecentPinnedNotestampTF) {
      const functionOnSuccess = (i_parseResponse) => {
        if(cellFieldIsStageTF) {
          this.props.OpenCaptureMobx.a_launch_card_full(k_cardIDAdvanceStage);
        }
        else if(cellFieldIsTotalShapingProgressTF || cellFieldIsStageShapingProgressTF || cellFieldIsPwinTF) {
          this.props.OpenCaptureMobx.a_launch_card_full(k_cardIDDealShaping);
        }
        else if(cellFieldIsOurPrimeSubTeammateAllocationTF) {
          this.props.OpenCaptureMobx.a_launch_card_full(k_cardIDTeammates);
        }
        else if(cellFieldIsRecentPinnedNotestampTF) {
          this.props.OpenCaptureMobx.a_launch_card_full(k_cardIDNotepad);
        }
      }
      this.props.OpenCaptureMobx.a_open_single_capture(p_cstMaskedCaptureValuesObj.id, functionOnSuccess);
    }
    else { //otherwise open the edit cell floating box for editing a field
      const captureCellFieldInitialValueRaw = p_cstMaskedCaptureValuesObj[p_expandedCstColumnObj.capture_field_id + "RAW"];
      this.props.CapturesMobx.a_set_capture_table_inline_edit_single_cell_value_raw(captureCellFieldInitialValueRaw);
      this.setState({s_editCellFloatingBoxIsOpenTF:true});
    }
  }

  onclick_close_edit_cell_floating_box = () => {
    this.setState({s_editCellFloatingBoxIsOpenTF:false});
  }

  render() {
    const s_editCellFloatingBoxIsOpenTF = this.state.s_editCellFloatingBoxIsOpenTF;

    const p_expandedCstColumnObj = this.props.p_expandedCstColumnObj;
    const p_cstMaskedCaptureValuesObj = this.props.p_cstMaskedCaptureValuesObj;

    const c_singleCaptureIsOpenTF = this.props.OpenCaptureMobx.c_singleCaptureIsOpenTF;
    const c_companyPwinIsCalculatedTF = this.props.DatabaseMobx.c_companyPwinIsCalculatedTF;
    const c_cardNameAdvanceStage = this.props.DatabaseMobx.c_cardNameAdvanceStage;
    const c_cardNameDealShaping = this.props.DatabaseMobx.c_cardNameDealShaping;
    const c_cardNameTeammates = this.props.DatabaseMobx.c_cardNameTeammates;
    const c_cardNameNotepad = this.props.DatabaseMobx.c_cardNameNotepad;
    const c_userCanEditCaptureCardContentTF = this.props.UserMobx.c_userCanEditCaptureCardContentTF;
    const c_userCaptureTableRowHeightOptionsObj = this.props.UserMobx.c_userCaptureTableRowHeightOptionsObj;
    const c_userCSTEditCellsModeTF = this.props.UserMobx.c_userCSTEditCellsModeTF;

    //if a capture is opened, blank out every cell in every row so that animating the capture opening or closing it and returning to the table is not slow (plus the current scroll down in the capture table is maintained for clicking on multiple captures back to back)
    if(c_singleCaptureIsOpenTF) {
      return(null);
    }

    const valueMaskPlainText = p_cstMaskedCaptureValuesObj[p_expandedCstColumnObj.capture_field_id + "MASKPT"];

    //(favorite/priority) direct edit field within a cell (can't direct edit when in compressed rows view, too small to draw edit in cell)
    if(p_expandedCstColumnObj.fieldExistsTF) {
      if(p_expandedCstColumnObj.captureFavoritesTF) {
        const favoriteValueRaw = p_cstMaskedCaptureValuesObj[p_expandedCstColumnObj.capture_field_id + "RAW"];
        return(
          <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:p_expandedCstColumnObj.width_em + "em"}}>
            <CEGeneralReact.InputCaptureFavorite
              p_favoriteTF={favoriteValueRaw}
              p_standardSizeTrueCSTCellSizeFalse={(c_userCaptureTableRowHeightOptionsObj.cellCaptureFavoritesDirectEditSizeEm === undefined)}
              f_onClick={((c_userCanEditCaptureCardContentTF) ? (this.onselect_cst_capture_favorite_or_priority_level) : (undefined))}
            />
          </div>
        );
      }
      else if(p_expandedCstColumnObj.capturePriorityLevelTF && c_userCaptureTableRowHeightOptionsObj.cellCapturePriorityDirectEditTF) {
        const priorityValueRaw = p_cstMaskedCaptureValuesObj[p_expandedCstColumnObj.capture_field_id + "RAW"];
        return(
          <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:p_expandedCstColumnObj.width_em + "em"}}>
            <CEGeneralReact.GenericInputOrSelectFromInputType
              p_fieldTypeObj={p_expandedCstColumnObj.expandedCaptureFieldMap.get("fieldTypeObj")}
              p_valueRaw={priorityValueRaw}
              f_onChangeOrOnSelect={((c_userCanEditCaptureCardContentTF) ? (this.onselect_cst_capture_favorite_or_priority_level) : (undefined))}
            />
          </div>
        );
      }
    }

    //cell has no click links (except for "website" type fields which still work when in cells)
    var cellValueMask = "";
    var cellContainsClickLinkTF = p_expandedCstColumnObj.websiteTF;
    if(cellContainsClickLinkTF) {
      cellValueMask = p_cstMaskedCaptureValuesObj[p_expandedCstColumnObj.capture_field_id + "MASK"];
    }
    else {
      cellValueMask = p_cstMaskedCaptureValuesObj[p_expandedCstColumnObj.capture_field_id + "MASKNCL"];
    }

    //cell text or html valueMaskNoClickLinks within maxheight or nowrap for cell
    var cellContentComponent = null;
    if(c_userCaptureTableRowHeightOptionsObj.cellTextMaxHeightWrapTrueNowrapFalse) {
      cellContentComponent = (
        <LibraryReact.MaxHeightWrap p_maxHeight={c_userCaptureTableRowHeightOptionsObj.cellTextMaxHeightEm + "em"}>
          {cellValueMask}
        </LibraryReact.MaxHeightWrap>
      );
    }
    else {
      cellContentComponent = (
        <LibraryReact.NowrapEllipsis>
          {cellValueMask}
        </LibraryReact.NowrapEllipsis>
      );
    }

    //edit cells mode turned on (and user is not view only), draw cell with transparent border inner cell that highlights on hover
    if(c_userCSTEditCellsModeTF && c_userCanEditCaptureCardContentTF) {
      const cellIsEditableTF = (p_expandedCstColumnObj.fieldExistsTF && p_expandedCstColumnObj.canEditFieldInCSTCellTF);

      var cellTitle = "";
      if(cellIsEditableTF) {
        if(p_expandedCstColumnObj.fieldIsStageIDTF) {
          cellTitle = "[Click to open the Capture " + c_cardNameAdvanceStage + " Card to advance the " + p_expandedCstColumnObj.fieldDisplayName + "]";
        }
        else if(p_expandedCstColumnObj.fieldIsShapingTotalProgressTF || p_expandedCstColumnObj.fieldIsShapingStageProgressTF) {
          cellTitle = "[Click to open the Capture " + c_cardNameDealShaping + " Card to answer shaping questions that affect the Progress score]";
        }
        else if(p_expandedCstColumnObj.fieldIsPwinTF && c_companyPwinIsCalculatedTF) {
          cellTitle = "[Click to open the Capture " + c_cardNameDealShaping + " Card to answer shaping questions that affect the calculated " + p_expandedCstColumnObj.fieldDisplayName + "]";
        }
        else if(p_expandedCstColumnObj.fieldIsOurPrimeSubTeammateAllocationTF) {
          cellTitle = "[Click to open the Capture " + c_cardNameTeammates + " Card to edit " + p_expandedCstColumnObj.fieldDisplayName + "]";
        }
        else if(p_expandedCstColumnObj.fieldIsRecentPinnedNotestampTF) {
          cellTitle = "[Click to open the Capture " + c_cardNameNotepad + " Card to edit Note Stamps]";
        }
        else {
          cellTitle = "[Click to edit field '" + p_expandedCstColumnObj.fieldDisplayName + "']";
        }
      }
      else {
        cellTitle = "--Field '" + p_expandedCstColumnObj.fieldDisplayName + "' is not editable--";
      }
      cellTitle += "\n\nCapture: '" + p_cstMaskedCaptureValuesObj.captureFullName + "'";
      cellTitle += "\nField: " + p_expandedCstColumnObj.fieldDisplayName;
      cellTitle += "\nValue: " + valueMaskPlainText;

      return(
        <>
          <div
            className={"flex00a displayFlexColumn " + p_expandedCstColumnObj.cstCellAlignClass + " " + ((cellIsEditableTF) ? ("cursorPointer") : ("cursorNotAllowed"))}
            style={{flexBasis:p_expandedCstColumnObj.width_em + "em"}}
            title={cellTitle}
            onClick={((cellIsEditableTF) ? (this.onclick_edit_cell) : (undefined))}>
            <div className={"flex11a displayFlexRowVc lrMedPad border2transparent " + ((cellIsEditableTF) ? ("hoverBorderColorBlue hoverLightestBlue") : ("hoverBorderColorGray hoverLightGray"))}>
              {cellContentComponent}
            </div>
          </div>
          {(s_editCellFloatingBoxIsOpenTF) &&
            <CaptureTableEditingCellFloatingBox
              p_expandedCstColumnObj={p_expandedCstColumnObj}
              p_cstMaskedCaptureValuesObj={p_cstMaskedCaptureValuesObj}
              f_onClickClose={this.onclick_close_edit_cell_floating_box}
            />
          }
        </>
      );
    }

    //normal CST cells (edit cells mode switched off) containing maxHeight or nowrap text
    var normalCstCellHoverText = "[Click to open Capture]";
    normalCstCellHoverText += "\n\nCapture: '" + p_cstMaskedCaptureValuesObj.captureFullName + "'";
    normalCstCellHoverText += "\nField: " + p_expandedCstColumnObj.fieldDisplayName;
    normalCstCellHoverText += "\nValue: " + valueMaskPlainText;

    return(
      <div
        className={"flex00a displayFlexRowVc lrMedPad " + p_expandedCstColumnObj.cstCellAlignClass + " cursorPointer"}
        style={{flexBasis:p_expandedCstColumnObj.width_em + "em"}}
        title={normalCstCellHoverText}
        onClick={this.onclick_open_capture}>
        {cellContentComponent}
      </div>
    );
  }
}));


const CaptureTableEditingCellFloatingBox = inject("CapturesMobx", "OpenCaptureMobx", "DatabaseMobx")(observer(
class CaptureTableEditingCellFloatingBox extends Component {  //props: p_expandedCstColumnObj, p_cstMaskedCaptureValuesObj, f_onClickClose
  componentDidMount() {
    const p_expandedCstColumnObj = this.props.p_expandedCstColumnObj;
    const p_cstMaskedCaptureValuesObj = this.props.p_cstMaskedCaptureValuesObj;

    const captureCellFieldInitialValueRaw = p_cstMaskedCaptureValuesObj[p_expandedCstColumnObj.capture_field_id + "RAW"];

    //load the raw value into the temp var for inline edit changes before saving
    this.onchange_cell_value(captureCellFieldInitialValueRaw);

    //if this capture field is a 'textarea' input type, fetch the full text value for this capture/field from the database (display waiting animation while fetching), needed because only slim first 100 chars with "..." are loaded at login for each capture in the capture table
    if(p_expandedCstColumnObj.textareaTF) {
      if(JSFUNC.string_is_filled_out_tf(captureCellFieldInitialValueRaw)) { //no need to fetch the full text if the slim value is "", the full textarea will also be ""
        this.props.CapturesMobx.a_capture_table_inline_edit_load_single_cell_full_textarea_from_capture_id_and_field_db_name(p_cstMaskedCaptureValuesObj.id, p_expandedCstColumnObj.fieldDbName, captureCellFieldInitialValueRaw);
      }
    }
  }

  onchange_cell_value = (i_newValue) => {
    this.props.CapturesMobx.a_set_capture_table_inline_edit_single_cell_value_raw(i_newValue);
  }

  onclick_cell_details_field_floating_box_save = () => {
    const o_captureTableInlineEditSingleCellValueRaw = this.props.CapturesMobx.o_captureTableInlineEditSingleCellValueRaw;
    this.onclick_save_edited_cell_value_to_capture(o_captureTableInlineEditSingleCellValueRaw);
  }

  onclick_save_edited_cell_value_to_capture = (i_updatedCellValueRaw) => {
    const p_expandedCstColumnObj = this.props.p_expandedCstColumnObj;
    const p_cstMaskedCaptureValuesObj = this.props.p_cstMaskedCaptureValuesObj;

    const captureID = p_cstMaskedCaptureValuesObj.id;
    const captureFullName = p_cstMaskedCaptureValuesObj.captureFullName;
    const valueRaw = p_cstMaskedCaptureValuesObj[p_expandedCstColumnObj.capture_field_id + "RAW"];

    //check if updated value is different from initial value (handled in CaptureFieldValueEditSaveCancel, but not this details updater)
    if(i_updatedCellValueRaw !== valueRaw) {
      if(p_expandedCstColumnObj.fieldExistsTF) {
        const functionOnVerifiedError = () => {
          alert("The previous edit was not successfully saved. Please log out and log back in and retry.\n - Capture: " + captureFullName + "\n - Field: " + p_expandedCstColumnObj.fieldDisplayName);
        }
        this.props.OpenCaptureMobx.a_details_update_field_value(p_expandedCstColumnObj.expandedCaptureFieldMap, i_updatedCellValueRaw, captureID, undefined, true, true, undefined, functionOnVerifiedError);
      }
    }

    if(JSFUNC.is_function(this.props.f_onClickClose)) {
      this.props.f_onClickClose();
    }
  }

  render() {
    const p_expandedCstColumnObj = this.props.p_expandedCstColumnObj;
    const p_cstMaskedCaptureValuesObj = this.props.p_cstMaskedCaptureValuesObj;
    
    const o_captureTableInlineEditSingleCellValueRaw = this.props.CapturesMobx.o_captureTableInlineEditSingleCellValueRaw;
    const o_captureTableInlineEditSingleCellFullTextareaIsLoadingTF = this.props.CapturesMobx.o_captureTableInlineEditSingleCellFullTextareaIsLoadingTF;

    if(p_expandedCstColumnObj.cellEditFloatingBoxContactsTF) {
      return(
        <CEGeneralReact.SelectOrSelectMultiContactsFloatingBoxFromFieldTypeObj
          p_fieldTypeObj={p_expandedCstColumnObj.expandedCaptureFieldMap.get("fieldTypeObj")}
          p_valueRaw={o_captureTableInlineEditSingleCellValueRaw}
          p_valuesToNotIncludeArray={undefined}
          p_contactsZoomedCompanyID={undefined}
          p_floatingBoxTitle={"Editing field " + p_expandedCstColumnObj.fieldDisplayName + " in Capture '" + p_cstMaskedCaptureValuesObj.captureFullName + "'"}
          f_onSaveChanged={this.onclick_save_edited_cell_value_to_capture}
          f_onCancel={this.props.f_onClickClose}
        />
      );
    }

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag={p_expandedCstColumnObj.cellEditFloatingBoxTrblFlag}
        p_title={"Editing Capture '" + p_cstMaskedCaptureValuesObj.captureFullName + "'"}
        f_onClickSave={((o_captureTableInlineEditSingleCellFullTextareaIsLoadingTF) ? (undefined) : (this.onclick_cell_details_field_floating_box_save))}
        f_onClickCancel={this.props.f_onClickClose}>
        <LibraryReact.InteractiveDiv
          p_class="flex11a displayFlexColumn tbPad lrMedPad yScroll"
          f_onKeyDownEnter={((o_captureTableInlineEditSingleCellFullTextareaIsLoadingTF || p_expandedCstColumnObj.textareaTF) ? (undefined) : (this.onclick_cell_details_field_floating_box_save))}
          f_onKeyDownEsc={this.props.f_onClickClose}>
          <div className="flex00a smallBottomMargin">
            <font className="fontBlue">
              {p_expandedCstColumnObj.fieldDisplayName}
            </font>
          </div>
          <div
            className="flex00a displayFlexColumn border1ddd bgCaptureItemEditing smallFullPad"
            style={{maxWidth:p_expandedCstColumnObj.recommendedEditMaxWidthOrUndefined, height:((p_expandedCstColumnObj.textareaTF) ? ("90%") : (undefined))}}>
            {(o_captureTableInlineEditSingleCellFullTextareaIsLoadingTF) ? (
              <div className="displayFlexColumnHcVc textCenter">
                <div className="flex00a smallBottomMargin">
                  <font className="fontItalic fontTextLight">
                    {"Loading full text for '" + p_expandedCstColumnObj.fieldDisplayName + "'"}
                  </font>
                </div>
                <CEGeneralReact.LoadingAnimation />
              </div>
            ) : (
              <CEGeneralReact.GenericInputOrSelectFromInputType
                p_fieldTypeObj={p_expandedCstColumnObj.expandedCaptureFieldMap.get("fieldTypeObj")}
                p_valueRaw={o_captureTableInlineEditSingleCellValueRaw}
                p_valuesToNotIncludeArray={undefined}
                p_selectInitOptionsBoxOpenTF={true}
                p_selectedDisplayFocusOnKeyDownEnterOpensSelectTF={false}
                p_tabIndex={1}
                f_onChangeOrOnSelect={this.onchange_cell_value}
                f_onKeyDownEnter={this.onclick_cell_details_field_floating_box_save}
              />
            )}
          </div>
          <div className="medTopMargin" />
        </LibraryReact.InteractiveDiv>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));







//======================================================================================================================================
//======================================================================================================================================
//Stage View
//======================================================================================================================================
//======================================================================================================================================
const StageOrPriorityView = inject("CapturesMobx", "DatabaseMobx", "UserMobx")(observer(
class StageOrPriorityView extends Component { //props: p_capturesViewFlag
  onclick_stage_view_capture_type_checkbox_tab = (i_selectedCaptureTypeIDsComma) => {
    this.props.UserMobx.a_update_logged_in_user_per_email_field("stage_view_selected_capture_type_ids_comma", i_selectedCaptureTypeIDsComma, "s");
  }

  onclick_expand_all_stages = () => {
    const stageIDsArray = JSFUNC.get_column_vector_from_arrayOfObjs(this.props.CapturesMobx.c_stageViewSelectedCaptureTypesStagesArrayOfObjs, "id");
    var minimizedStageIDsArray = this.props.UserMobx.c_userStageViewMinimizedStageIDsArray;
    for(let stageID of stageIDsArray) {
      minimizedStageIDsArray = JSFUNC.remove_all_values_from_array(stageID, minimizedStageIDsArray);
    }
    const minimizedStageIDsComma = JSFUNC.convert_array_to_comma_list(minimizedStageIDsArray);
    this.props.UserMobx.a_update_logged_in_user_per_email_field("stage_view_minimized_stage_ids_comma", minimizedStageIDsComma, "s");
  }

  onclick_collapse_all_stages = () => {
    const stageIDsArray = JSFUNC.get_column_vector_from_arrayOfObjs(this.props.CapturesMobx.c_stageViewSelectedCaptureTypesStagesArrayOfObjs, "id");
    var minimizedStageIDsArray = this.props.UserMobx.c_userStageViewMinimizedStageIDsArray;
    for(let stageID of stageIDsArray) {
      minimizedStageIDsArray = JSFUNC.merge_unique(stageID, minimizedStageIDsArray);
    }
    const minimizedStageIDsComma = JSFUNC.convert_array_to_comma_list(minimizedStageIDsArray);
    this.props.UserMobx.a_update_logged_in_user_per_email_field("stage_view_minimized_stage_ids_comma", minimizedStageIDsComma, "s");
  }

  onclick_show_all_captures = () => {
    const maxTrueResetFalse = true;
    const viewIsProgressChartTF = false;
    this.props.CapturesMobx.a_set_cst_or_chart_max_num_captures_drawn(maxTrueResetFalse, viewIsProgressChartTF);
  }

  render() {
    const p_capturesViewFlag = this.props.p_capturesViewFlag;

    const o_cstOrChartMaxNumCapturesDrawn = this.props.CapturesMobx.o_cstOrChartMaxNumCapturesDrawn;
    const c_selectedQuickAccessExpandedCaptureTableMasterPresetObj = this.props.CapturesMobx.c_selectedQuickAccessExpandedCaptureTableMasterPresetObj;
    const c_stageViewSelectedCaptureTypesStagesArrayOfObjs = this.props.CapturesMobx.c_stageViewSelectedCaptureTypesStagesArrayOfObjs;
    const c_stageViewAtLeast1CaptureInSelectedCaptureTypeTF = this.props.CapturesMobx.c_stageViewAtLeast1CaptureInSelectedCaptureTypeTF;
    const c_stageViewAtLeast1StageHasMoreCapturesThanLimitTF = this.props.CapturesMobx.c_stageViewAtLeast1StageHasMoreCapturesThanLimitTF;
    const c_stageViewCaptureTypeFieldDisplayNameWithSelectedCaptureTypeName = this.props.CapturesMobx.c_stageViewCaptureTypeFieldDisplayNameWithSelectedCaptureTypeName;
    const c_priorityViewAllPriorityColumnsOfLimitedCapturesArrayOfObjs = this.props.CapturesMobx.c_priorityViewAllPriorityColumnsOfLimitedCapturesArrayOfObjs;
    const c_priorityViewAtLeast1CaptureTF = this.props.CapturesMobx.c_priorityViewAtLeast1CaptureTF;
    const c_priorityViewAtLeast1PriorityHasMoreCapturesThanLimitTF = this.props.CapturesMobx.c_priorityViewAtLeast1PriorityHasMoreCapturesThanLimitTF;
    const c_numFilteredCaptures = this.props.CapturesMobx.c_numFilteredCaptures;
    const c_fieldMapOfCaptureType = this.props.DatabaseMobx.c_fieldMapOfCaptureType;
    const c_fieldMapOfCapturePriorityLevel = this.props.DatabaseMobx.c_fieldMapOfCapturePriorityLevel;
    const c_captureTypeIDsArray = this.props.DatabaseMobx.c_captureTypeIDsArray;
    const c_captureTypeNamesArray = this.props.DatabaseMobx.c_captureTypeNamesArray;
    const c_combinedUserObj = this.props.UserMobx.c_combinedUserObj;
    const c_userStageViewSelectedCaptureTypeIDsArray = this.props.UserMobx.c_userStageViewSelectedCaptureTypeIDsArray;

    //stage vs priority vars
    const stageViewTF = (p_capturesViewFlag === "stage");
    const priorityViewTF = (p_capturesViewFlag === "priority");
    var stageOrPriorityColumnsOfLimitedCapturesArrayOfObjs = [];
    var viewAtLeast1CaptureTF = false;
    var viewAtLeast1StageOrPriorityHasMoreCapturesThanLimitTF = false;
    if(stageViewTF) {
      stageOrPriorityColumnsOfLimitedCapturesArrayOfObjs = c_stageViewSelectedCaptureTypesStagesArrayOfObjs;
      viewAtLeast1CaptureTF = c_stageViewAtLeast1CaptureInSelectedCaptureTypeTF;
      viewAtLeast1StageOrPriorityHasMoreCapturesThanLimitTF = c_stageViewAtLeast1StageHasMoreCapturesThanLimitTF;
    }
    else if(priorityViewTF) {
      stageOrPriorityColumnsOfLimitedCapturesArrayOfObjs = c_priorityViewAllPriorityColumnsOfLimitedCapturesArrayOfObjs;
      viewAtLeast1CaptureTF = c_priorityViewAtLeast1CaptureTF;
      viewAtLeast1StageOrPriorityHasMoreCapturesThanLimitTF = c_priorityViewAtLeast1PriorityHasMoreCapturesThanLimitTF;
    }

    const captureTypeFieldDisplayName = c_fieldMapOfCaptureType.get("display_name");
    const userNumCaptureTypesSelected = c_userStageViewSelectedCaptureTypeIDsArray.length;
    const selectedCaptureTypeHas0StagesTF = (stageOrPriorityColumnsOfLimitedCapturesArrayOfObjs.length === 0);

    var selectCaptureTypeTopBarComponent = null;
    if(stageViewTF) {
      const selectAStageViewLabelTitle = undefined;//"Each different " + captureTypeFieldDisplayName + " set up by your " + c_productStylingObj.c_productStylingObjproductName + " Admin can have a different timeline of Stages";
      selectCaptureTypeTopBarComponent = (
        <div className="flex00a displayFlexRow smallTopMargin lrMargin border bevelBorderDarkColors bgDarkGray" style={{height:"4.2em"}}>
          <div
            className="flex00a displayFlexColumnVc lrPad"
            style={{flexBasis:"11em"}}
            title={selectAStageViewLabelTitle}>
            <font className="fontItalic fontAlmostWhite">
              {"Select a " + captureTypeFieldDisplayName + " for Stage View"}
            </font>
          </div>
          <div className="flex11a displayFlexColumnVc lrMedPad xScroll">
            <CEGeneralReact.TabsList
              p_canMultiSelectTabsFromSelectedDbNamesCommaTF={true}
              p_tabDbNamesArray={c_captureTypeIDsArray}
              p_tabDisplayNamesArray={c_captureTypeNamesArray}
              p_selectedTabDbName={c_combinedUserObj.stage_view_selected_capture_type_ids_comma}
              p_tabHeight="2.7em"
              p_textMaxHeight="2.4em"
              p_tabWidth="10em"
              p_unselectedFontClass="fontBold"
              p_unselectedBgClass="bgLighterGrayGradient hoverLighterBlueGradient fontTextLight"
              p_selectedBgClass="bgOrangeGradient"
              f_onSelect={this.onclick_stage_view_capture_type_checkbox_tab}
            />
          </div>
          {(JSFUNC.is_array_not_empty(c_stageViewSelectedCaptureTypesStagesArrayOfObjs)) &&
            <div className="flex00a displayFlexColumnHcVc lrPad">
              <div
                className="flex00a displayFlexRowVc cursorPointer"
                title="Expand All Stages"
                onClick={this.onclick_expand_all_stages}>
                <div className="flex00a smallRightMargin" style={{flexBasis:"6em", whiteSpace:"nowrap"}}>
                  <font className="fontAlmostWhite">Expand All</font>
                </div>
                <div className="displayFlexColumnHcVc border bevelBorderDarkColors borderRadius10 bgLightesterGrayGradient hoverBgWhite textCenter" style={{width:"1.3em", height:"1.2em"}}>
                  <font>+</font>
                </div>
              </div>
              <div
                className="flex00a displayFlexRowVc smallTopMargin cursorPointer"
                style={{marginTop:"0.15em"}}
                title="Collapse All Stages"
                onClick={this.onclick_collapse_all_stages}>
                <div className="flex00a smallRightMargin" style={{flexBasis:"6em", whiteSpace:"nowrap"}}>
                  <font className="fontAlmostWhite">Collapse All</font>
                </div>
                <div className="displayFlexColumnHcVc border bevelBorderDarkColors borderRadius10 bgLightesterGrayGradient hoverBgWhite textCenter" style={{width:"1.3em", height:"1.2em"}}>
                  <font>-</font>
                </div>
              </div>
            </div>
          }
        </div>
      );
    }

    var stageViewContentComponent = null;
    if(stageViewTF && (userNumCaptureTypesSelected === 0)) {
      stageViewContentComponent = (
        <CEGeneralReact.EmptyScreenGray p_fontClass="font12">
          {"Select at least 1 " + captureTypeFieldDisplayName + " above to view its Captures"}
        </CEGeneralReact.EmptyScreenGray>
      );
    }
    else if(selectedCaptureTypeHas0StagesTF) {
      var zeroCategoriesErrorMessage = "";
      if(stageViewTF) {
        zeroCategoriesErrorMessage = c_stageViewCaptureTypeFieldDisplayNameWithSelectedCaptureTypeName + " has 0 Stages";
      }
      else if(priorityViewTF) {
        zeroCategoriesErrorMessage = "'" + c_fieldMapOfCapturePriorityLevel.get("display_name") + "' field does not have any categories set up by the Admin";
      }

      stageViewContentComponent = (
        <CEGeneralReact.EmptyScreenGray p_fontClass="font12">
          {zeroCategoriesErrorMessage}
        </CEGeneralReact.EmptyScreenGray>
      );
    }
    else {
      const stageColumnsWithCaptureBlocksComponent = (
        stageOrPriorityColumnsOfLimitedCapturesArrayOfObjs.map((m_stageViewExpandedStageObj, m_index) =>
          <StageViewStageColumnWithCaptureBlocks
            key={m_stageViewExpandedStageObj.id}
            p_capturesViewFlag={p_capturesViewFlag}
            p_stageViewExpandedStageObj={m_stageViewExpandedStageObj}
            p_isFirstStageTF={(m_index === 0)}
          />
        )
      );

      if(viewAtLeast1CaptureTF) { //Stages with Captures and 'show all' button at bottom
        stageViewContentComponent = (
          <div className="flex11a xyScroll">
            <div className="displayFlexRow lrPad medBottomPad">
              {stageColumnsWithCaptureBlocksComponent}
            </div>
            {(viewAtLeast1StageOrPriorityHasMoreCapturesThanLimitTF) &&
              <ShowAllCapturesButtonAndMessage
                p_numFilteredCaptures={c_numFilteredCaptures}
                p_maxNumCapturesDrawn={o_cstOrChartMaxNumCapturesDrawn}
                f_onClickShowAllCaptures={this.onclick_show_all_captures}
              />
            }
          </div>
        );
      }
      else { //0 Captures, show Stages across top with no Captures, full blank screen with 0 Captures message
        stageViewContentComponent = (
          <>
            <div className="flex00a displayFlexRow lrPad smallBottomPad xyScroll">
              {stageColumnsWithCaptureBlocksComponent}
            </div>
            <CEGeneralReact.EmptyScreenGray p_fontClass="font12">
              <div>
                {"0 captures using filter '" + c_selectedQuickAccessExpandedCaptureTableMasterPresetObj.name + "'"}
              </div>
              {(stageViewTF) &&
                <div>
                  {"(when combined with selected " + c_stageViewCaptureTypeFieldDisplayNameWithSelectedCaptureTypeName + ")"}
                </div>
              }
              {(priorityViewTF) &&
                <div>
                  {"(with field '" + c_fieldMapOfCapturePriorityLevel.get("display_name") + "' filled out)"}
                </div>
              }
            </CEGeneralReact.EmptyScreenGray>
          </>
        );
      }
    }

    return(
      <>
        {selectCaptureTypeTopBarComponent}
        {stageViewContentComponent}
      </>
    );
  }
}));


const StageViewStageColumnWithCaptureBlocks = inject("CapturesMobx", "DatabaseMobx", "UserMobx")(observer(
class StageViewStageColumnWithCaptureBlocks extends Component { //props: p_capturesViewFlag, p_stageViewExpandedStageObj, p_isFirstStageTF
  render() {
    const p_capturesViewFlag = this.props.p_capturesViewFlag;
    const p_stageViewExpandedStageObj = this.props.p_stageViewExpandedStageObj;
    const p_isFirstStageTF = this.props.p_isFirstStageTF;

    const c_cstSortedFilteredMaskedCaptureValuesArrayOfObjs = this.props.CapturesMobx.c_cstSortedFilteredMaskedCaptureValuesArrayOfObjs;
    const c_fieldMapOfStage = this.props.DatabaseMobx.c_fieldMapOfStage;
    const c_fieldMapOfCapturePriorityLevel = this.props.DatabaseMobx.c_fieldMapOfCapturePriorityLevel;
    const c_userStageViewMinimizedStageIDsArray = this.props.UserMobx.c_userStageViewMinimizedStageIDsArray;
    const c_userPriorityViewMinimizedPriorityIDsArray = this.props.UserMobx.c_userPriorityViewMinimizedPriorityIDsArray;
    
    var viewMinimizedItemIDsCommaUpeFieldDbName = "stage_view_minimized_stage_ids_comma";
    var userViewMinimizedItemIDsArray = c_userStageViewMinimizedStageIDsArray;
    var stageTimelineStageCustomTitle = c_fieldMapOfStage.get("display_name") + " '" + p_stageViewExpandedStageObj.name + "'";
    if(p_capturesViewFlag === "priority") {
      viewMinimizedItemIDsCommaUpeFieldDbName = "priority_view_minimized_priority_ids_comma";
      userViewMinimizedItemIDsArray = c_userPriorityViewMinimizedPriorityIDsArray;
      stageTimelineStageCustomTitle = c_fieldMapOfCapturePriorityLevel.get("display_name") + " '" + p_stageViewExpandedStageObj.name + "'";
    }

    const stageIsMinimizedTF = JSFUNC.in_array(p_stageViewExpandedStageObj.id, userViewMinimizedItemIDsArray);
    
    const stageBorderHashColor = "#30363c";

    var stageWidth = "16em";
    var marginLeft = "0.4em";
    var marginRight = "0.4em";
    if(stageIsMinimizedTF) {
      stageWidth = "1.4em";
      marginLeft = undefined;
      marginRight = undefined;
    }

    if(p_isFirstStageTF) {
      marginLeft = undefined;
    }

    return(
      <div className="flex00a" style={{flexBasis:stageWidth, marginLeft:marginLeft, marginRight:marginRight}}>
        <StageViewMinimizeMaximizeButton
          p_viewMinimizedItemIDsCommaUpeFieldDbName={viewMinimizedItemIDsCommaUpeFieldDbName}
          p_userViewMinimizedItemIDsArray={userViewMinimizedItemIDsArray}
          p_stageViewExpandedStageObj={p_stageViewExpandedStageObj}
          p_stageIsMinimizedTF={stageIsMinimizedTF}
        />
        <div className="displayFlexColumn overflowHidden" style={{width:stageWidth, height:"4em"}}>
          <OpenCaptureReact.StageTimelineStage
            p_stageObj={p_stageViewExpandedStageObj}
            p_minimizedStageTF={stageIsMinimizedTF}
            p_advanceColorIsStageColorTF={true}
            p_customBorderHashColor={stageBorderHashColor}
            p_customTitle={stageTimelineStageCustomTitle}
          />
        </div>
        {(!stageIsMinimizedTF) &&
          <>
            {c_cstSortedFilteredMaskedCaptureValuesArrayOfObjs.map((m_cstMaskedCaptureValuesObj) =>
              (JSFUNC.in_array(m_cstMaskedCaptureValuesObj.id, p_stageViewExpandedStageObj.limitedOrAllStageCaptureIDsArray)) &&
              <StageViewSingleCaptureBlock
                p_cstMaskedCaptureValuesObj={m_cstMaskedCaptureValuesObj}
              />
            )}
          </>
        }
        <div style={{height:"2em"}} />
      </div>
    );
  }
}));


const StageViewMinimizeMaximizeButton = inject("DatabaseMobx", "UserMobx")(observer(
class StageViewMinimizeMaximizeButton extends Component { //props: p_viewMinimizedItemIDsCommaUpeFieldDbName, p_userViewMinimizedItemIDsArray, p_stageViewExpandedStageObj, p_stageIsMinimizedTF
  onclick_minimize = () => {
    const p_viewMinimizedItemIDsCommaUpeFieldDbName = this.props.p_viewMinimizedItemIDsCommaUpeFieldDbName;
    const p_userViewMinimizedItemIDsArray = this.props.p_userViewMinimizedItemIDsArray;
    const p_stageViewExpandedStageObj = this.props.p_stageViewExpandedStageObj;

    const updatedMinimizedStageIDsArray = JSFUNC.merge_unique(p_stageViewExpandedStageObj.id, p_userViewMinimizedItemIDsArray);
    const updatedMinimizedStageIDsComma = JSFUNC.convert_array_to_comma_list(updatedMinimizedStageIDsArray);
    this.props.UserMobx.a_update_logged_in_user_per_email_field(p_viewMinimizedItemIDsCommaUpeFieldDbName, updatedMinimizedStageIDsComma, "s");
  }

  onclick_maximize = () => {
    const p_viewMinimizedItemIDsCommaUpeFieldDbName = this.props.p_viewMinimizedItemIDsCommaUpeFieldDbName;
    const p_userViewMinimizedItemIDsArray = this.props.p_userViewMinimizedItemIDsArray;
    const p_stageViewExpandedStageObj = this.props.p_stageViewExpandedStageObj;

    const updatedMinimizedStageIDsArray = JSFUNC.remove_all_values_from_array(p_stageViewExpandedStageObj.id, p_userViewMinimizedItemIDsArray);
    const updatedMinimizedStageIDsComma = JSFUNC.convert_array_to_comma_list(updatedMinimizedStageIDsArray);
    this.props.UserMobx.a_update_logged_in_user_per_email_field(p_viewMinimizedItemIDsCommaUpeFieldDbName, updatedMinimizedStageIDsComma, "s");
  }

  render() {
    const p_stageViewExpandedStageObj = this.props.p_stageViewExpandedStageObj;
    const p_stageIsMinimizedTF = this.props.p_stageIsMinimizedTF;

    const c_fieldMapOfStage = this.props.DatabaseMobx.c_fieldMapOfStage;

    return(
      <div className="displayFlexRow" style={{padding:"0.1em 0"}}>
        <div
          className="flex00a cursorPointer"
          title={"Click to " + ((p_stageIsMinimizedTF) ? ("unhide") : ("hide")) + " " + c_fieldMapOfStage.get("display_name") + " '" + p_stageViewExpandedStageObj.name + "'"}
          onClick={((p_stageIsMinimizedTF) ? (this.onclick_maximize) : (this.onclick_minimize))}>
          <div
            className="displayFlexColumnHcVc border bevelBorderDarkColors borderRadius10 bgLightesterGrayGradient hoverBgWhite textCenter"
            style={{width:"1.3em", height:"1.2em"}}>
            <font className="">
              {((p_stageIsMinimizedTF) ? ("+") : ("-"))}
            </font>
          </div>
        </div>
        <div className="flex11a" />
      </div>
    );
  }
}));


function StageViewMinimizedStage(props) { //props: p_stageViewExpandedStageObj, p_customBorderHashColor
  const p_stageViewExpandedStageObj = props.p_stageViewExpandedStageObj;
  const p_customBorderHashColor = props.p_customBorderHashColor;

  return(
    <div className="flex11a displayFlexColumn" style={{margin:"0 0.1em", border:"solid 2px " + p_customBorderHashColor}}>
      <div className="flex11a bgWhite" />
      <div className="flex00a" style={{flexBasis:"0.3em", background:"#" + p_stageViewExpandedStageObj.color}} />
    </div>
  );
}


const StageViewSingleCaptureBlock = inject("OpenCaptureMobx", "DatabaseMobx", "UserMobx")(observer(
class StageViewSingleCaptureBlock extends Component { //props: p_cstMaskedCaptureValuesObj
  onclick_stage_view_capture = () => {
    const p_cstMaskedCaptureValuesObj = this.props.p_cstMaskedCaptureValuesObj;
    this.props.OpenCaptureMobx.a_open_single_capture(p_cstMaskedCaptureValuesObj.id);
  }

  render() {
    const p_cstMaskedCaptureValuesObj = this.props.p_cstMaskedCaptureValuesObj;

    const c_companyUsingPwinTF = this.props.DatabaseMobx.c_companyUsingPwinTF;
    const c_fieldMapOfCaptureManagers = this.props.DatabaseMobx.c_fieldMapOfCaptureManagers;
    const c_fieldMapOfDivisionOwners = this.props.DatabaseMobx.c_fieldMapOfDivisionOwners;
    const c_fieldMapOfContractRevenueValue = this.props.DatabaseMobx.c_fieldMapOfContractRevenueValue;
    const c_fieldMapOfShapingTotalProgress = this.props.DatabaseMobx.c_fieldMapOfShapingTotalProgress;
    const c_fieldMapOfPwin = this.props.DatabaseMobx.c_fieldMapOfPwin;
    const c_fieldMapOfRFPDate = this.props.DatabaseMobx.c_fieldMapOfRFPDate;
    const c_fieldMapOfProposalDueDateTimeUtc = this.props.DatabaseMobx.c_fieldMapOfProposalDueDateTimeUtc;
    const c_userStageViewBoxSize = this.props.UserMobx.c_userStageViewBoxSize;

    const captureMapOrUndefined = this.props.DatabaseMobx.o_tbl_captures.get(p_cstMaskedCaptureValuesObj.id);

    const contractRevenueValueRaw = this.props.DatabaseMobx.capture_value_raw_or_undefined_from_capture_map_and_expanded_capture_field_map(captureMapOrUndefined, c_fieldMapOfContractRevenueValue);
    var contractRevenueValueShortPlainText = "--";
    if(contractRevenueValueRaw !== undefined) {
      contractRevenueValueShortPlainText = JSFUNC.money_short(contractRevenueValueRaw, true);
    }
    
    const shapingTotalProgressValueRaw = this.props.DatabaseMobx.capture_value_raw_or_undefined_from_capture_map_and_expanded_capture_field_map(captureMapOrUndefined, c_fieldMapOfShapingTotalProgress);
    const shapingTotalProgressValueMask = this.props.DatabaseMobx.progress_bar_html_from_percent_and_size_em(shapingTotalProgressValueRaw, 1.3);
    const shapingTotalProgressValueMaskPlainText = this.props.DatabaseMobx.value_mask_plaintext_from_value_raw_and_field_type_obj(shapingTotalProgressValueRaw, c_fieldMapOfPwin.get("fieldTypeObj"));

    const pwinValueRaw = this.props.DatabaseMobx.capture_value_raw_or_undefined_from_capture_map_and_expanded_capture_field_map(captureMapOrUndefined, c_fieldMapOfPwin);
    const pwinValueMask = this.props.DatabaseMobx.pwin_cube_svg_html_from_percent_and_size_em(pwinValueRaw, 2);
    const pwinValueMaskPlainText = this.props.DatabaseMobx.value_mask_plaintext_from_value_raw_and_field_type_obj(pwinValueRaw, c_fieldMapOfPwin.get("fieldTypeObj"));

    const clickToOpenCaptureTitle = "[Click to open Capture '" + p_cstMaskedCaptureValuesObj.captureFullName + "']";

    var boxHeightEm = 10;
    var marginTopEm = 0.4;
    if(c_userStageViewBoxSize === 1) {
      boxHeightEm = 5.5;
      marginTopEm = 0.3;
    }
    else if(c_userStageViewBoxSize === 2) {
      boxHeightEm = 8.3;
      marginTopEm = 0.5;
    }
    else if(c_userStageViewBoxSize === 3) {
      boxHeightEm = 11.2;
      marginTopEm = 0.7;
    }
    
    var captureManagersComponent = null;
    var divisionOwnersComponent = null;
    if(c_userStageViewBoxSize >= 2) {
      const captureManagersValueMaskSortIfoObj = this.props.DatabaseMobx.value_mask_sort_ifo_canedit_obj_from_capture_map_and_expanded_capture_field_map(captureMapOrUndefined, c_fieldMapOfCaptureManagers);
      captureManagersComponent = (
        <>
          <div className="" style={{border:"solid 1px #ddd", margin:"0.3em 5% 0 5%"}} />
          <div className="displayFlexRowVc lrPad" style={{marginTop:"0.2em"}} title={c_fieldMapOfCaptureManagers.get("display_name") + ": " + captureManagersValueMaskSortIfoObj.valueMaskPlainText + "\n" + clickToOpenCaptureTitle}>
            <LibraryReact.NowrapEllipsis p_fontClass="font09">
              {captureManagersValueMaskSortIfoObj.valueMask}
            </LibraryReact.NowrapEllipsis>
          </div>
        </>
      );
      
      const divisionOwnersValueMaskSortIfoObj = this.props.DatabaseMobx.value_mask_sort_ifo_canedit_obj_from_capture_map_and_expanded_capture_field_map(captureMapOrUndefined, c_fieldMapOfDivisionOwners);
      divisionOwnersComponent = (
        <div className="displayFlexRowVc lrPad" style={{marginTop:"0.2em"}} title={c_fieldMapOfDivisionOwners.get("display_name") + ": " + divisionOwnersValueMaskSortIfoObj.valueMaskPlainText + "\n" + clickToOpenCaptureTitle}>
          <LibraryReact.NowrapEllipsis p_fontClass="font09">
            {divisionOwnersValueMaskSortIfoObj.valueMask}
          </LibraryReact.NowrapEllipsis>
        </div>
      );
    }

    var lbTeammatesComponent = null;
    var sbTeammatesComponent = null;
    if(c_userStageViewBoxSize === 3) {
      const lbTeammateNamesAndAllocsCommaCodewordReplacementObj = JSPHP.get_codeword_replacement_obj_from_capture_map(true, "@team_all_selected_teammates_list_names_and_allocation_sort_lb_allocation", captureMapOrUndefined);
      lbTeammatesComponent = (
        <>
          <div className="" style={{border:"solid 1px #ddd", margin:"0.3em 5% 0 5%"}} />
          <div className="displayFlexRow" style={{marginTop:"0.2em"}}>
            <div className="flex00a displayFlexRowVc" style={{flexBasis:"1.4em", marginLeft:"0.4em"}}>
              <font className="font09 fontBold fontItalic" style={{color:"#98a"}}>
                {"LB:"}
              </font>
            </div>
            <div className="flex11a displayFlexRowVc lrPad" style={{flexBasis:"100em"}} title={"LB Teammates: " + lbTeammateNamesAndAllocsCommaCodewordReplacementObj.codewordReplacementPlaintext + "\n" + clickToOpenCaptureTitle}>
              <LibraryReact.NowrapEllipsis p_fontClass="font09">
                {lbTeammateNamesAndAllocsCommaCodewordReplacementObj.codewordReplacementPlaintext}
              </LibraryReact.NowrapEllipsis>
            </div>
          </div>
        </>
      );
      
      const sbTeammateNamesAndAllocsCommaCodewordReplacementObj = JSPHP.get_codeword_replacement_obj_from_capture_map(true, "@team_all_selected_teammates_list_names_and_allocation_sort_sb_allocation", captureMapOrUndefined);
      sbTeammatesComponent = (
        <div className="displayFlexRow" style={{marginTop:"0.2em"}}>
          <div className="flex00a displayFlexRowVc" style={{flexBasis:"1.4em", marginLeft:"0.4em"}}>
          <font className="font09 fontBold fontItalic" style={{color:"#8a9"}}>
              {"SB:"}
            </font>
          </div>
          <div className="flex11a displayFlexRowVc lrPad" style={{flexBasis:"100em"}} title={"SB Teammates: " + sbTeammateNamesAndAllocsCommaCodewordReplacementObj.codewordReplacementPlaintext + "\n" + clickToOpenCaptureTitle}>
            <LibraryReact.NowrapEllipsis p_fontClass="font09">
              {sbTeammateNamesAndAllocsCommaCodewordReplacementObj.codewordReplacementPlaintext}
            </LibraryReact.NowrapEllipsis>
          </div>
        </div>
      );
    }

    return(
      <div
        className="border1bbb bgWhite hoverLighterBlueGradient cursorPointer"
        style={{height:boxHeightEm + "em", marginTop:marginTopEm + "em", boxShadow:"0.1em 0.1em 0.4em 0.05em #333"}}
        onClick={this.onclick_stage_view_capture}>
        <div className="bgRedCapture tbMicroPad lrPad" title={p_cstMaskedCaptureValuesObj.captureFullName}>
          <LibraryReact.NowrapEllipsis p_fontClass="fontWhite">
            {p_cstMaskedCaptureValuesObj.captureFullName}
          </LibraryReact.NowrapEllipsis>
        </div>
        <div className="displayFlexRow lrPad overflowHidden" style={{height:"2.5em"}}>
          <div className="flex11a displayFlexColumnHcVc textCenter" style={{flexBasis:"100em"}} title={c_fieldMapOfContractRevenueValue.get("display_name") + ": " + contractRevenueValueShortPlainText + "\n" + clickToOpenCaptureTitle}>
            <LibraryReact.NowrapEllipsis p_fontClass="fontBold fontBlue">
              {contractRevenueValueShortPlainText}
            </LibraryReact.NowrapEllipsis>
          </div>
          <div className="flex00a" style={{flexBasis:"0.8em"}} />
          <div className={"flex11a displayFlexColumnVc " + ((c_companyUsingPwinTF) ? ("") : ("lrPad"))} style={{flexBasis:"100em"}} title={c_fieldMapOfShapingTotalProgress.get("display_name") + ": " + shapingTotalProgressValueMaskPlainText + "\n" + clickToOpenCaptureTitle}>
            {shapingTotalProgressValueMask}
          </div>
          {(c_companyUsingPwinTF) &&
            <>
              <div className="flex00a" style={{flexBasis:"0.8em"}} />
              <div className="flex11a displayFlexColumnHcVc" style={{flexBasis:"100em"}} title={c_fieldMapOfPwin.get("display_name") + ": " + pwinValueMaskPlainText + "\n" + clickToOpenCaptureTitle}>
                {pwinValueMask}
              </div>
            </>
          }
        </div>
        <div className="displayFlexRow">
          <StageViewBlockDate
            p_fieldMap={c_fieldMapOfRFPDate}
            p_captureMap={captureMapOrUndefined}
            p_fieldShortDisplayName="R"
            p_clickToOpenCaptureTitle={clickToOpenCaptureTitle}
          />
          <StageViewBlockDate
            p_fieldMap={c_fieldMapOfProposalDueDateTimeUtc}
            p_captureMap={captureMapOrUndefined}
            p_fieldShortDisplayName="P"
            p_clickToOpenCaptureTitle={clickToOpenCaptureTitle}
          />
        </div>
        {captureManagersComponent}
        {divisionOwnersComponent}
        {lbTeammatesComponent}
        {sbTeammatesComponent}
      </div>
    );
  }
}));


const StageViewBlockDate = inject("DatabaseMobx")(observer(
class StageViewBlockDate extends Component { //props: p_fieldMap, p_captureMap, p_fieldShortDisplayName, p_clickToOpenCaptureTitle
  render() {
    const p_fieldMap = this.props.p_fieldMap;
    const p_captureMap = this.props.p_captureMap;
    const p_fieldShortDisplayName = this.props.p_fieldShortDisplayName;
    const p_clickToOpenCaptureTitle = this.props.p_clickToOpenCaptureTitle;

    const c_genericDateFieldTypeObj = this.props.DatabaseMobx.c_genericDateFieldTypeObj;

    const fieldDisplayName = p_fieldMap.get("display_name");
    const captureValueRaw = this.props.DatabaseMobx.capture_value_raw_or_undefined_from_capture_map_and_expanded_capture_field_map(p_captureMap, p_fieldMap);
    var captureValueRawDate = undefined;
    if(JSFUNC.is_string(captureValueRaw)) {
      captureValueRawDate = captureValueRaw.substring(0, 10);
    }
    const valueMask = this.props.DatabaseMobx.value_mask_from_value_raw_and_field_type_obj(captureValueRawDate, c_genericDateFieldTypeObj);
    const fullValueMaskPlainText = this.props.DatabaseMobx.value_mask_plaintext_from_value_raw_and_field_type_obj(captureValueRaw, p_fieldMap.get("fieldTypeObj"));

    return(
      <>
        <div className="flex00a displayFlexRowVc" style={{flexBasis:"1.3em", marginLeft:"0.4em"}}>
          <font className="font09 fontBold fontItalic fontTextLightest">
            {p_fieldShortDisplayName + ":"}
          </font>
        </div>
        <div
          className="flex11a displayFlexRowVc"
          style={{flexBasis:"100em", marginRight:"0.4em"}}
          title={fieldDisplayName + ": " + fullValueMaskPlainText + "\n" + p_clickToOpenCaptureTitle}>
          <LibraryReact.NowrapEllipsis p_fontClass="font09">
            {valueMask}
          </LibraryReact.NowrapEllipsis>
        </div>
      </>
    );
  }
}));



//======================================================================================================================================
//======================================================================================================================================
//Progress/Gantt Timeline Chart View
//======================================================================================================================================
//======================================================================================================================================
const TimelineChart = inject("CaptureExecMobx", "CapturesMobx", "UserMobx")(observer(
class TimelineChart extends Component { //props: p_ganttTrueProgressFalse
  render() {
    const p_ganttTrueProgressFalse = JSFUNC.prop_value(this.props.p_ganttTrueProgressFalse, true);
    
    const c_isMobileTF = this.props.CaptureExecMobx.c_isMobileTF;
    const c_isTabletTF = this.props.CaptureExecMobx.c_isTabletTF;
    const o_viewIsLoadingTF = this.props.CapturesMobx.o_viewIsLoadingTF;
    const c_ganttHasValidPresetSelectedTF = this.props.CapturesMobx.c_ganttHasValidPresetSelectedTF;
    const c_timelineChartTimeSpanObj = this.props.CapturesMobx.c_timelineChartTimeSpanObj;
    const c_combinedUserObj = this.props.UserMobx.c_combinedUserObj;

    //chart user row height
    var chartUserRowHeightEm = 2;
    if(p_ganttTrueProgressFalse) {
      chartUserRowHeightEm = c_combinedUserObj.capture_chart_gantt_size;
    }
    else {
      chartUserRowHeightEm = c_combinedUserObj.capture_chart_progress_size;
    }

    if(chartUserRowHeightEm <= 1) {
      chartUserRowHeightEm = 1.2;
    }

    //width of the name of the capture column on left side of chart
    var captureNameContainerWidth = "12%";
    if(c_isMobileTF) { captureNameContainerWidth = "20%"; }
    else if(c_isTabletTF) { captureNameContainerWidth = "15%"; }

    //data table or empty screen if there is loading or invalid start/end dates
    var chartCaptureRowsComponent = null;
    if(o_viewIsLoadingTF) {
      const c_numFilteredCaptures = this.props.CapturesMobx.c_numFilteredCaptures;
      chartCaptureRowsComponent = (
        <CEGeneralReact.EmptyScreenGray>
          {"Loading Progress History for " + c_numFilteredCaptures + " " + JSFUNC.plural(c_numFilteredCaptures, "Capture", "Captures") + "..."}
        </CEGeneralReact.EmptyScreenGray>
      );
    }
    else if(!c_timelineChartTimeSpanObj.startDateIsValidTF || !c_timelineChartTimeSpanObj.endDateIsValidTF) {
      chartCaptureRowsComponent = (
        <CEGeneralReact.EmptyScreenGray>
          {"Start/End dates must be set for this chart to display"}
        </CEGeneralReact.EmptyScreenGray>
      );
    }
    else if(p_ganttTrueProgressFalse && !c_ganttHasValidPresetSelectedTF) {
      chartCaptureRowsComponent = (
        <CEGeneralReact.EmptyScreenGray>
          {"Select or create a Gantt Dates Preset to view a Gantt Chart"}
        </CEGeneralReact.EmptyScreenGray>
      );
    }
    else {
      chartCaptureRowsComponent = (
        <TimelineChartCaptureRows p_ganttTrueProgressFalse={p_ganttTrueProgressFalse} p_chartUserRowHeightEm={chartUserRowHeightEm} p_captureNameContainerWidth={captureNameContainerWidth} />
      );
    }

    return(
      <div className="flex11a displayFlexColumn">
        <TimelineControlsAndLegends p_ganttTrueProgressFalse={p_ganttTrueProgressFalse} />
        <MonthLabels p_captureNameContainerWidth={captureNameContainerWidth} />
        {chartCaptureRowsComponent}
      </div>
    );
  }
}));

const TimelineControlsAndLegends = inject("CaptureExecMobx", "CapturesMobx")(observer(
class TimelineControlsAndLegends extends Component { //props: p_ganttTrueProgressFalse
  constructor(props) {
    super(props);
    this.state = {
      s_mobileScreenNum: 1 //1-timeline, 2-gantt dates/progress legends
    }
  }

  onclick_advance_mobile_screen_up = () => {
    const s_mobileScreenNum = this.state.s_mobileScreenNum;
    const updatedMobileScreenNum = ((s_mobileScreenNum <= 1) ? (2) : (s_mobileScreenNum - 1));
    this.setState({s_mobileScreenNum:updatedMobileScreenNum});
  }

  onclick_advance_mobile_screen_down = () => {
    const s_mobileScreenNum = this.state.s_mobileScreenNum;
    const updatedMobileScreenNum = ((s_mobileScreenNum >= 2) ? (1) : (s_mobileScreenNum + 1));
    this.setState({s_mobileScreenNum:updatedMobileScreenNum});
  }

  render() {
    const s_mobileScreenNum = this.state.s_mobileScreenNum;

    const p_ganttTrueProgressFalse = this.props.p_ganttTrueProgressFalse;

    const c_isMobileOrTabletTF = this.props.CaptureExecMobx.c_isMobileOrTabletTF;

    if(c_isMobileOrTabletTF) {
      var currentScreenComponent = null;
      if(s_mobileScreenNum === 1) {
        currentScreenComponent = (<TimelineControlsDates />);
      }
      else if(p_ganttTrueProgressFalse && (s_mobileScreenNum === 2)) {
        currentScreenComponent = (<GanttPresetSelectionAndDatesLegend />);
      }
      else if(!p_ganttTrueProgressFalse && (s_mobileScreenNum === 2)) {
        currentScreenComponent = (<ProgressChartLegends />);
      }

      return(
        <div className="flex00a displayFlexRow" style={{height:"5.9em", background:"#f5f5f5", borderBottom:"solid 1px #ddd"}}>
          <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"3em", backgroundColor:"#ddd", borderRight:"solid 1px #aaa"}}>
            <div className="cursorPointer" onClick={this.onclick_advance_mobile_screen_up}>
              <font className="font14 fontTextLighter">{"\u25B2"}</font>
            </div>
            <div className="microTopPad microBottomPad">
              <font className="fontItalic">{s_mobileScreenNum}</font>
            </div>
            <div className="cursorPointer" onClick={this.onclick_advance_mobile_screen_down}>
              <font className="font14 fontTextLighter">{"\u25BC"}</font>
            </div>
          </div>
          <div className="flex11a displayFlexRow">
            {currentScreenComponent}
          </div>
        </div>
      );
    }

    return(
      <div className="flex00a displayFlexRow borderB1ddd" style={{height:"5.9em", background:"#f5f5f5"}}>
        {(p_ganttTrueProgressFalse) ? (
          <GanttPresetSelectionAndDatesLegend />
        ) : (
          <ProgressChartLegends />
        )}
        <div className="flex11a borderR1ddd" />
        <TimelineControlsDates />
      </div>
    );
  }
}));


const ProgressChartLegends = inject("DatabaseMobx")(observer(
class ProgressChartLegends extends Component { //props:
  render() {
    const c_fieldMapOfStage = this.props.DatabaseMobx.c_fieldMapOfStage;
    const c_companyUsingPwinTF = this.props.DatabaseMobx.c_companyUsingPwinTF;

    const nameColorDataArray = [this.props.DatabaseMobx.c_shapingProgressColorsArrayOfObjs, this.props.DatabaseMobx.c_pwinColorsArrayOfObjs, this.props.DatabaseMobx.c_adminSortedExpandedStagesArrayOfObjs];
    const legendTitlesArray = ["Progress Legend", "PWin Legend", c_fieldMapOfStage.get("display_name") + " Legend"];
    const legendEmptyLabelsArray = ["Admin has not defined progress colors yet", "Admin has not defined PWin colors yet", "Admin has not defined any stages yet"];
    const legendWidthsArray = ["11em", "11em", "16em"];

    //do not include PWin legend if company is not using PWin
    const legendIndicesArray = ((c_companyUsingPwinTF) ? ([0, 1, 2]) : ([0, 2]));

    return(
      legendIndicesArray.map((m_legendIndex) =>
        <TimelineChartLegend
          key={legendTitlesArray[m_legendIndex]}
          p_nameColorDataArrayOfObjsOrUndefined={nameColorDataArray[m_legendIndex]}
          p_itemNameFieldName="name"
          p_label={legendTitlesArray[m_legendIndex]}
          p_emptyLabel={legendEmptyLabelsArray[m_legendIndex]}
          p_width={legendWidthsArray[m_legendIndex]}
        />
      )
    );
  }
}));

const GanttPresetSelectionAndDatesLegend = inject("CapturesMobx", "UserMobx")(observer(
class GanttPresetSelectionAndDatesLegend extends Component { //props:
  onclick_gantt_preset_editor_button = () => {
    this.props.CapturesMobx.a_set_gantt_dates_preset_editor_open_tf(true);
  }

  onselect_gantt_dates_preset = (i_selectedGanttDatesPresetID) => {
    this.props.CapturesMobx.a_select_gantt_dates_preset(i_selectedGanttDatesPresetID);
  }

  render() {
    const c_selectGanttPresetsFieldTypeObj = this.props.CapturesMobx.c_selectGanttPresetsFieldTypeObj;
    const c_ganttSelectedPresetObj = this.props.CapturesMobx.c_ganttSelectedPresetObj;
    const c_combinedUserObj = this.props.UserMobx.c_combinedUserObj;

    return(
      <>
        <div className="flex00a displayFlexColumnHcVc borderR1ddd lrMedPad">
          <div className="displayFlexRowHcVc">
            <div className="flex00a" style={{flexBasis:"3.5em"}}>
              <ButtonCreateEditFilters
                p_sizeEm={2.5}
                p_title="Create/Edit Gantt Date Presets"
                f_onClick={this.onclick_gantt_preset_editor_button}
              />
            </div>
            <div className="flex00a" style={{flexBasis:"8em"}}>
              <font className="fontBold fontTextLighter">
                {"Selected Gantt Dates Preset:"}
              </font>
            </div>
          </div>
          <div className="smallTopMargin" style={{width:"17em"}}>
            <CEGeneralReact.GenericInputOrSelectFromInputType
              p_fieldTypeObj={c_selectGanttPresetsFieldTypeObj}
              p_valueRaw={c_combinedUserObj.gantt_date_preset_id_selected}
              f_onChangeOrOnSelect={this.onselect_gantt_dates_preset}
            />
          </div>
        </div>
        <TimelineChartLegend
          p_nameColorDataArrayOfObjsOrUndefined={((c_ganttSelectedPresetObj !== undefined) ? (c_ganttSelectedPresetObj.ganttDatesArrayOfObjs) : (undefined))}
          p_itemNameFieldName="fieldDisplayName"
          p_label="Gantt Dates Legend"
          p_emptyLabel={(c_combinedUserObj.gantt_date_preset_id_selected > 0) ? ("Preset has no dates added yet") : ("No preset selected")}
          p_width="18em"
        />
      </>
    );
  }
}));

function TimelineChartLegend(props) { //props: p_nameColorDataArrayOfObjsOrUndefined, p_itemNameFieldName, p_label, p_emptyLabel, p_width
  const p_nameColorDataArrayOfObjsOrUndefined = props.p_nameColorDataArrayOfObjsOrUndefined;
  const p_itemNameFieldName = props.p_itemNameFieldName;
  const p_label = props.p_label;
  const p_emptyLabel = props.p_emptyLabel;
  const p_width = props.p_width;

  var nameColorDataArrayOfObjsHasAtLeast1ColorTF = false;
  var timelineChartLegendHoverText = p_label;
  if(!JSFUNC.is_array(p_nameColorDataArrayOfObjsOrUndefined)) {
    timelineChartLegendHoverText += "\n - " + p_emptyLabel;
  }
  else {
    nameColorDataArrayOfObjsHasAtLeast1ColorTF = (p_nameColorDataArrayOfObjsOrUndefined.length > 0);

    for(let nameColorObj of p_nameColorDataArrayOfObjsOrUndefined) {
      timelineChartLegendHoverText += "\n - " + nameColorObj[p_itemNameFieldName];
    }
  }

  return(
    <div
      className="flex00a displayFlexColumn borderR1ddd yScroll"
      style={{flexBasis:p_width}}
      title={timelineChartLegendHoverText}>
      <LibraryReact.DivFont p_class="tbMicroPad textCenter" p_fontClass="font09 fontBold fontTextLight">
        {p_label}
      </LibraryReact.DivFont>
      {(!nameColorDataArrayOfObjsHasAtLeast1ColorTF) ? (
        <LibraryReact.DivFont p_class="lrMargin" p_fontClass="fontItalic fontTextLighter">
          {p_emptyLabel}
        </LibraryReact.DivFont>
      ) : (
        p_nameColorDataArrayOfObjsOrUndefined.map((m_nameColorObj) =>
          <div className="displayFlexRowVc lrMargin" style={{height:"0.9em"}}>
            <div className="flex00a smallRightMargin border bevelBorderColors borderRadius05" style={{flexBasis:"0.7em", height:"0.8em", background:"#" + m_nameColorObj.color}} />
            <div className="flex11a">
              <LibraryReact.NowrapEllipsis p_fontClass="font09 fontItalic fontTextLight">
                {m_nameColorObj[p_itemNameFieldName]}
              </LibraryReact.NowrapEllipsis>
            </div>
          </div>
        )
      )}
    </div>
  );
}

const TimelineControlsDates = inject("CapturesMobx", "DatabaseMobx", "UserMobx")(observer(
class TimelineControlsDates extends Component { //props:
  onchange_start_date = (i_newStartDate) => {
    const oldEndDate = this.props.CapturesMobx.c_timelineChartTimeSpanObj.endDate;
    var newEndDate = undefined; //undefined if the end date does not need to be updated
    if(i_newStartDate > oldEndDate) { //if the start date was set to a date further out than the end date, move the end date 1 month past this new start date
      newEndDate = JSFUNC.date_add_months(i_newStartDate, 1);
    }
    this.props.CapturesMobx.a_timeline_chart_update_start_end_dates(i_newStartDate, newEndDate);
    this.set_zoom_cool_down_timer();
  }

  onchange_end_date = (i_newEndDate) => {
    const oldStartDate = this.props.CapturesMobx.c_timelineChartTimeSpanObj.startDate;
    var newStartDate = undefined; //undefined if the start date does not need to be updated
    if(i_newEndDate < oldStartDate) { //if the end date was set to a date earlier than the start date, move the start date 1 month before this new end date
      newStartDate = JSFUNC.date_add_months(i_newEndDate, -1);
    }
    this.props.CapturesMobx.a_timeline_chart_update_start_end_dates(newStartDate, i_newEndDate);
    this.set_zoom_cool_down_timer();
  }

  onclick_zoom_out = () => {
    this.props.CapturesMobx.a_timeline_zoom_in_or_out("out");
    this.set_zoom_cool_down_timer();
  }

  onclick_zoom_in = () => {
    this.props.CapturesMobx.a_timeline_zoom_in_or_out("in");
    this.set_zoom_cool_down_timer();
  }

  onclick_pan_left = () => {
    this.props.CapturesMobx.a_timeline_zoom_in_or_out("left");
    this.set_zoom_cool_down_timer();
  }

  onclick_pan_right = () => {
    this.props.CapturesMobx.a_timeline_zoom_in_or_out("right");
    this.set_zoom_cool_down_timer();
  }

  set_zoom_cool_down_timer = () => {
    clearTimeout(this.chartZoomCoolDownTimerID);
    this.chartZoomCoolDownTimerID = setTimeout(this.clear_zoom_cool_down_timer, (5000));
    this.props.CapturesMobx.a_timeline_set_zoom_cool_down_is_running_tf(true);
  }

  clear_zoom_cool_down_timer = () => {
    clearTimeout(this.chartZoomCoolDownTimerID);
    this.props.CapturesMobx.a_timeline_set_zoom_cool_down_is_running_tf(false);
  }

  render() {
    const c_timelineChartTimeSpanObj = this.props.CapturesMobx.c_timelineChartTimeSpanObj;
    const startDate = this.props.UserMobx.c_combinedUserObj.capture_chart_start_date;
    const endDate = this.props.UserMobx.c_combinedUserObj.capture_chart_end_date;

    const totalNumDays = c_timelineChartTimeSpanObj.totalNumDays;
    const canZoomOutTF = (totalNumDays < (365 * 100));
    const canZoomInTF = (totalNumDays > 1);

    return(
      <>
        <div className="flex00a displayFlexRowVc lrMedPad">
          <div className="displayFlexColumnHcVc">
            <div className="displayFlexRowVc">
              <LibraryReact.DivFont p_class="flex00a smallRightMargin" p_fontClass="fontBold fontItalic fontTextLight">
                {"Zoom:"}
              </LibraryReact.DivFont>
              <div className="flex00a displayFlexColumnHcVc hoverLightestGrayGradient cursorPointer" style={{height:"2.7em", width:"2.7em", borderRadius:"2em"}} onClick={((canZoomOutTF) ? (this.onclick_zoom_out) : (undefined))}>
                <svg width="2em" height="2em">
                  <circle cx="50%" cy="50%" r="45%" fill="transparent" style={{strokeWidth:"0.07em", stroke:((canZoomOutTF) ? ("#666") : ("#ccc"))}} />
                  <LibraryReact.SvgHLine p_x1p={20} p_x2p={80} p_ycp={50} p_widthP={7} p_color={(canZoomOutTF) ? ("#666") : ("#ccc")} />
                </svg>
              </div>
              <div className="flex00a displayFlexColumnHcVc hoverLightestGrayGradient cursorPointer" style={{height:"2.7em", width:"2.7em", borderRadius:"2em"}} onClick={((canZoomInTF) ? (this.onclick_zoom_in) : (undefined))}>
                <svg width="2em" height="2em">
                  <circle cx="50%" cy="50%" r="45%" fill="transparent" style={{strokeWidth:"0.07em", stroke:((canZoomInTF) ? ("#666") : ("#ccc"))}} />
                  <LibraryReact.SvgHLine p_x1p={20} p_x2p={80} p_ycp={50} p_widthP={7} p_color={(canZoomInTF) ? ("#666") : ("#ccc")} />
                  <LibraryReact.SvgVLine p_y1p={20} p_y2p={80} p_xcp={50} p_widthP={7} p_color={(canZoomInTF) ? ("#666") : ("#ccc")} />
                </svg>
              </div>
            </div>
            <div className="displayFlexRowVc">
              <LibraryReact.DivFont p_class="flex00a smallRightMargin" p_fontClass="fontBold fontItalic fontTextLight">
                {"Pan:"}
              </LibraryReact.DivFont>
              <div className="flex00a displayFlexColumnHcVc hoverLightestGrayGradient cursorPointer" style={{height:"2.2em", width:"2.9em", borderRadius:"0.2em"}} onClick={this.onclick_pan_left}>
                <svg width="2.2em" height="1.5em">
                  <rect x="5%" y="5%" rx="10%" ry="10%" width="90%" height="90%" fill="transparent" style={{strokeWidth:"0.07em", stroke:"#666"}} />
                  <line x1="40%" x2="20%" y1="20%" y2="50%" style={{strokeWidth:"0.12em", stroke:"#666"}} />
                  <line x1="20%" x2="40%" y1="50%" y2="80%" style={{strokeWidth:"0.12em", stroke:"#666"}} />
                  <line x1="70%" x2="50%" y1="20%" y2="50%" style={{strokeWidth:"0.12em", stroke:"#666"}} />
                  <line x1="50%" x2="70%" y1="50%" y2="80%" style={{strokeWidth:"0.12em", stroke:"#666"}} />
                </svg>
              </div>
              <div className="flex00a displayFlexColumnHcVc hoverLightestGrayGradient cursorPointer" style={{height:"2.2em", width:"2.9em", borderRadius:"0.2em"}} onClick={this.onclick_pan_right}>
                <svg width="2.2em" height="1.5em">
                  <rect x="5%" y="5%" rx="10%" ry="10%" width="90%" height="90%" fill="transparent" style={{strokeWidth:"0.07em", stroke:"#666"}} />
                  <line x1="30%" x2="50%" y1="20%" y2="50%" style={{strokeWidth:"0.12em", stroke:"#666"}} />
                  <line x1="50%" x2="30%" y1="50%" y2="80%" style={{strokeWidth:"0.12em", stroke:"#666"}} />
                  <line x1="60%" x2="80%" y1="20%" y2="50%" style={{strokeWidth:"0.12em", stroke:"#666"}} />
                  <line x1="80%" x2="60%" y1="50%" y2="80%" style={{strokeWidth:"0.12em", stroke:"#666"}} />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div className="flex00a displayFlexRowVc lrMedPad" style={{flexBasis:"25em", borderRight:"solid 1px #aaa"}}>
          <div className="flex11a">
            <div className="displayFlexColumnVc" style={{height:"2.3em"}}>
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString="timelineProgressStartDate"
                p_fieldDisplayName="Start Date:"
                p_fieldTypeObj={this.props.DatabaseMobx.c_genericDateFieldTypeObj}
                p_valueRaw={startDate}
                p_valueIsEditableTFU={true}
                p_fieldClass="fontBold fontItalic fontTextLight"
                p_fieldWidth="5.5em"
                p_fieldNowrapTF={true}
                p_fieldValueVerticallyAlignedTF={true}
                f_onSaveChanged={this.onchange_start_date}
              />
            </div>
            <div className="displayFlexColumnVc" style={{height:"2.3em"}}>
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString="timelineProgressEndDate"
                p_fieldDisplayName="End Date:"
                p_fieldTypeObj={this.props.DatabaseMobx.c_genericDateFieldTypeObj}
                p_valueRaw={endDate}
                p_valueIsEditableTFU={true}
                p_fieldClass="fontBold fontItalic fontTextLight"
                p_fieldWidth="5.5em"
                p_fieldNowrapTF={true}
                p_fieldValueVerticallyAlignedTF={true}
                f_onSaveChanged={this.onchange_end_date}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}));


const MonthLabels = inject("CapturesMobx")(observer(
class MonthLabels extends Component { //props: p_captureNameContainerWidth
  render() {
    const p_captureNameContainerWidth = this.props.p_captureNameContainerWidth;

    const c_timelineChartTimeSpanObj = this.props.CapturesMobx.c_timelineChartTimeSpanObj;

    const startDateIsValidTF = c_timelineChartTimeSpanObj.startDateIsValidTF;
    const endDateIsValidTF = c_timelineChartTimeSpanObj.endDateIsValidTF;
    const showDaysTF = c_timelineChartTimeSpanObj.showDaysTF;
    const monthLinesArrayOfObjs = c_timelineChartTimeSpanObj.monthLinesArrayOfObjs;

    if(!startDateIsValidTF || !endDateIsValidTF) {
      return(null);
    }

    return(
      <div className="flex00a displayFlexRow yScrollAlways borderB1ddd" style={{flexBasis:"2.3em"}}>
        <div className="flex00a borderR1ddd" style={{flexBasis:p_captureNameContainerWidth}} />
        <div className="flex11a overflowHidden bgWhite">
          <svg width="100%" height="100%">
            {monthLinesArrayOfObjs.map((m_monthObj) =>
              <>
                <LibraryReact.SvgVLine p_y1p={0} p_y2p={100} p_xcp={m_monthObj.monthPos} p_widthEm={0.1} p_color="#ccc" />
                <SingleMonthLabel p_monthObj={m_monthObj} />
                {(!showDaysTF && m_monthObj.monthIndex0to11 === 0) &&
                  <text x={(m_monthObj.monthPos + 0.1) + "%"} y="90%" fill="#333">
                    {m_monthObj.shortYear}
                  </text>
                }
                {(showDaysTF) &&
                  m_monthObj.datesArrayOfObjs.map((m_dateObj) => 
                    <>
                      <LibraryReact.SvgVLine p_y1p={50} p_y2p={100} p_xcp={m_dateObj.datePos} p_widthEm={0.09} p_color="#ccc" />
                      <text x={(m_dateObj.datePos + 0.1) + "%"} y="100%" fill="#444">{m_dateObj.date}</text>
                    </>
                  )
                }
              </>
            )}
            <SvgTodayLine p_in100SvgTF={false} />
          </svg>
        </div>
      </div>
    );
  }
}));

const SingleMonthLabel = inject("CapturesMobx")(observer(
class SingleMonthLabel extends Component { //props: p_monthObj
  onclick_month_label = () => {
    const p_monthObj = this.props.p_monthObj;
    this.props.CapturesMobx.a_timeline_zoom_to_single_month(p_monthObj.year, p_monthObj.monthIndex0to11);
  }

  render() {
    const p_monthObj = this.props.p_monthObj;

    return(
      <text x={(p_monthObj.monthPos + 0.1) + "%"} y="45%" fill="#333" className="cursorPointer" onClick={this.onclick_month_label}>
        {p_monthObj.monthName}
      </text>
    );
  }
}));


const TimelineChartCaptureRows = inject("CaptureExecMobx", "CapturesMobx")(observer(
class TimelineChartCaptureRows extends Component { //props: p_ganttTrueProgressFalse, p_chartUserRowHeightEm, p_captureNameContainerWidth
  constructor(props) {
    super(props);
    this.state = {
      s_capureIDHover: -1
    }
  }

  onhover_capture_name = (i_captureID) => {
    this.setState({s_capureIDHover:i_captureID});
  }

  onclick_show_all_captures = () => {
    const c_selectedLeftNavIsProgressChartViewTF = this.props.CaptureExecMobx.c_selectedLeftNavIsProgressChartViewTF;

    const maxTrueResetFalse = true;
    this.props.CapturesMobx.a_set_cst_or_chart_max_num_captures_drawn(maxTrueResetFalse, c_selectedLeftNavIsProgressChartViewTF);
  }

  render() {
    const p_ganttTrueProgressFalse = this.props.p_ganttTrueProgressFalse;
    const p_chartUserRowHeightEm = this.props.p_chartUserRowHeightEm;
    const p_captureNameContainerWidth = this.props.p_captureNameContainerWidth;

    const o_cstOrChartMaxNumCapturesDrawn = this.props.CapturesMobx.o_cstOrChartMaxNumCapturesDrawn;
    const c_ganttOrProgressChartSortedFilteredCapturesArrayOfObjs = this.props.CapturesMobx.c_ganttOrProgressChartSortedFilteredCapturesArrayOfObjs;
    const c_numFilteredCaptures = this.props.CapturesMobx.c_numFilteredCaptures;

    const borderBottom = ((p_ganttTrueProgressFalse) ? ("solid 1px #ddd") : ("solid 2px #bbb"));

    return(
      <div className="flex11a yScrollAlways yScrollBottomPad">
        {c_ganttOrProgressChartSortedFilteredCapturesArrayOfObjs.map((m_captureObj, m_index) =>
          (m_index < o_cstOrChartMaxNumCapturesDrawn) &&
          <div
            key={m_captureObj.id}
            className="displayFlexRow bgWhite hoverLighterBlueGradient"
            style={{height:p_chartUserRowHeightEm + "em", borderBottom:borderBottom}}>
            <TimelineChartCaptureName
              p_captureObj={m_captureObj}
              p_chartUserRowHeightEm={p_chartUserRowHeightEm}
              p_captureNameContainerWidth={p_captureNameContainerWidth}
              f_onHover={this.onhover_capture_name}
            />
            <TimelineChartDataRow
              p_ganttTrueProgressFalse={p_ganttTrueProgressFalse}
              p_captureObj={m_captureObj}
              p_chartUserRowHeightEm={p_chartUserRowHeightEm}
              p_isHoverTF={(this.state.s_capureIDHover === m_captureObj.id)}
              f_onHover={this.onhover_capture_name}
            />
          </div>
        )}
        <ShowAllCapturesButtonAndMessage
          p_numFilteredCaptures={c_numFilteredCaptures}
          p_maxNumCapturesDrawn={o_cstOrChartMaxNumCapturesDrawn}
          f_onClickShowAllCaptures={this.onclick_show_all_captures}
        />
      </div>
    );
  }
}));

const TimelineChartCaptureName = inject("CaptureExecMobx", "CapturesMobx", "OpenCaptureMobx", "UserMobx")(observer(
class TimelineChartCaptureName extends Component { //props: p_captureObj, p_chartUserRowHeightEm, p_captureNameContainerWidth, f_onHover
  onhover_capture_name = (i_hoverTF) => {
    if(JSFUNC.is_function(this.props.f_onHover)) {
      this.props.f_onHover((i_hoverTF) ? (this.props.p_captureObj.id) : (-1));
    }
  }

  onclick_capture_name = () => {
    this.props.OpenCaptureMobx.a_open_single_capture(this.props.p_captureObj.id);
  }

  render() {
    const p_captureObj = this.props.p_captureObj;
    const p_chartUserRowHeightEm = this.props.p_chartUserRowHeightEm;
    const p_captureNameContainerWidth = this.props.p_captureNameContainerWidth;

    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;

    const captureNameTitle = p_captureObj.captureFullName + "\n[Click to open this Capture]";

    var captureNameComponent = null;
    if(p_chartUserRowHeightEm < 2.5) {
      captureNameComponent = (
        <LibraryReact.NowrapEllipsis p_fontClass="fontWhite">
          {p_captureObj.captureFullName}
        </LibraryReact.NowrapEllipsis>
      );
    }
    else {
      captureNameComponent = (
        <LibraryReact.MaxHeightWrap p_maxHeight={(p_chartUserRowHeightEm - 0.5) + "em"} p_fontClass="fontWhite">
          {p_captureObj.captureFullName}
        </LibraryReact.MaxHeightWrap>
      );
    }

    return(
      <LibraryReact.InteractiveDiv
        p_class={"flex00a displayFlexRowVc lrPad " + c_productStylingObj.openCaptureTopBarBgClass + " hoverRed cursorPointer"}
        p_styleObj={{flexBasis:p_captureNameContainerWidth, borderRight:"solid 1px #ccc"}}
        p_title={captureNameTitle}
        f_onClick={this.onclick_capture_name}
        f_onHover={this.onhover_capture_name}>
        {captureNameComponent}
      </LibraryReact.InteractiveDiv>
    );
  }
}));

const TimelineChartDataRow = inject("CapturesMobx", "OpenCaptureMobx")(observer(
class TimelineChartDataRow extends Component { //props: p_ganttTrueProgressFalse, p_captureObj, p_chartUserRowHeightEm, p_isHoverTF, f_onHover
  onhover_data_row = (i_hoverTF) => {
    const p_captureObj = this.props.p_captureObj;

    if(JSFUNC.is_function(this.props.f_onHover)) {
      this.props.f_onHover((i_hoverTF) ? (p_captureObj.id) : (-1));
    }
  }

  render() {
    const p_ganttTrueProgressFalse = this.props.p_ganttTrueProgressFalse;
    const p_captureObj = this.props.p_captureObj;
    const p_chartUserRowHeightEm = this.props.p_chartUserRowHeightEm;
    const p_isHoverTF = this.props.p_isHoverTF;

    const c_singleCaptureIsOpenTF = this.props.OpenCaptureMobx.c_singleCaptureIsOpenTF;

    //if a capture is opened, blank out every cell in every row so that animating the capture opening or closing it and returning to the table is not slow (plus the current scroll down in the capture table is maintained for clicking on multiple captures back to back)
    if(c_singleCaptureIsOpenTF) {
      return(null);
    }

    return(
      <LibraryReact.InteractiveDiv
        p_class="flex11a displayFlexColumn"
        p_styleObj={{backgroundColor:((p_isHoverTF) ? ("#f2f5fb") : (undefined))}}
        f_onHover={this.onhover_data_row}>
        {(p_ganttTrueProgressFalse) ? (
          <GanttRow p_captureObj={p_captureObj} />
        ) : (
          <ProgressRow p_captureObj={p_captureObj} p_chartUserRowHeightEm={p_chartUserRowHeightEm} />
        )}
      </LibraryReact.InteractiveDiv>
    );
  }
}));





//-------------------------------------------------------------------------------------------------------------------------------------
//Progress Chart
//-------------------------------------------------------------------------------------------------------------------------------------
const ProgressRow = inject("CapturesMobx", "DatabaseMobx")(observer(
class ProgressRow extends Component { //props: p_captureObj, p_chartUserRowHeightEm
  render() {
    const p_captureObj = this.props.p_captureObj;
    const p_chartUserRowHeightEm = this.props.p_chartUserRowHeightEm;

    const c_companyUsingPwinTF = this.props.DatabaseMobx.c_companyUsingPwinTF;

    var topProgressFraction = 0.075;
    var progressHeightFraction = 0.25;
    var topPwinFraction = 0.05;
    var pwinHeightFraction = 0.25;
    var topStagesFraction = 0.05;
    var stagesHeightFraction = 0.25;
    var bottomStagesFraction = 0.075;
    if(!c_companyUsingPwinTF) {
      topProgressFraction = 0.1;
      progressHeightFraction = 0.4;
      topStagesFraction = 0.1;
      stagesHeightFraction = 0.3;
      bottomStagesFraction = 0.1;
    }

    return(
      <>
        <div style={{height:(progressHeightFraction * p_chartUserRowHeightEm) + "em", marginTop:(topProgressFraction * p_chartUserRowHeightEm) + "em"}}>
          <ProgressRowShapingOrPwin p_captureObj={p_captureObj} p_shapingTruePwinFalse={true} p_chartUserRowHeightEm={p_chartUserRowHeightEm} />
        </div>
        {(c_companyUsingPwinTF) &&
          <div style={{height:(pwinHeightFraction * p_chartUserRowHeightEm) + "em", marginTop:(topPwinFraction * p_chartUserRowHeightEm) + "em"}}>
            <ProgressRowShapingOrPwin p_captureObj={p_captureObj} p_shapingTruePwinFalse={false} p_chartUserRowHeightEm={p_chartUserRowHeightEm} />
          </div>
        }
        <div style={{height:(stagesHeightFraction * p_chartUserRowHeightEm) + "em", marginTop:(topStagesFraction * p_chartUserRowHeightEm) + "em", marginBottom:(bottomStagesFraction * p_chartUserRowHeightEm) + "em"}}>
          <ProgressRowStage p_captureObj={p_captureObj} />
        </div>
      </>
    );
  }
}));

const ProgressRowShapingOrPwin = inject("CapturesMobx", "DatabaseMobx")(observer(
class ProgressRowShapingOrPwin extends Component { //props: p_captureObj, p_shapingTruePwinFalse, p_chartUserRowHeightEm
  render() {
    const p_captureObj = this.props.p_captureObj;
    const p_shapingTruePwinFalse = JSFUNC.prop_value(this.props.p_shapingTruePwinFalse, true);
    const p_chartUserRowHeightEm = this.props.p_chartUserRowHeightEm;

    const c_timelineChartTimeSpanObj = this.props.CapturesMobx.c_timelineChartTimeSpanObj;

    const logTblName = ((p_shapingTruePwinFalse) ? ("o_progressChartLogShapingMapOfArrayOfObjs") : ("o_progressChartLogPwinMapOfArrayOfObjs"));
    const dvDataArrayOfObjs = this.props.DatabaseMobx[logTblName].get(p_captureObj.id);
    const progressPwinStagesFlag = ((p_shapingTruePwinFalse) ? ("progress") : ("pwin"));

    if((dvDataArrayOfObjs === undefined) || (dvDataArrayOfObjs.length === 0)) {
      return(
        <SvgAllMonthLines p_in100SvgTF={true} />
      );
    }

    const progressBarsDataObj = this.props.CapturesMobx.compute_progress_chart_bars_data_obj(dvDataArrayOfObjs, c_timelineChartTimeSpanObj.startDate, c_timelineChartTimeSpanObj.endDate, c_timelineChartTimeSpanObj.startDateUnixSec, c_timelineChartTimeSpanObj.totalNumSec, c_timelineChartTimeSpanObj.nowDateTimeUTC, progressPwinStagesFlag);

    //progress bar width
    var progressBlackBarThicknessPercent = (15 - Math.round(p_chartUserRowHeightEm / 5));

    return(
      <svg width="100%" height="100%">
        {progressBarsDataObj.bgProgressColorsArrayOfObjs.map((m_bgColorObj) =>
          <rect x={m_bgColorObj.pos1 + "%"} y="0" width={(m_bgColorObj.pos2 - m_bgColorObj.pos1) + "%"} height="100%" style={{fill:m_bgColorObj.value, strokeWidth:"0"}} />
        )}
        {progressBarsDataObj.progressBarsArrayOfObjs.map((m_barObj) =>
          <g>
            <title>{m_barObj.numDays + " days at " + m_barObj.value + "% Total Progress"}</title>
            <LibraryReact.SvgHLine p_x1p={m_barObj.pos1} p_x2p={m_barObj.pos2} p_ycp={(100 - m_barObj.value)} p_widthP={progressBlackBarThicknessPercent} p_color="#333" />
          </g>
        )}
        <SvgAllMonthLines p_in100SvgTF={false} />
      </svg>
    );
  }
}));

const ProgressRowStage = inject("CapturesMobx", "DatabaseMobx")(observer(
class ProgressRowStage extends Component { //props: p_captureObj
  render() {
    const p_captureObj = this.props.p_captureObj;

    const logTblName = "o_progressChartLogStagesMapOfArrayOfObjs";
    const dvDataArrayOfObjs = this.props.DatabaseMobx[logTblName].get(p_captureObj.id);

    if(dvDataArrayOfObjs === undefined || dvDataArrayOfObjs.length === 0) {
      return(
        <SvgAllMonthLines p_in100SvgTF={true} />
      );
    }

    const c_timelineChartTimeSpanObj = this.props.CapturesMobx.c_timelineChartTimeSpanObj;
    const stagesDataObj = this.props.CapturesMobx.compute_progress_chart_bars_data_obj(dvDataArrayOfObjs, c_timelineChartTimeSpanObj.startDate, c_timelineChartTimeSpanObj.endDate, c_timelineChartTimeSpanObj.startDateUnixSec, c_timelineChartTimeSpanObj.totalNumSec, c_timelineChartTimeSpanObj.nowDateTimeUTC, "stages");
    const numProgressBars = stagesDataObj.progressBarsArrayOfObjs.length;

    var stageLogsArrayOfObjs = [];
    for(let s = 0; s < numProgressBars; s++) {
      var singleStageDataObj = stagesDataObj.progressBarsArrayOfObjs[s];
      var stageMap = this.props.DatabaseMobx.tbl_row_map_from_id("tbl_a_stages_pool", singleStageDataObj.value);
      stageLogsArrayOfObjs.push({
        pos1: singleStageDataObj.pos1,
        pos2: singleStageDataObj.pos2,
        color: "#" + stageMap.get("color"),
        lineTF: (!((s === (numProgressBars - 1)) && stageMap.get("isClosedStageTF"))),
        rectTF: (singleStageDataObj.pos1 > 0), //tall box placed on the day the stage was changed to this stage
        title: singleStageDataObj.numDays + " days in stage '" + stageMap.get("name") + "'"
      });
    }

    return(
      <svg width="100%" height="100%">
        {stageLogsArrayOfObjs.map((m_stageObj) =>
          <g>
            <title>{m_stageObj.title}</title>
            {(m_stageObj.lineTF) &&
              <LibraryReact.SvgHLine p_x1p={m_stageObj.pos1} p_x2p={m_stageObj.pos2} p_ycp={50} p_widthP={35} p_color={m_stageObj.color} />
            }
            {(m_stageObj.rectTF) &&
              <rect x={m_stageObj.pos1 + "%"} y="0" width="1em" height="100%" style={{strokeWidth:"1", stroke:"#888", fill:m_stageObj.color}} />
            }
          </g>
        )}
        <SvgAllMonthLines p_in100SvgTF={false} />
      </svg>
    );
  }
}));




//-------------------------------------------------------------------------------------------------------------------------------------
//Gantt Chart
//-------------------------------------------------------------------------------------------------------------------------------------
const GanttRow = inject("CapturesMobx", "DatabaseMobx", "UserMobx")(observer(
class GanttRow extends Component { //props: p_captureObj
  render() {
    const p_captureObj = this.props.p_captureObj;

    const c_ganttSelectedPresetObj = this.props.CapturesMobx.c_ganttSelectedPresetObj;
    const c_timelineChartTimeSpanObj = this.props.CapturesMobx.c_timelineChartTimeSpanObj;
    const userChartSize = this.props.UserMobx.c_combinedUserObj.capture_chart_gantt_size;

    if(c_ganttSelectedPresetObj == undefined) {
      return(null);
    }

    const ganttDatesArrayOfObjs = c_ganttSelectedPresetObj.ganttDatesArrayOfObjs;

    const monthLinesArrayOfObjs = c_timelineChartTimeSpanObj.monthLinesArrayOfObjs;
    const todayPos = c_timelineChartTimeSpanObj.todayPos;

    const dateEllipseWidth = ((userChartSize * 0.03) + 0.23) + "em";
    const dateEllipseYRadius = (45 - (userChartSize * 2.8)) + "%";

    //get each date value from the capture record
    var captureDatesArrayOfObjs = [];
    for(let ganttDateObj of ganttDatesArrayOfObjs) {
      var captureDateOrDateTimeUtcValueRaw = p_captureObj[ganttDateObj.fieldDbName];
      var jsDateObj = undefined;
      var durationInSeconds = 0;
      var dateTimeLocal = "";
      var dateOrDateTimeLocalMaskPlainText = "";
      if(ganttDateObj.fieldIsDateWithDurationTF) {
        var dateWithDurationObj = JSFUNC.convert_date_with_duration_raw_datetime_to_date_with_duration_obj(captureDateOrDateTimeUtcValueRaw);
        if(JSFUNC.date_is_filled_out_tf(dateWithDurationObj.dateYmd)) {
          dateTimeLocal = dateWithDurationObj.dateYmd + " 12:00:00";
          jsDateObj = JSFUNC.convert_naturaldatetimelocal_to_jsdateobj(dateTimeLocal);
          if(dateWithDurationObj.numDaysWeeksMonthsYearsInt > 0) {
            if(dateWithDurationObj.days1Weeks2Months3Years4Int === 2) { durationInSeconds = (dateWithDurationObj.numDaysWeeksMonthsYearsInt * 7 * 86400); } //weeks
            else if(dateWithDurationObj.days1Weeks2Months3Years4Int === 3) { durationInSeconds = (dateWithDurationObj.numDaysWeeksMonthsYearsInt * 30.4375 * 86400); } //months
            else if(dateWithDurationObj.days1Weeks2Months3Years4Int === 4) { durationInSeconds = (dateWithDurationObj.numDaysWeeksMonthsYearsInt * 365.25 * 86400); } //years
            else { durationInSeconds = (dateWithDurationObj.numDaysWeeksMonthsYearsInt * 86400); } //days
          }
          dateOrDateTimeLocalMaskPlainText = this.props.DatabaseMobx.value_mask_plaintext_from_value_raw_and_field_type_obj(captureDateOrDateTimeUtcValueRaw, this.props.DatabaseMobx.c_genericDateWithDurationFieldTypeObj);
        }
      }
      else if(JSFUNC.datetime_is_filled_out_tf(captureDateOrDateTimeUtcValueRaw)) {
        const dateSecondsString0to59 = JSFUNC.direct_get_ss_00to59_string_from_YmdHis_datetime(captureDateOrDateTimeUtcValueRaw);
        if((dateSecondsString0to59 === "58") || (dateSecondsString0to59 === "59")) { //time is not set, force it to noon same as the regular date field type
          dateTimeLocal = JSFUNC.direct_get_Ymd_string_from_YmdHis_datetime(captureDateOrDateTimeUtcValueRaw) + " 12:00:00";
          jsDateObj = JSFUNC.convert_naturaldatetimelocal_to_jsdateobj(dateTimeLocal);
        }
        else { //convert datetime in UTC to local time
          jsDateObj = JSFUNC.convert_ce_datetimeutc_to_jsdateobj(captureDateOrDateTimeUtcValueRaw);
          dateTimeLocal = JSFUNC.get_naturalDateTimeYmdHis_local_or_utc_from_jsDateObj_and_utctf(jsDateObj, false);
        }
        dateOrDateTimeLocalMaskPlainText = this.props.DatabaseMobx.value_mask_plaintext_from_value_raw_and_field_type_obj(captureDateOrDateTimeUtcValueRaw, this.props.DatabaseMobx.c_genericDateTimeFieldTypeObj);
      }
      else if(JSFUNC.date_is_filled_out_tf(captureDateOrDateTimeUtcValueRaw)) { //use noon as the local time for a date type field
        dateTimeLocal = captureDateOrDateTimeUtcValueRaw + " 12:00:00";
        jsDateObj = JSFUNC.convert_naturaldatetimelocal_to_jsdateobj(dateTimeLocal);
        dateOrDateTimeLocalMaskPlainText = this.props.DatabaseMobx.value_mask_plaintext_from_value_raw_and_field_type_obj(captureDateOrDateTimeUtcValueRaw, this.props.DatabaseMobx.c_genericDateFieldTypeObj);
      }

      if(jsDateObj !== undefined) {
        var captureDateSecFromStartDate = ((jsDateObj.getTime() / 1000) - c_timelineChartTimeSpanObj.startDateUnixSec);
        captureDatesArrayOfObjs.push({
          dateTimeLocal: dateTimeLocal,
          dateOrDateTimeLocalMaskPlainText: dateOrDateTimeLocalMaskPlainText,
          dateFieldDisplayName: ganttDateObj.fieldDisplayName,
          secFromStart: captureDateSecFromStartDate,
          durationInSeconds: durationInSeconds,
          color: ganttDateObj.color
        });
      }
    }

    //sort the dates in ascending order
    captureDatesArrayOfObjs.sort(JSFUNC.sort_by_asc("dateTimeLocal"));
    const numCaptureDates = captureDatesArrayOfObjs.length;

    //only include dates that would have a dot or bar drawn somewhere within the graph start/end dates
    var ganttDataArrayOfObjs = [];
    for(let d = 0; d < numCaptureDates; d++) {
      var captureDateObj = captureDatesArrayOfObjs[d];
      var currentDateTimeLocal = captureDateObj.dateTimeLocal;

      //add a date circle if the date falls within the start/end
      if(captureDateObj.durationInSeconds > 0) {
        var pos1 = ((captureDateObj.secFromStart / c_timelineChartTimeSpanObj.totalNumSec) * 100);
        var pos2 = (((captureDateObj.secFromStart + captureDateObj.durationInSeconds) / c_timelineChartTimeSpanObj.totalNumSec) * 100);
        if(((pos1 >= 0) && (pos1 <= 100)) || ((pos2 >= 0) && (pos2 <= 100))) {
          ganttDataArrayOfObjs.push({
            dateTF: false,
            dateWithDurationTF: true,
            barTF: false,
            pos1: pos1,
            pos2: pos2,
            color: captureDateObj.color,
            title: captureDateObj.dateFieldDisplayName + ": " + captureDateObj.dateOrDateTimeLocalMaskPlainText + "\n" + p_captureObj.captureFullName
          });
        }
      }
      else {
        var pos1 = ((captureDateObj.secFromStart / c_timelineChartTimeSpanObj.totalNumSec) * 100);
        if((pos1 >= 0) && (pos1 <= 100)) {
          ganttDataArrayOfObjs.push({
            dateTF: true,
            dateWithDurationTF: false,
            barTF: false,
            pos1: pos1,
            pos2: undefined,
            color: captureDateObj.color,
            title: captureDateObj.dateFieldDisplayName + ": " + captureDateObj.dateOrDateTimeLocalMaskPlainText + "\n" + p_captureObj.captureFullName
          });
        }
      }

      //add a bar if any part of the bar from this date to the next one falls within the start/end dates
      if(d < (numCaptureDates - 1)) { //last latest date does not have a bar after it
        var nextCaptureDateObj = captureDatesArrayOfObjs[d + 1];
        var nextDateTimeLocal = nextCaptureDateObj.dateTimeLocal;
        var pos1 = undefined;
        var pos2 = undefined;
        if(currentDateTimeLocal <= c_timelineChartTimeSpanObj.startDate) {
          if(nextDateTimeLocal <= c_timelineChartTimeSpanObj.startDate) { //both dates are to the left of the start date, no bar drawn
            pos1 = undefined;
            pos2 = undefined;
          }
          else if(nextDateTimeLocal <= c_timelineChartTimeSpanObj.endDate) { //date is left of start, but next date is in the window
            pos1 = 0;
            pos2 = ((nextCaptureDateObj.secFromStart / c_timelineChartTimeSpanObj.totalNumSec) * 100);
          }
          else { //nextDateTimeLocal > c_timelineChartTimeSpanObj.endDate, bar spans the entire window
            pos1 = 0;
            pos2 = 100;
          }
        }
        else if(currentDateTimeLocal <= c_timelineChartTimeSpanObj.endDate) {
          if(nextDateTimeLocal <= c_timelineChartTimeSpanObj.endDate) { //this date and next date are both in the window
            pos1 = ((captureDateObj.secFromStart / c_timelineChartTimeSpanObj.totalNumSec) * 100);
            pos2 = ((nextCaptureDateObj.secFromStart / c_timelineChartTimeSpanObj.totalNumSec) * 100);
          }
          else { //nextDateTimeLocal > c_timelineChartTimeSpanObj.endDate, this date is in the window, but next date is outside of the window
            pos1 = ((captureDateObj.secFromStart / c_timelineChartTimeSpanObj.totalNumSec) * 100);
            pos2 = 100;
          }
        }
        else { //thisdate > c_timelineChartTimeSpanObj.endDate, meaning that the nextDateTimeLocal is also past the end date, thus neither of the dates are in the window and there is no bar
          pos1 = undefined;
          pos2 = undefined;
        }

        if(pos1 !== undefined && pos2 !== undefined) {
          ganttDataArrayOfObjs.push({
            dateTF: false,
            dateWithDurationTF: false,
            barTF: true,
            pos1: pos1,
            pos2: pos2,
            color: captureDateObj.color,
            title: undefined
          });
        }
      }
    }

    //draw the gantt dates and connecting bars
    return(
      <svg width="100%" height="100%">
        <SvgAllMonthLines p_in100SvgTF={false} />
        {ganttDataArrayOfObjs.map((m_ganttDataObj) =>
          <g>
            {(m_ganttDataObj.title !== undefined) &&
              <title>{m_ganttDataObj.title}</title>
            }
            {(m_ganttDataObj.dateTF) &&
              <ellipse cx={m_ganttDataObj.pos1 + "%"} cy="50%" rx={dateEllipseWidth} ry={dateEllipseYRadius} style={{fill:"#" + m_ganttDataObj.color, strokeWidth:"1", stroke:"#aaa"}} />
            }
            {(m_ganttDataObj.dateWithDurationTF) &&
              <rect x={m_ganttDataObj.pos1 + "%"} y="15%" rx="5px" ry="5px" width={(m_ganttDataObj.pos2 - m_ganttDataObj.pos1) + "%"} height="70%" style={{fill:"#" + m_ganttDataObj.color, strokeWidth:"1", stroke:"#aaa"}} />
            }
            {(m_ganttDataObj.barTF) &&
              <LibraryReact.SvgHLine p_x1p={m_ganttDataObj.pos1} p_x2p={m_ganttDataObj.pos2} p_ycp={50} p_widthP={12} p_color={"#" + m_ganttDataObj.color} />
            }
          </g>
        )}
        <SvgTodayLine p_in100SvgTF={false} />
      </svg>
    );
  }
}));


const SvgAllMonthLines = inject("CapturesMobx")(observer(
class SvgAllMonthLines extends Component { //props: p_in100SvgTF
  render() {
    const p_in100SvgTF = JSFUNC.prop_value(this.props.p_in100SvgTF, true);

    const c_timelineChartTimeSpanObj = this.props.CapturesMobx.c_timelineChartTimeSpanObj;

    const singleLetterMonthsTF = c_timelineChartTimeSpanObj.singleLetterMonthsTF;
    const monthLinesArrayOfObjs = c_timelineChartTimeSpanObj.monthLinesArrayOfObjs;

    //for single letter months (very zoomed out), only show January line, otherwise draw a line for each month
    const monthLinesComponent = monthLinesArrayOfObjs.map((m_monthObj) =>
      (!singleLetterMonthsTF || (m_monthObj.monthIndex0to11 === 0)) &&
      <LibraryReact.SvgVLine p_y1p={0} p_y2p={100} p_xcp={m_monthObj.monthPos} p_widthEm={0.1} p_color={((!singleLetterMonthsTF && m_monthObj.monthIndex0to11 === 0) ? ("#999") : ("#ddd"))} />
    );

    if(p_in100SvgTF) {
      return(
        <svg width="100%" height="100%">
          {monthLinesComponent}
        </svg>
      );
    }

    return(
      monthLinesComponent
    );
  }
}));


const SvgTodayLine = inject("CapturesMobx")(observer(
class SvgTodayLine extends Component { //props: p_in100SvgTF
  render() {
    const p_in100SvgTF = JSFUNC.prop_value(this.props.p_in100SvgTF, true);

    const c_timelineChartTimeSpanObj = this.props.CapturesMobx.c_timelineChartTimeSpanObj;

    if(c_timelineChartTimeSpanObj.todayPos === undefined) {
      return(null);
    }

    const lineComponent = (
      <LibraryReact.SvgVLine p_y1p={0} p_y2p={100} p_xcp={c_timelineChartTimeSpanObj.todayPos} p_widthEm={0.2} p_color={"#005da3"} />
    );

    if(p_in100SvgTF) {
      return(
        <svg width="100%" height="100%">
          {lineComponent}
        </svg>
      );
    }

    return(
      lineComponent
    );
  }
}));









//-------------------------------------------------------------------------------------------------------------------------------------
//IDIQ & Task Orders View
//-------------------------------------------------------------------------------------------------------------------------------------
const IDIQTaskOrdersView = inject("CapturesMobx", "OpenCaptureMobx", "DatabaseMobx", "UserMobx")(observer(
class IDIQTaskOrdersView extends Component {
  onswitch_expand_all_idiqs = () => {
    const idiqCapturesArrayOfObjs = this.props.CapturesMobx.c_idiqTaskOrdersTableDataObj.idiqCapturesWithTaskOrdersArrayOfObjs;
    const idiqCaptureIDsArray = idiqCapturesArrayOfObjs.map((idiqCaptureObj) => idiqCaptureObj.id);
    const expandedIDIQCaptureIDsArray = this.props.CapturesMobx.o_idiqExpandedCaptureIDsArray;
    const allIDIQsExpandedTF = (idiqCaptureIDsArray.length > 0) && idiqCaptureIDsArray.every((captureID) => expandedIDIQCaptureIDsArray.includes(captureID));
    this.props.CapturesMobx.a_set_idiq_expanded_capture_ids_array(allIDIQsExpandedTF ? [] : idiqCaptureIDsArray);
  }

  onclick_toggle_idiq_expansion = (i_idiqCaptureID) => {
    this.props.CapturesMobx.a_toggle_idiq_capture_expanded(i_idiqCaptureID);
  }

  onselect_idiq_categories = (i_selectedCategoryNumbersCommaString) => {
    this.props.UserMobx.a_update_logged_in_user_per_email_field(
      "idiqs_tos_view_selected_idiq_category_types_comma",
      i_selectedCategoryNumbersCommaString,
      "s"
    );
  }

  onclick_open_capture = (i_captureID) => {
    this.props.OpenCaptureMobx.a_open_single_capture(i_captureID);
  }

  render() {
    const o_idiqExpandedCaptureIDsArray = this.props.CapturesMobx.o_idiqExpandedCaptureIDsArray;
    const idiqTaskOrdersTableDataObj = this.props.CapturesMobx.c_idiqTaskOrdersTableDataObj;
    const idiqCapturesArrayOfObjs = idiqTaskOrdersTableDataObj.idiqCapturesWithTaskOrdersArrayOfObjs;
    const idiqFirstRowColumnsArrayOfObjs = idiqTaskOrdersTableDataObj.idiqFirstRowColumnsArrayOfObjs;
    const idiqSecondRowColumnsArrayOfObjs = idiqTaskOrdersTableDataObj.idiqSecondRowColumnsArrayOfObjs;
    const taskOrderFirstRowColumnsArrayOfObjs = idiqTaskOrdersTableDataObj.taskOrderFirstRowColumnsArrayOfObjs;
    const taskOrderHeaderRepeatNumRows = idiqTaskOrdersTableDataObj.taskOrderHeaderRepeatNumRows;
    const idiqLaunchColumnWidthEm = 2.5;
    const idiqCategoryColorColumnWidthEm = 2.2;
    const idiqFirstRowHeightEm = 2.2;
    const idiqSecondRowHeightEm = 1.7;
    const idiqRowsHeightEm = idiqFirstRowHeightEm + idiqSecondRowHeightEm;
    const allIDIQsExpandedTF = (idiqCapturesArrayOfObjs.length > 0) && idiqCapturesArrayOfObjs.every((captureValuesObj) =>
      o_idiqExpandedCaptureIDsArray.includes(captureValuesObj.id)
    );

    return(
      <>
        <div className="flex00a displayFlexRowVc bgWhite borderB1ddd lrMedPad" style={{minHeight:"3.4em", gap:"1.5em"}}>
          <div className="flex00a" style={{flexBasis:"14em"}}>
            <LibraryReact.DivFont p_fontClass="font13 fontBold">
              {"IDIQs & Task Orders View"}
            </LibraryReact.DivFont>
          </div>
          <div className="flex00a displayFlexColumn tbPad" style={{width:"20em"}}>
            <LibraryReact.DivFont p_class="microBottomMargin textCenter" p_fontClass="font09 fontItalic fontTextLight">
              {"IDIQ Categories"}
            </LibraryReact.DivFont>
            <CEGeneralReact.GenericInputOrSelectFromInputType
              p_fieldTypeObj={this.props.DatabaseMobx.c_idiqCategoryFilterMultiSelectFieldTypeObj}
              p_valueRaw={this.props.UserMobx.c_combinedUserObj.idiqs_tos_view_selected_idiq_category_types_comma}
              f_onChangeOrOnSelect={this.onselect_idiq_categories}
            />
          </div>
          <div className="flex11a" />
          <div className="flex00a">
            <CEGeneralReact.SwitchWithTextAndConfirmBox
              p_isOnTF={allIDIQsExpandedTF}
              p_sizeEm={2.8}
              p_labelText={"Expand/Collapse All IDIQs"}
              p_labelFontClass="font09 fontItalic fontTextLight"
              p_labelWidthEm={8}
              p_title="When on, Task Orders are shown under every IDIQ"
              f_onSwitch={this.onswitch_expand_all_idiqs}
            />
          </div>
        </div>
        <div className="flex00a displayFlexRowVc borderB1ddd lrSmallPad" style={{minHeight:"2.4em", backgroundColor:"#e9eef2"}}>
          <div className="flex00a" style={{width:idiqLaunchColumnWidthEm + "em"}} />
          <div className="flex00a" style={{width:idiqCategoryColorColumnWidthEm + "em"}} />
          <div className="flex11a displayFlexRowVc" style={{minWidth:0}}>
            {idiqFirstRowColumnsArrayOfObjs.map((columnObj) =>
              <div key={columnObj.valueObjKey} className={(columnObj.fixedWidthTF ? "flex00a" : "flex11a") + " displayFlexRowVc lrPad"} style={{flexBasis:columnObj.widthEm + "em", minWidth:0}}>
                <LibraryReact.NowrapEllipsis p_fontClass="font09 fontBold fontTextLighter">
                  {columnObj.label}
                </LibraryReact.NowrapEllipsis>
              </div>
            )}
          </div>
          <div className="flex00a" style={{width:"2.5em"}} />
        </div>
        <div className="flex11a yScroll">
          {(idiqCapturesArrayOfObjs.length === 0) ? (
            <CEGeneralReact.EmptyScreenGray>
              {"No IDIQ Captures match the current Capture Table filter."}
            </CEGeneralReact.EmptyScreenGray>
          ) : (
            idiqCapturesArrayOfObjs.map((idiqCaptureValuesObj) => {
              const idiqCaptureID = idiqCaptureValuesObj.id;
              const taskOrderValuesArrayOfObjs = idiqCaptureValuesObj.taskOrdersArrayOfObjs;
              const isExpandedTF = o_idiqExpandedCaptureIDsArray.includes(idiqCaptureID);
              const taskOrdersAreVisibleTF = (isExpandedTF && (taskOrderValuesArrayOfObjs.length > 0));

              return(
                <div
                  key={"idiqTaskOrder" + idiqCaptureID}
                  className="positionRelative"
                  style={{margin:(taskOrdersAreVisibleTF) ? ("0.1em 0.25em 1em") : ("0.1em 0.25em"), border:"1px solid #d6dee6", borderRadius:"0.25em", overflow:"hidden", backgroundColor:"#f5f5f5"}}>
                  {(taskOrdersAreVisibleTF) &&
                    <div
                      aria-hidden="true"
                      style={{position:"absolute", left:"0.8em", top:idiqFirstRowHeightEm + "em", bottom:"1.2em", borderLeft:"1px solid #bdc8d3", pointerEvents:"none", zIndex:1}}
                    />
                  }
                  <div
                    className="displayFlexRowVc"
                    style={{backgroundColor:"#f5f5f5"}}>
                    <div
                      className="flex00a displayFlexColumnHcVc cursorPointer"
                      style={{width:idiqLaunchColumnWidthEm + "em", height:idiqRowsHeightEm + "em", backgroundColor:"#f5f5f5"}}
                      title={"Open Capture '" + idiqCaptureValuesObj.captureName + "'"}
                      onClick={() => this.onclick_open_capture(idiqCaptureID)}>
                      <CEIconsReact.SvgLaunch p_sizeEm={1.4} p_color="885055" />
                    </div>
                    <div
                      className="flex00a displayFlexColumn smallRightMargin"
                      style={{width:idiqCategoryColorColumnWidthEm + "em", height:idiqRowsHeightEm + "em"}}>
                      <div
                        className="flex11a tbMicroMargin border bevelBorderColors"
                        style={{backgroundColor:"#" + idiqCaptureValuesObj.idiqCategoryBgColor}}
                        title={"IDIQ Category " + idiqCaptureValuesObj.idiqCategoryNumber + ": " + idiqCaptureValuesObj.idiqCategoryDescription}
                      />
                    </div>
                    <div className="flex11a displayFlexColumn" style={{minWidth:0}}>
                      <div className="displayFlexRowVc" style={{minHeight:idiqFirstRowHeightEm + "em", backgroundColor:"#f5f5f5"}}>
                        {idiqFirstRowColumnsArrayOfObjs.map((columnObj) =>
                          <CaptureSummaryInfoCell
                            key={columnObj.valueObjKey}
                            p_valueObj={idiqCaptureValuesObj[columnObj.valueObjKey]}
                            p_basis={columnObj.widthEm + "em"}
                            p_fixedWidthTF={columnObj.fixedWidthTF}
                            p_displayValueHasFlexWrapMaskTF={columnObj.displayValueHasFlexWrapMaskTF}
                            p_cstCellAlignClass={columnObj.cstCellAlignClass}
                            p_fontClass={columnObj.fontClass}
                          />
                        )}
                      </div>
                      <div className="displayFlexRowVc" style={{minHeight:idiqSecondRowHeightEm + "em", backgroundColor:"#eeeeee"}}>
                        {idiqSecondRowColumnsArrayOfObjs.map((columnObj) =>
                          <CaptureSummaryInfoCell
                            key={columnObj.valueObjKey}
                            p_label={columnObj.label}
                            p_hoverText={columnObj.hoverText}
                            p_valueObj={idiqCaptureValuesObj[columnObj.valueObjKey]}
                            p_basis={columnObj.widthEm + "em"}
                            p_fixedWidthTF={columnObj.fixedWidthTF}
                            p_cstCellAlignClass={columnObj.cstCellAlignClass}
                            p_fontClass={columnObj.fontClass}
                          />
                        )}
                        <div className="flex11a" />
                      </div>
                    </div>
                    <div className="flex00a displayFlexColumnHcVc" style={{width:"2.5em", height:idiqRowsHeightEm + "em", backgroundColor:"#f5f5f5"}}>
                      {(taskOrderValuesArrayOfObjs.length > 0) &&
                        <CEGeneralReact.ButtonExpandCollapse
                          p_isExpandedTF={isExpandedTF}
                          p_sizeEm={1.5}
                          p_bgClass="bgLightestGray"
                          p_title={(isExpandedTF) ? ("Collapse Task Orders for " + idiqCaptureValuesObj.captureName) : ("Expand Task Orders for " + idiqCaptureValuesObj.captureName)}
                          f_onClick={() => this.onclick_toggle_idiq_expansion(idiqCaptureID)}
                        />
                      }
                    </div>
                  </div>
                  {(isExpandedTF) && taskOrderValuesArrayOfObjs.map((taskOrderValuesObj, taskOrderIndex) => {
                    return(
                      <React.Fragment key={"taskOrder" + taskOrderValuesObj.id}>
                        {(taskOrderIndex % taskOrderHeaderRepeatNumRows === 0) &&
                          <div className="displayFlexRowVc borderB1ddd" style={{minHeight:idiqFirstRowHeightEm + "em", backgroundColor:"#faf6ee"}}>
                            <div className="flex00a" style={{width:"2em"}} />
                            <div className="flex00a" style={{width:"2.5em"}} />
                            <div className="flex11a displayFlexRowVc" style={{minWidth:0}}>
                              {taskOrderFirstRowColumnsArrayOfObjs.map((columnObj) =>
                                <div key={columnObj.valueObjKey} className={(columnObj.fixedWidthTF ? "flex00a" : "flex11a") + " displayFlexRowVc lrPad"} style={{flexBasis:columnObj.widthEm + "em", minWidth:0}}>
                                  <LibraryReact.NowrapEllipsis p_fontClass="font09 fontBold fontTextLighter">
                                    {columnObj.label}
                                  </LibraryReact.NowrapEllipsis>
                                </div>
                              )}
                            </div>
                          </div>
                        }
                        <div
                          className="displayFlexRowVc"
                          style={{minHeight:idiqFirstRowHeightEm + "em", backgroundColor:"#fffefa"}}>
                          <div className="flex00a positionRelative" style={{width:"2em", height:idiqFirstRowHeightEm + "em", zIndex:2}}>
                            <div
                              aria-hidden="true"
                              style={{position:"absolute", left:"0.8em", top:"50%", width:"1.2em", borderTop:"1px solid #bdc8d3", pointerEvents:"none"}}
                            />
                          </div>
                          <div
                            className="flex00a displayFlexColumnHcVc cursorPointer"
                            style={{width:"2.5em", height:idiqFirstRowHeightEm + "em"}}
                            title={"Open Capture '" + taskOrderValuesObj.captureName + "'"}
                            onClick={() => this.onclick_open_capture(taskOrderValuesObj.id)}>
                            <CEIconsReact.SvgLaunch p_sizeEm={1.2} p_color="885055" />
                          </div>
                          {taskOrderFirstRowColumnsArrayOfObjs.map((columnObj) =>
                            <CaptureSummaryInfoCell
                              key={columnObj.valueObjKey}
                              p_valueObj={taskOrderValuesObj[columnObj.valueObjKey]}
                              p_basis={columnObj.widthEm + "em"}
                              p_fixedWidthTF={columnObj.fixedWidthTF}
                              p_cstCellAlignClass={columnObj.cstCellAlignClass}
                              p_fontClass={columnObj.fontClass}
                            />
                          )}
                        </div>
                      </React.Fragment>
                    );
                  })}
                </div>
              );
            })
          )}
        </div>
      </>
    );
  }
}));

function CaptureSummaryInfoCell(props) {
  const p_label = props.p_label;
  const p_valueObj = props.p_valueObj;
  const p_basis = props.p_basis;
  const p_fixedWidthTF = props.p_fixedWidthTF;
  const p_displayValueHasFlexWrapMaskTF = props.p_displayValueHasFlexWrapMaskTF;
  const p_hoverText = props.p_hoverText;
  const p_fontClass = props.p_fontClass;
  const p_cstCellAlignClass = props.p_cstCellAlignClass;

  const displayValue = ((p_valueObj === undefined) || (p_valueObj.valueMask === undefined) || (p_valueObj.valueMask === null)) ? ("") : (p_valueObj.valueMask);
  const displayValueText = ((typeof displayValue === "string") || (typeof displayValue === "number")) ? (displayValue) : ("");
  const hoverValueText = ((p_valueObj !== undefined) && (p_valueObj.valueMaskPlainText !== undefined) && (p_valueObj.valueMaskPlainText !== null))
    ? (p_valueObj.valueMaskPlainText)
    : (displayValueText);
  const hoverText = (p_hoverText !== undefined)
    ? (p_hoverText + " " + hoverValueText)
    : ((p_valueObj === undefined) ? (undefined) : (p_valueObj.hoverText));
  const alignClass = (p_cstCellAlignClass === undefined) ? ("") : (" " + p_cstCellAlignClass);

  return(
    <div
      className={(p_fixedWidthTF ? "flex00a" : "flex11a") + " displayFlexRowVc lrPad" + alignClass}
      style={{flexBasis:p_basis}}
      title={hoverText}>
      {(p_label !== undefined) &&
        <LibraryReact.DivFont p_class="flex00a smallRightMargin" p_fontClass="font09 fontItalic fontTextLightester">
          {p_label + ":"}
        </LibraryReact.DivFont>
      }
      <div className="flex11a">
        <LibraryReact.NowrapEllipsis p_fontClass={p_fontClass}>
          {p_displayValueHasFlexWrapMaskTF ? (
            <div className="" style={{display:"flex", flexWrap:"nowrap", minWidth:0, overflow:"hidden"}}>
              {displayValue}
            </div>
          ) : (displayValue)}
        </LibraryReact.NowrapEllipsis>
      </div>
    </div>
  );
}












//======================================================================================================================================
//======================================================================================================================================
//Capture Table Presets Editor / Gantt Presets Editor
//======================================================================================================================================
//======================================================================================================================================

export const PresetEditorFloatingBox = inject("CaptureExecMobx", "CapturesMobx")(observer(
class PresetEditorFloatingBox extends Component {
  onclose_editor = () => {
    this.props.CapturesMobx.a_set_capture_table_preset_editor_open_tf(false);
    this.props.CapturesMobx.a_set_gantt_dates_preset_editor_open_tf(false);
    this.props.CapturesMobx.a_set_preset_editor_open_filter_preset_matching_captures_list_max_num_captures_drawn_or_m1(25);
  }

  render() {
    const c_isMobileTF = this.props.CaptureExecMobx.c_isMobileTF;
    const o_masterPresetEditorOpenTF = this.props.CapturesMobx.o_masterPresetEditorOpenTF;
    const o_ganttDatesPresetEditorOpenTF = this.props.CapturesMobx.o_ganttDatesPresetEditorOpenTF;

    //neither the master or gantt preset editors are open
    if(!o_masterPresetEditorOpenTF && !o_ganttDatesPresetEditorOpenTF) {
      return(null);
    }

    var floatingBoxTitle = undefined;
    var leftSideComponent = null;
    var rightSideComponent = null;
    var rightSideIsOpenTF = false; //in mobile, only 1 side can be shown at a time, if an item is open, then show the right side, otherwise show the list of items on the left
    if(o_masterPresetEditorOpenTF) {
      floatingBoxTitle = "Create/Edit Capture Table Presets (Columns/Filters/Sorts)";
      leftSideComponent = (<PresetEditorLeftPresetsList />);
      rightSideComponent = (<PresetEditorRightOpenPreset />);
      rightSideIsOpenTF = (this.props.CapturesMobx.o_presetEditorOpenPresetTypeOrUndefined !== undefined && this.props.CapturesMobx.o_presetEditorOpenPresetIDOrUndefined !== undefined);
    }
    else if(o_ganttDatesPresetEditorOpenTF) {
      floatingBoxTitle = "Create/Edit Gantt Date Presets";
      leftSideComponent = (<GanttPresetEditorLeftPresetsList />);
      rightSideComponent = (<GanttPresetEditorRightOpenPreset />);
      rightSideIsOpenTF = (this.props.CapturesMobx.o_ganttDatesOpenPresetID !== undefined);
    }

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="contactsSystemSelect"
        p_title={floatingBoxTitle}
        f_onClickSave={this.onclose_editor}>
        {(o_masterPresetEditorOpenTF) &&
          <div className="flex00a">
            <PresetTopQuickAccessSelections />
          </div>
        }
        <div className="flex11a displayFlexColumn">
          {(c_isMobileTF) ? (
            <div className="flex11a displayFlexColumn">
              {((rightSideIsOpenTF) ? (rightSideComponent) : (leftSideComponent))}
            </div>
          ) : (
            <div className="flex11a displayFlexRow">
              <div className="flex11a displayFlexColumn" style={{flexBasis:"100em", borderRight:"solid 1px #ccc"}}>
                {leftSideComponent}
              </div>
              <div className="flex11a displayFlexColumn" style={{flexBasis:"100em"}}>
                {rightSideComponent}
              </div>
            </div>
          )}
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));






//-------------------------------------------------------------------------------------------------------------------------------------
//"Capture Table" Preset Editor
//-------------------------------------------------------------------------------------------------------------------------------------
const PresetTopQuickAccessSelections = inject("CapturesMobx")(observer(
class PresetTopQuickAccessSelections extends Component {
  render() {
    const c_userQuickAccessCaptureTablePresetsArrayOfObjs = this.props.CapturesMobx.c_userQuickAccessCaptureTablePresetsArrayOfObjs; //this includes the default -2 "My Captures" if there are no presets designated for quick access, don't include it in the editor here

    const canResortTF = (c_userQuickAccessCaptureTablePresetsArrayOfObjs.length > 1); //no need to allow drag/drop if there is only 1 button added so far

    return(
      <div className="displayFlexRowVc flexWrap borderB1bbb tbMicroPad" style={{backgroundColor:"#cfdde9"}}>
        <div className="flex00a displayFlexColumnHcVc lrMargin" style={{height:"3.9em"}}>
          <font className="fontItalic fontTextLight">
            <div>{"Quick Access"}</div>
            <div>{"View Buttons:"}</div>
          </font>
        </div>
        {c_userQuickAccessCaptureTablePresetsArrayOfObjs.map((m_masterPresetObj) =>
          <PresetEditorSelectedQAMasterPresetButton
            key={m_masterPresetObj.id}
            p_masterPresetObj={m_masterPresetObj}
            p_canResortTF={canResortTF}
          />
        )}
        {(canResortTF) &&
          <PresetEditorSelectedQAMasterPresetButton
            p_masterPresetObj={undefined}
            p_canResortTF={canResortTF}
          />
        }
      </div>
    );
  }
}));


const PresetEditorSelectedQAMasterPresetButton = inject("CaptureExecMobx", "CapturesMobx")(observer(
class PresetEditorSelectedQAMasterPresetButton extends Component { //props: p_masterPresetObj, p_canResortTF
  onclick_open_quick_access_selection_item = () => {
    const p_masterPresetObj = this.props.p_masterPresetObj;
    this.props.CapturesMobx.a_set_preset_editor_open_preset_type_and_id("master", p_masterPresetObj.id);
  }

  onremove_master_preset_quick_access = () => {
    const p_masterPresetObj = this.props.p_masterPresetObj;
    this.props.CapturesMobx.a_remove_master_preset_from_quick_access(p_masterPresetObj.id);
  }

  ondragover_other_preset = (i_isDragOverTF) => {
    this.setState({s_isDragOverTF:i_isDragOverTF});
  }

  ondrop_other_preset = (i_draggedMasterPresetID) => { //does not trigger when dropped onto itself, which would not sort any differently anyway
    const droppedOnMasterPresetID = this.props.p_masterPresetObj.id;
    this.props.CapturesMobx.a_resort_selected_quick_access_master_presets(i_draggedMasterPresetID, droppedOnMasterPresetID);
  }

  ondrop_last_blank_dropzone = (i_draggedMasterPresetID) => {
    this.props.CapturesMobx.a_resort_selected_quick_access_master_presets(i_draggedMasterPresetID, -1);
  }

  render() {
    const p_masterPresetObj = this.props.p_masterPresetObj;
    const p_canResortTF = this.props.p_canResortTF;

    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const o_presetEditorOpenPresetTypeOrUndefined = this.props.CapturesMobx.o_presetEditorOpenPresetTypeOrUndefined;
    const o_presetEditorOpenPresetIDOrUndefined = this.props.CapturesMobx.o_presetEditorOpenPresetIDOrUndefined;

    //if p_masterPresetObj is undefined, it is meant to be a blank dropzone at the end of the sortable master preset buttons
    if(p_masterPresetObj === undefined) {
      return(
        <CEGeneralReact.CE3Drag3Drop3Shell3
          p_uniqueString="presetEditorSelectedQAMasterPreset"
          p_itemID={-1}
          p_draggableTF={p_canResortTF}
          p_droppableTF={p_canResortTF}
          p_dropZoneIsInvisibleOverlayTF={true}
          p_dropZoneOversizeWidthEm={undefined}
          p_class="flex00a smallFullMargin"
          p_styleObj={{flexBasis:"10em", height:"3em"}}
          p_dragOverStyleObj={{border:"solid 2px #333", backgroundColor:"rgba(0,0,0,0.2)"}}
          f_onDropMatchingItem={this.ondrop_last_blank_dropzone}
        />
      );
    }

    const isSelectedTF = ((o_presetEditorOpenPresetTypeOrUndefined === "master") && (o_presetEditorOpenPresetIDOrUndefined === p_masterPresetObj.id));

    var title = "'" + p_masterPresetObj.name + "'";
    title += "\n\n[Click to edit the presets for this View Button]";
    var cursorClass = "cursorPointer";
    if(p_canResortTF) {
      title += "\n[Drag/drop this View Button to reorder]";
      cursorClass = "cursorGrab";
    }

    return(
      <CEGeneralReact.CE3Drag3Drop3Shell3
        p_uniqueString="presetEditorSelectedQAMasterPreset"
        p_itemID={p_masterPresetObj.id}
        p_draggableTF={p_canResortTF}
        p_droppableTF={p_canResortTF}
        p_dropZoneIsInvisibleOverlayTF={true}
        p_dropZoneOversizeWidthEm={undefined}
        p_class={"flex00a displayFlexRow tbMicroMargin smallRightMargin border bevelBorderColors " + ((isSelectedTF) ? (c_productStylingObj.capturesTabMasterButtonSelectedBgClass) : (c_productStylingObj.capturesTabMasterButtonUnselectedBgClass)) + " " + cursorClass}
        p_styleObj={{flexBasis:"8.5em", height:"3.7em"}}
        p_title={title}
        p_dragOverClass={undefined}
        p_dragOverStyleObj={{border:"solid 2px #333", backgroundColor:"rgba(0,0,0,0.2)"}}
        f_onDropMatchingItem={this.ondrop_other_preset}
        f_onClick={this.onclick_open_quick_access_selection_item}>
        <div className="flex11a displayFlexRowVc" style={{padding:"0 0.3em"}}>
          <LibraryReact.MaxHeightWrap p_maxHeight="3.3em" p_fontClass={"font09 " + ((isSelectedTF) ? (c_productStylingObj.capturesTabMasterButtonSelectedFontClass) : (c_productStylingObj.capturesTabMasterButtonUnselectedFontClass))}>
            {p_masterPresetObj.name}
          </LibraryReact.MaxHeightWrap>
        </div>
        <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"1.6em"}}>
          <CEGeneralReact.RemoveItemXWithRedHover
            p_title={"Remove master preset '" + p_masterPresetObj.name + "' from your quick access bar"}
            f_onClick={this.onremove_master_preset_quick_access}
          />
        </div>
      </CEGeneralReact.CE3Drag3Drop3Shell3>
    );
  }
}));


const PresetEditorLeftPresetsList = inject("CapturesMobx", "UserMobx")(observer(
class PresetEditorLeftPresetsList extends Component {
  onswitch_view_presets_from_other_users_switch = () => {
    const o_presetEditorViewPresetsFromOtherUsersTF = this.props.CapturesMobx.o_presetEditorViewPresetsFromOtherUsersTF;
    this.props.CapturesMobx.a_set_preset_editor_view_presets_from_other_users_tf(!o_presetEditorViewPresetsFromOtherUsersTF);
  }

  onclick_create_new_preset_to_enter_name = (i_createPresetType) => {
    this.props.CapturesMobx.a_set_preset_editor_creating_new_preset_type(i_createPresetType);
  }

  onclick_save_new_preset_name = (i_newPresetName) => {
    const o_presetEditorCreatingNewPresetType = this.props.CapturesMobx.o_presetEditorCreatingNewPresetType;
    this.props.CapturesMobx.a_create_new_master_columns_filter_sort_preset(o_presetEditorCreatingNewPresetType, i_newPresetName);
    this.props.CapturesMobx.a_set_preset_editor_creating_new_preset_type(undefined);
  }

  onclick_cancel_create_new_preset = () => {
    this.props.CapturesMobx.a_set_preset_editor_creating_new_preset_type(undefined);
  }

  render() {
    const o_presetEditorViewPresetsFromOtherUsersTF = this.props.CapturesMobx.o_presetEditorViewPresetsFromOtherUsersTF;
    const o_presetEditorCreatingNewPresetType = this.props.CapturesMobx.o_presetEditorCreatingNewPresetType;
    const c_presetMyCaptureTablePresetsArrayOfObjs = this.props.CapturesMobx.c_presetMyCaptureTablePresetsArrayOfObjs;
    const c_presetPublicCaptureTablePresetsArrayOfObjs = this.props.CapturesMobx.c_presetPublicCaptureTablePresetsArrayOfObjs;
    const c_presetSystemCaptureTablePresetsArrayOfObjs = this.props.CapturesMobx.c_presetSystemCaptureTablePresetsArrayOfObjs;
    const c_presetMyCstColumnPresetsArrayOfObjs = this.props.CapturesMobx.c_presetMyCstColumnPresetsArrayOfObjs;
    const c_presetPublicCstColumnPresetsArrayOfObjs = this.props.CapturesMobx.c_presetPublicCstColumnPresetsArrayOfObjs;
    const c_presetSystemCstColumnPresetsWithCstColumnsArrayOfObjs = this.props.CapturesMobx.c_presetSystemCstColumnPresetsWithCstColumnsArrayOfObjs;
    const c_presetMyFilterPresetsArrayOfObjs = this.props.CapturesMobx.c_presetMyFilterPresetsArrayOfObjs;
    const c_presetPublicFilterPresetsArrayOfObjs = this.props.CapturesMobx.c_presetPublicFilterPresetsArrayOfObjs;
    const c_presetSystemFilterPresetsWithFiltersArrayOfObjs = this.props.CapturesMobx.c_presetSystemFilterPresetsWithFiltersArrayOfObjs;
    const c_presetMySortPresetsArrayOfObjs = this.props.CapturesMobx.c_presetMySortPresetsArrayOfObjs;
    const c_presetPublicSortPresetsArrayOfObjs = this.props.CapturesMobx.c_presetPublicSortPresetsArrayOfObjs;
    const c_presetSystemSortPresetsWithSortsArrayOfObjs = this.props.CapturesMobx.c_presetSystemSortPresetsWithSortsArrayOfObjs;
    const c_anyOfUsersMultiLoginsHaveAdminPowerTF = this.props.UserMobx.c_anyOfUsersMultiLoginsHaveAdminPowerTF;

    const presetTypesArray = ["master", "cstColumns", "filter", "sort"];
    const createNewPresetButtonLabelsArray = ["View Button", "Column", "Filter", "Sort"];
    const presetLabelsArray = ["View Buttons (1 Column Preset + 1 Filter Preset + 1 Sort Preset)", "Column Presets", "Filter Presets", "Sort Presets"];
    const myPresetsArrayOfArrayOfObjs = [c_presetMyCaptureTablePresetsArrayOfObjs, c_presetMyCstColumnPresetsArrayOfObjs, c_presetMyFilterPresetsArrayOfObjs, c_presetMySortPresetsArrayOfObjs];
    const publicPresetsArrayOfArrayOfObjs = [c_presetPublicCaptureTablePresetsArrayOfObjs, c_presetPublicCstColumnPresetsArrayOfObjs, c_presetPublicFilterPresetsArrayOfObjs, c_presetPublicSortPresetsArrayOfObjs];
    const systemPresetsArrayOfArrayOfObjs = [c_presetSystemCaptureTablePresetsArrayOfObjs, c_presetSystemCstColumnPresetsWithCstColumnsArrayOfObjs, c_presetSystemFilterPresetsWithFiltersArrayOfObjs, c_presetSystemSortPresetsWithSortsArrayOfObjs];

    return(
      <div className="flex11a displayFlexColumn">
        <div className="flex00a" style={{borderBottom:"solid 1px #ccc"}}>
          {(o_presetEditorCreatingNewPresetType === undefined) ? (
            <div className="displayFlexRow">
              {presetTypesArray.map((m_presetType, m_index) =>
                <PresetEditorLeftCreateNewPresetButton
                  key={createNewPresetButtonLabelsArray[m_index]}
                  p_presetType={m_presetType}
                  p_label={createNewPresetButtonLabelsArray[m_index]}
                  f_onClick={this.onclick_create_new_preset_to_enter_name}
                />
              )}
            </div>
          ) : (
            <PresetEditorNewPresetNameInputSaveCancel
              p_instructions={"Enter a name for the new " + createNewPresetButtonLabelsArray[presetTypesArray.indexOf(o_presetEditorCreatingNewPresetType)] + " Preset"}
              f_onClickSave={this.onclick_save_new_preset_name}
              f_onClickCancel={this.onclick_cancel_create_new_preset}
            />
          )}
        </div>
        <div className="flex11a yScroll yScrollBottomPad" style={{backgroundColor:"#f8f8f8"}}>
          {(c_anyOfUsersMultiLoginsHaveAdminPowerTF) &&
            <div className="displayFlexRow" style={{height:"1.8em"}}>
              <div className="flex11a displayFlexColumnVc textRight">
                <font className="fontItalic fontTextLight">
                  {"Show/Edit Presets created by other Users"}
                </font>
              </div>
              <div className="flex00a displayFlexRowVc lrMedPad">
                <CEGeneralReact.SwitchWithTextAndConfirmBox
                  p_isOnTF={o_presetEditorViewPresetsFromOtherUsersTF}
                  p_sizeEm={2.6}
                  p_onColor="cc7722"
                  p_title={"Switch on to show all Presets created by all other Users and have the ability to edit/delete them (this switch is only available for Admins)"}
                  f_onSwitch={this.onswitch_view_presets_from_other_users_switch}
                />
              </div>
            </div>
          }
          {presetTypesArray.map((m_presetType, m_index) =>
            <PresetEditorLeftPresetTypeMyAndPublicAndSystemLists
              key={m_presetType}
              p_presetType={m_presetType}
              p_presetLabel={presetLabelsArray[m_index]}
              p_myPresetsArrayOfObjs={myPresetsArrayOfArrayOfObjs[m_index]}
              p_publicPresetsArrayOfObjs={publicPresetsArrayOfArrayOfObjs[m_index]}
              p_systemPresetsArrayOfObjsOrUndefined={systemPresetsArrayOfArrayOfObjs[m_index]}
            />
          )}
        </div>
      </div>
    );
  }
}));


const PresetEditorLeftCreateNewPresetButton = inject("CapturesMobx")(observer(
class PresetEditorLeftCreateNewPresetButton extends Component { //props: p_presetType, p_label
  onclick_create_new_preset = () => {
    this.props.CapturesMobx.a_set_preset_editor_creating_new_preset_type(this.props.p_presetType);
  }

  render() {
    const p_presetType = this.props.p_presetType; //"master", "cstColumns", "filter", "sort"
    const p_label = this.props.p_label;

    return(
      <div
        className="flex11a displayFlexColumn smallFullMargin hoverLightestBlueGradient cursorPointer"
        style={{flexBasis:"100em", height:"3.3em", border:"solid 2px #99a", borderRadius:"0.7em"}}
        onClick={this.onclick_create_new_preset}>
        <div className="flex11a displayFlexRowVc textCenter" title={"Create a new " + p_label + " Preset"}>
          <LibraryReact.MaxHeightWrap p_maxHeight="2.4em" p_fontClass="fontTextLight">
            <div>{"Create New"}</div>
            <div><font className="fontBold">{p_label}</font>{" Preset"}</div>
          </LibraryReact.MaxHeightWrap>
        </div>
        <PresetTypeColorBar p_presetType={p_presetType} p_width="0.35em" />
      </div>
    );
  }
}));


class PresetEditorNewPresetNameInputSaveCancel extends Component { //props: p_instructions, f_onClickSave, f_onClickCancel
  constructor(props) {
    super(props);
    this.state = {
      s_newPresetNameText: "",
      s_showErrorsTF: false
    }
  }

  onchange_new_preset_name = (i_newValue) => {
    this.setState({s_newPresetNameText:i_newValue});
  }

  onclick_save = () => {
    if(JSFUNC.is_function(this.props.f_onClickSave)) {
      this.setState({s_showErrorsTF:true});
      if(!this.new_name_error_tf()) {
        this.props.f_onClickSave(this.state.s_newPresetNameText);
      }
    }
  }

  onclick_cancel = () => {
    if(JSFUNC.is_function(this.props.f_onClickCancel)) {
      this.props.f_onClickCancel();
    }
  }

  new_name_error_tf = () => {
    return(this.state.s_newPresetNameText === "");
  }

  render() {
    const s_newPresetNameText = this.state.s_newPresetNameText;
    const s_showErrorsTF = this.state.s_showErrorsTF;

    var nameBlankErrorTF = false;
    if(s_showErrorsTF) {
      nameBlankErrorTF = this.new_name_error_tf();
    }

    return(
      <div className="medFullPad bgCaptureItemEditing">
        <div className="smallBottomMargin textCenter">
          <font className="fontBold fontItalic">
            {this.props.p_instructions}
          </font>
        </div>
        <CEGeneralReact.EditInlineWithSaveCancel
          p_fieldValueVerticallyAlignedTF={true}
          f_onClickSave={this.onclick_save}
          f_onClickCancel={this.onclick_cancel}>
          <LibraryReact.Text
            p_value={s_newPresetNameText}
            p_styleObj={{width:"100%"}}
            p_tabIndex={1}
            p_errorTF={nameBlankErrorTF}
            f_onChange={this.onchange_new_preset_name}
            f_onKeyDownEnter={this.onclick_save}
          />
        </CEGeneralReact.EditInlineWithSaveCancel>
        {(nameBlankErrorTF) &&
          <CEGeneralReact.ErrorText p_text="New Preset Name cannot be blank" />
        }
      </div>
    );
  }
}


function PresetEditorLeftPresetTypeMyAndPublicAndSystemLists(props) { //props: p_presetType, p_presetLabel, p_myPresetsArrayOfObjs, p_publicPresetsArrayOfObjs, p_systemPresetsArrayOfObjsOrUndefined
  const p_presetType = props.p_presetType; //"master", "cstColumns", "filter", "sort"
  const p_presetLabel = props.p_presetLabel;
  const p_myPresetsArrayOfObjs = props.p_myPresetsArrayOfObjs;
  const p_publicPresetsArrayOfObjs = props.p_publicPresetsArrayOfObjs;
  const p_systemPresetsArrayOfObjsOrUndefined = props.p_systemPresetsArrayOfObjsOrUndefined;

  return(
    <div className="displayFlexRow borderT1ddd borderB1ddd" style={{marginBottom:"3em", backgroundColor:"#fafafa"}}>
      <PresetTypeColorBar p_presetType={p_presetType} p_width="1em" />
      <div className="flex11a">
        <div className="lrPad smallTopPad medBottomPad">
          <div>
            <font className="font12 fontBold fontTextLighter">
              {p_presetLabel}
            </font>
          </div>
          <div className="smallTopMargin" style={{marginLeft:"0.4em"}}>
            <PresetEditorPresetTypeSubHeading p_label={"My Presets (" + p_myPresetsArrayOfObjs.length + ")"} />
            {p_myPresetsArrayOfObjs.map((m_myPresetObj) =>
              <LeftPresetItem
                key={m_myPresetObj.id}
                p_presetType={p_presetType}
                p_presetObj={m_myPresetObj}
              />
            )}
            <div className="bigTopPad" />
            <PresetEditorPresetTypeSubHeading p_label={"Public Presets (" + p_publicPresetsArrayOfObjs.length + ")"} />
            {p_publicPresetsArrayOfObjs.map((m_publicPresetObj) =>
              <LeftPresetItem
                key={m_publicPresetObj.id}
                p_presetType={p_presetType}
                p_presetObj={m_publicPresetObj}
              />
            )}
            {(JSFUNC.is_array_not_empty(p_systemPresetsArrayOfObjsOrUndefined)) &&
              <>
                <div className="bigTopPad" />
                <PresetEditorPresetTypeSubHeading p_label={"System Presets (" + p_systemPresetsArrayOfObjsOrUndefined.length + ")"} />
                {p_systemPresetsArrayOfObjsOrUndefined.map((m_systemPresetObj) =>
                  <LeftPresetItem
                    key={m_systemPresetObj.id}
                    p_presetType={p_presetType}
                    p_presetObj={m_systemPresetObj}
                    p_isSystemTF={true}
                  />
                )}
              </>
            }
          </div>
        </div>
      </div>
    </div>
  );
}


const LeftPresetItem = inject("CapturesMobx")(observer(
class LeftPresetItem extends Component { //props: p_presetType, p_presetObj, p_isSystemTF
  onclick_preset_item = () => {
    this.props.CapturesMobx.a_set_preset_editor_open_preset_type_and_id(this.props.p_presetType, this.props.p_presetObj.id);
  }

  onclick_add_master_preset_to_quick_access = () => {
    this.props.CapturesMobx.a_add_master_preset_to_quick_access(this.props.p_presetObj.id);
  }

  ondelete_preset = () => {
    this.props.CapturesMobx.a_delete_master_columns_filter_sort_preset(this.props.p_presetType, this.props.p_presetObj.id);
  }

  render() {
    const p_presetType = this.props.p_presetType;
    const p_presetObj = this.props.p_presetObj;
    const p_isSystemTF = JSFUNC.prop_value(this.props.p_isSystemTF, false);
    
    const o_presetEditorViewPresetsFromOtherUsersTF = this.props.CapturesMobx.o_presetEditorViewPresetsFromOtherUsersTF;
    const c_presetEditorOpenPresetObj = this.props.CapturesMobx.c_presetEditorOpenPresetObj;

    var canAddMasterToQuickAccessTF = false;
    if(p_presetType === "master") {
      canAddMasterToQuickAccessTF = (!JSFUNC.in_array(p_presetObj.id, this.props.CapturesMobx.c_userQuickAccessMasterPresetIDsArray));
    }

    var rowBgClass = "bgAlmostWhite";
    if((c_presetEditorOpenPresetObj !== undefined) && (c_presetEditorOpenPresetObj.presetType === p_presetType) && (c_presetEditorOpenPresetObj.id === p_presetObj.id)) {
      rowBgClass = "bgCaptureItemEditing";
    }

    return(
      <div
        className={"displayFlexRow microTopMargin microBottomMargin border bevelBorderColors bgWhite hoverLighterBlueGradient cursorPointer " + rowBgClass}
        style={{height:"2.7em"}}
        onClick={this.onclick_preset_item}>
        <PresetTypeColorBar p_presetType={p_presetType} p_width="0.2em" />
        <div className="flex11a displayFlexRowVc lrMargin">
          <LibraryReact.MaxHeightWrap p_maxHeight="2.4em" p_fontClass="">
            {p_presetObj.name}
          </LibraryReact.MaxHeightWrap>
        </div>
        {(p_presetType === "master") &&
          <div className="flex00a displayFlexColumnHcVc">
            {(canAddMasterToQuickAccessTF) ? (
              <div
                className="border bevelBorderColors displayFlexColumnHcVc lrMedPad bgLightGrayGradient hoverLighterGrayGradient"
                style={{height:"1.5em", borderRadius:"1em"}}
                title={"Click to add this Capture Table View Button '" + p_presetObj.name + "' to the Quick Access Bar above the capture summary table"}
                onClick={this.onclick_add_master_preset_to_quick_access}>
                <font className="fontItalic">
                  {"Add to Quick Access"}
                </font>
              </div>
            ) : (
              <font className="fontItalic fontTextLighter">
                {"On your Quick Access"}
              </font>
            )}
          </div>
        }
        <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"3em"}}>
          {(!p_isSystemTF && (p_presetObj.isPresetOwnerCanEditTF || o_presetEditorViewPresetsFromOtherUsersTF)) &&
            <CEGeneralReact.DeleteMenu
              p_menuItemText="Delete"
              p_message={"Are you sure you want to delete preset '" + p_presetObj.name + "'"}
              f_onDelete={this.ondelete_preset}
            />
          }
        </div>
      </div>
    );
  }
}));


function PresetTypeColorBar(props) { //props: p_presetType, p_width
  var bgColorClass = "bgWhite";
  if(props.p_presetType === "master") {
    bgColorClass = "bgCstPresetsMaster";
  }
  else if(props.p_presetType === "cstColumns") {
    bgColorClass = "bgCstPresetsCstColumns";
  }
  else if(props.p_presetType === "filter") {
    bgColorClass = "bgCstPresetsFilters";
  }
  else if(props.p_presetType === "sort") {
    bgColorClass = "bgCstPresetsSorts";
  }

  return(
    <div className={"flex00a " + bgColorClass} style={{flexBasis:props.p_width}} />
  );
}


const PresetEditorRightOpenPreset = inject("CapturesMobx", "DatabaseMobx", "UserMobx")(observer(
class PresetEditorRightOpenPreset extends Component {
  onclick_close_preset = () => {
    this.props.CapturesMobx.a_set_preset_editor_open_preset_type_and_id(undefined, undefined);
  }

  onclick_back_to_master_preset = () => {
    const o_presetEditorOpenCFSPresetIsFromMasterPresetIDOrUndefined = this.props.CapturesMobx.o_presetEditorOpenCFSPresetIsFromMasterPresetIDOrUndefined;
    this.props.CapturesMobx.a_set_preset_editor_open_preset_type_and_id("master", o_presetEditorOpenCFSPresetIsFromMasterPresetIDOrUndefined); //return to the master preset that this CFS preset was opened from
    this.props.CapturesMobx.a_set_preset_editor_open_cfs_preset_is_from_master_preset_id_or_undefined(undefined); //reset the CFS master tracker
  }

  onclick_confirm_create_copied_preset = (i_newPresetName) => {
    this.props.CapturesMobx.a_copy_preset_with_new_name(this.props.CapturesMobx.c_presetEditorOpenPresetObj, i_newPresetName);
  }

  onsave_new_preset_name = (i_newPresetName) => {
    this.props.CapturesMobx.a_update_preset_field(this.props.CapturesMobx.c_presetEditorOpenPresetObj, "name", i_newPresetName, "s");
  }

  onsave_new_preset_description = (i_newPresetDescription) => {
    this.props.CapturesMobx.a_update_preset_field(this.props.CapturesMobx.c_presetEditorOpenPresetObj, "description", i_newPresetDescription, "s");
  }

  onclick_preset_public_switch = () => {
    const newPublic01Value = ((this.props.CapturesMobx.c_presetEditorOpenPresetObj.public_01 === 1) ? (0) : (1));
    this.props.CapturesMobx.a_update_preset_field(this.props.CapturesMobx.c_presetEditorOpenPresetObj, "public_01", newPublic01Value, "i");
  }

  onsave_new_preset_excel_report_writer_codeword = (i_newExcelReportWriterCodeword) => {
    const newExcelReportWriterCodewordDbName = JSFUNC.db_name_from_display_name(i_newExcelReportWriterCodeword);
    this.props.CapturesMobx.a_update_preset_field(this.props.CapturesMobx.c_presetEditorOpenPresetObj, "excel_report_writer_codeword", newExcelReportWriterCodewordDbName, "s");
  }

  render() {
    const o_presetEditorOpenCFSPresetIsFromMasterPresetIDOrUndefined = this.props.CapturesMobx.o_presetEditorOpenCFSPresetIsFromMasterPresetIDOrUndefined;
    const c_presetEditorOpenPresetObj = this.props.CapturesMobx.c_presetEditorOpenPresetObj;
    const c_userCanCreatePublicItemsTF = this.props.UserMobx.c_userCanCreatePublicItemsTF;

    if(c_presetEditorOpenPresetObj === undefined) {
      return(
        <CEGeneralReact.EmptyScreenGray>
          {"Select a preset to view/edit its components"}
        </CEGeneralReact.EmptyScreenGray>
      );
    }

    const presetMenuItemsArrayOfObjs = [
      {
        displayName: "Copy this as a new " + c_presetEditorOpenPresetObj.presetLabel + " Preset",
        confirmType: "inputText",
        confirmTitle: "Copy " + c_presetEditorOpenPresetObj.presetLabel + " Preset '" + c_presetEditorOpenPresetObj.name + "'",
        confirmTextInitialValue: "Copy of " + c_presetEditorOpenPresetObj.name,
        confirmButton1Name: "Create Copy",
        confirmTextMustBeChangedForSaveTFU: false,
        confirmMessage: "Enter a new name for this copied " + c_presetEditorOpenPresetObj.presetLabel + " Preset",
        functionOnClickConfirmButton: this.onclick_confirm_create_copied_preset
      }
    ];

    const openCFSPresetIsFromMasterPresetTF = (o_presetEditorOpenCFSPresetIsFromMasterPresetIDOrUndefined !== undefined);

    const containerClass = "smallTopMargin lrMargin";
    const fieldClass = "fontBlue";
    const fieldWidth = "14em";

    const editSaveCancelOwnerComponent = (
      <CEGeneralReact.CaptureExecFieldEditSaveCancel
        p_ceEditItemString={c_presetEditorOpenPresetObj.presetType + "PresetID" + c_presetEditorOpenPresetObj.id + "owner"}
        p_fieldDisplayName="Owner"
        p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
        p_valueRaw={c_presetEditorOpenPresetObj.user_id}
        p_valueMask={c_presetEditorOpenPresetObj.ownerUserNameMask}
        p_valueIsEditableTFU={false}
        p_containerClass={containerClass}
        p_fieldClass={fieldClass}
        p_fieldWidth={fieldWidth}
        p_fieldValueVerticallyAlignedTF={true}
        f_onSaveChanged={undefined}
      />
    );

    const editSaveCancelPresetNameComponent = (
      <CEGeneralReact.CaptureExecFieldEditSaveCancel
        p_ceEditItemString={c_presetEditorOpenPresetObj.presetType + "PresetID" + c_presetEditorOpenPresetObj.id + "name"}
        p_fieldDisplayName={c_presetEditorOpenPresetObj.presetLabel + " Preset Name"}
        p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
        p_valueRaw={c_presetEditorOpenPresetObj.name}
        p_valueIsEditableTFU={c_presetEditorOpenPresetObj.isPresetOwnerCanEditTF}
        p_containerClass={containerClass}
        p_fieldClass={fieldClass}
        p_fieldWidth={fieldWidth}
        p_fieldValueVerticallyAlignedTF={true}
        f_onSaveChanged={this.onsave_new_preset_name}
      />
    );

    var editSaveCancelMasterHoverDescriptionComponent = null; //only master has hover text description field to edit for its preset
    if(c_presetEditorOpenPresetObj.isMasterTF) {
      editSaveCancelMasterHoverDescriptionComponent = (
        <CEGeneralReact.CaptureExecFieldEditSaveCancel
          p_ceEditItemString={c_presetEditorOpenPresetObj.presetType + "PresetID" + c_presetEditorOpenPresetObj.id + "description"}
          p_fieldDisplayName="Hover Description"
          p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
          p_valueRaw={c_presetEditorOpenPresetObj.description}
          p_valueIsEditableTFU={c_presetEditorOpenPresetObj.isPresetOwnerCanEditTF}
          p_containerClass={containerClass}
          p_fieldClass={fieldClass}
          p_fieldWidth={fieldWidth}
          p_fieldValueVerticallyAlignedTF={true}
          f_onSaveChanged={this.onsave_new_preset_description}
        />
      );
    }

    var editSaveCancelFilterSortExcelReportWriterCodewordComponent = null;
    if(c_presetEditorOpenPresetObj.isFilterTF || c_presetEditorOpenPresetObj.isSortTF) {
      editSaveCancelFilterSortExcelReportWriterCodewordComponent = (
        <CEGeneralReact.CaptureExecFieldEditSaveCancel
          p_ceEditItemString={c_presetEditorOpenPresetObj.presetType + "PresetID" + c_presetEditorOpenPresetObj.id + "excelreportwritercodeword"}
          p_fieldDisplayName="Excel Report Writer Codeword"
          p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
          p_valueRaw={c_presetEditorOpenPresetObj.excel_report_writer_codeword}
          p_valueIsEditableTFU={c_presetEditorOpenPresetObj.isPresetOwnerCanEditTF}
          p_containerClass={containerClass}
          p_fieldClass={fieldClass}
          p_fieldWidth={fieldWidth}
          p_fieldValueVerticallyAlignedTF={true}
          f_onSaveChanged={this.onsave_new_preset_excel_report_writer_codeword}
        />
      );
    }

    return(
      <div className="flex11a displayFlexColumn" style={{backgroundColor:"#f3f6fc"}}>
        <div className="flex00a displayFlexRow borderB1bbb">
          <div className="flex11a displayFlexColumnVc lrPad">
            <LibraryReact.NowrapEllipsis p_fontClass="font13 fontBold fontTextLighter">
              {"Preset '" + c_presetEditorOpenPresetObj.name + "'"}
            </LibraryReact.NowrapEllipsis>
          </div>
          <div className="flex00a displayFlexColumnHcVc borderR1bbb" style={{flexBasis:"2em"}}>
            <CEGeneralReact.VerticalDotsMenu
              p_menuItemsArrayOfObjs={presetMenuItemsArrayOfObjs}
            />
          </div>
          <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"7em"}}>
            <CEGeneralReact.CEButton
              p_type="gray"
              p_text={((openCFSPresetIsFromMasterPresetTF) ? ("Back") : ("Close"))}
              f_onClick={((openCFSPresetIsFromMasterPresetTF) ? (this.onclick_back_to_master_preset) : (this.onclick_close_preset))}
            />
          </div>
        </div>
        <div className="flex11a yScroll yScrollBottomPad lrPad" style={{flexBasis:"400em"}}>
          {editSaveCancelOwnerComponent}
          {editSaveCancelPresetNameComponent}
          {editSaveCancelMasterHoverDescriptionComponent}
          {editSaveCancelFilterSortExcelReportWriterCodewordComponent}
          {(c_presetEditorOpenPresetObj.isPresetOwnerCanEditTF && c_userCanCreatePublicItemsTF) &&
            <div className="displayFlexRowVc smallTopMargin medBottomMargin lrMargin">
              <div className="flex00a" style={{flexBasis:fieldWidth}}>
                <font className={fieldClass}>
                  {"Is Public?"}
                </font>
              </div>
              <div className="flex11a">
                <CEGeneralReact.SwitchWithTextAndConfirmBox
                  p_isOnTF={(c_presetEditorOpenPresetObj.public_01 === 1)}
                  p_sizeEm={3}
                  p_onText="Public to everyone"
                  p_offText="Private to me"
                  p_title={"Turn on to make your created " + c_presetEditorOpenPresetObj.presetLabel + " Preset public to all users in your company"}
                  f_onSwitch={this.onclick_preset_public_switch}
                />
              </div>
            </div>
          }
          {(c_presetEditorOpenPresetObj.isMasterTF) ? (
            <PresetEditorOpenMasterPreset />
          ) : (
            <PresetEditorOpenCFSPreset />
          )}
        </div>
        {(c_presetEditorOpenPresetObj.isFilterTF) &&
          <PresetEditorOpenFilterPresetMatchingCapturesList />
        }
      </div>
    );
  }
}));


const PresetEditorOpenMasterPreset = inject("CapturesMobx")(observer(
class PresetEditorOpenMasterPreset extends Component {
  render() {
    const c_presetEditorOpenPresetObj = this.props.CapturesMobx.c_presetEditorOpenPresetObj;

    if(c_presetEditorOpenPresetObj === undefined) {
      return(null);
    }

    const c_selectMyAndPublicColumnPresetsFieldTypeObj = this.props.CapturesMobx.c_selectMyAndPublicColumnPresetsFieldTypeObj;
    const c_selectMyAndPublicFilterPresetsFieldTypeObj = this.props.CapturesMobx.c_selectMyAndPublicFilterPresetsFieldTypeObj;
    const c_selectMyAndPublicSortPresetsFieldTypeObj = this.props.CapturesMobx.c_selectMyAndPublicSortPresetsFieldTypeObj;

    return(
      <>
        <div className="hugeTopMargin" />
        <PresetEditorOpenMasterPresetSingleCFSPreset
          p_masterPresetFieldName="cst_column_preset_id"
          p_presetType="cstColumns"
          p_label="Column Preset"
          p_fieldTypeObj={c_selectMyAndPublicColumnPresetsFieldTypeObj}
        />
        <div className="hugeTopMargin" />
        <PresetEditorOpenMasterPresetSingleCFSPreset
          p_masterPresetFieldName="filter_preset_id"
          p_presetType="filter"
          p_label="Filter Preset"
          p_fieldTypeObj={c_selectMyAndPublicFilterPresetsFieldTypeObj}
        />
        <div className="hugeTopMargin" />
        <PresetEditorOpenMasterPresetSingleCFSPreset
          p_masterPresetFieldName="sort_preset_id"
          p_presetType="sort"
          p_label="Sort Preset"
          p_fieldTypeObj={c_selectMyAndPublicSortPresetsFieldTypeObj}
        />
      </>
    );
  }
}));


const PresetEditorOpenMasterPresetSingleCFSPreset = inject("CapturesMobx", "DatabaseMobx")(observer(
class PresetEditorOpenMasterPresetSingleCFSPreset extends Component { //props: p_masterPresetFieldName, p_presetType, p_label, p_fieldTypeObj
  onselect_cfs_preset_for_master = (i_selectedCFSPresetID) => {
    const p_masterPresetFieldName = this.props.p_masterPresetFieldName;
    const c_presetEditorOpenPresetObj = this.props.CapturesMobx.c_presetEditorOpenPresetObj;
    this.props.CapturesMobx.a_update_preset_field(c_presetEditorOpenPresetObj, p_masterPresetFieldName, i_selectedCFSPresetID, "i");
  }

  onclick_open_cfs_preset = () => {
    const p_masterPresetFieldName = this.props.p_masterPresetFieldName;
    const p_presetType = this.props.p_presetType;
    const c_presetEditorOpenPresetObj = this.props.CapturesMobx.c_presetEditorOpenPresetObj;
    this.props.CapturesMobx.a_set_preset_editor_open_preset_type_and_id(p_presetType, c_presetEditorOpenPresetObj[p_masterPresetFieldName]);
    this.props.CapturesMobx.a_set_preset_editor_open_cfs_preset_is_from_master_preset_id_or_undefined(c_presetEditorOpenPresetObj.id);
  }

  render() {
    const p_masterPresetFieldName = this.props.p_masterPresetFieldName; //"cst_column_preset_id", "filter_preset_id", "sort_preset_id"
    const p_presetType = this.props.p_presetType;
    const p_label = this.props.p_label;
    const p_fieldTypeObj = this.props.p_fieldTypeObj;

    const c_presetEditorOpenPresetObj = this.props.CapturesMobx.c_presetEditorOpenPresetObj;

    const selectedValue = c_presetEditorOpenPresetObj[p_masterPresetFieldName];

    return(
      <>
        <div className="displayFlexRowVc">
          <div className="flex11a">
            <font className="font13 fontBold fontItalic fontTextLighter">
              {p_label}
            </font>
          </div>
          <div className="flex00a lrMargin">
            <CEGeneralReact.CEButton
              p_type="add"
              p_text="Open Preset"
              f_onClick={this.onclick_open_cfs_preset}
            />
          </div>
        </div>
        <div className="microTopMargin">
          {(c_presetEditorOpenPresetObj.isPresetOwnerCanEditTF) ? (
            <CEGeneralReact.GenericInputOrSelectFromInputType
              p_fieldTypeObj={p_fieldTypeObj}
              p_valueRaw={selectedValue}
              f_onChangeOrOnSelect={this.onselect_cfs_preset_for_master}
            />
          ) : (
            this.props.DatabaseMobx.value_mask_from_value_raw_and_field_type_obj(selectedValue, p_fieldTypeObj)
          )}
        </div>
      </>
    );
  }
}));


const PresetEditorOpenCFSPreset = inject("CapturesMobx")(observer(
class PresetEditorOpenCFSPreset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      s_addNewColumnsFirst1Last2: 2
    };
  }

  onadd_selected_new_capture_fields = (i_addedCaptureFieldIDsComma) => {
    const s_addNewColumnsFirst1Last2 = this.state.s_addNewColumnsFirst1Last2;
    const openCFSPresetObj = this.props.CapturesMobx.c_presetEditorOpenPresetObj;
    this.props.CapturesMobx.a_cfs_preset_add_capture_field_items(openCFSPresetObj.presetType, openCFSPresetObj.id, i_addedCaptureFieldIDsComma, openCFSPresetObj.numPresetItems, s_addNewColumnsFirst1Last2);
  }

  onselect_add_columns_first_last = (i_newValue12) => {
    this.setState({s_addNewColumnsFirst1Last2:i_newValue12});
  }

  render() {
    const s_addNewColumnsFirst1Last2 = this.state.s_addNewColumnsFirst1Last2;

    const c_presetEditorOpenPresetObj = this.props.CapturesMobx.c_presetEditorOpenPresetObj;
    const c_viewButtonEditorOpenCFSSelectMultiCaptureFieldsFieldTypeObj = this.props.CapturesMobx.c_viewButtonEditorOpenCFSSelectMultiCaptureFieldsFieldTypeObj;

    if(c_presetEditorOpenPresetObj === undefined) {
      return(null);
    }

    var addPresetItemsTopRowComponent = null;
    if(c_presetEditorOpenPresetObj.isPresetOwnerCanEditTF) {
      const addPresetItemsButtonComponent = (
        <CEGeneralReact.CaptureExecFieldAddNewItemsButton
          p_buttonType="blue"
          p_buttonText={"Add " + c_presetEditorOpenPresetObj.presetLabel + "(s)"}
          p_addInstructions={"Select capture fields to add to this " + c_presetEditorOpenPresetObj.presetLabel + " Preset"}
          p_addInstructionsNowrapTF={true}
          p_fieldTypeObj={c_viewButtonEditorOpenCFSSelectMultiCaptureFieldsFieldTypeObj}
          f_onAddSelectedItems={this.onadd_selected_new_capture_fields}
        />
      );

      addPresetItemsTopRowComponent = (
        <div className="displayFlexRow" style={{height:"5.2em"}}>
          <div className="flex11a displayFlexColumnVc lrMedMargin">
            {addPresetItemsButtonComponent}
          </div>
          {(c_presetEditorOpenPresetObj.isCstColumnsTF) &&
            <div className="flex00a displayFlexColumnVc" style={{flexBasis:"7em", marginRight:"1em"}}>
              <div className="flex00a textCenter" title="Insert newly added Capture Field columns first or last to the existing list of columns below for easier sorting">
                <font className="fontItalic fontTextLighter">
                  {"Add Columns:"}
                </font>
              </div>
              <div className="flex00a">
                <CEGeneralReact.VerticalSwitch
                  p_valueArray={[1, 2]}
                  p_displayArray={["First", "Last"]}
                  p_selectedValue={s_addNewColumnsFirst1Last2}
                  p_rowHeightEm={1.5}
                  p_sizeMultiplier={0.7}
                  f_onSelect={this.onselect_add_columns_first_last}
                />
              </div>
            </div>
          }
        </div>
      );
    }
    else {
      addPresetItemsTopRowComponent = (
        <div className="medTopMargin textCenter">
          <font className="font12 fontBold fontItalic fontTextLighter">
            {c_presetEditorOpenPresetObj.presetLabel + "s in this Preset"}
          </font>
        </div>
      );
    }

    var fieldItemsListComponent = null;
    if(c_presetEditorOpenPresetObj.numPresetItems > 0) {
      fieldItemsListComponent = (
        c_presetEditorOpenPresetObj.expandedPresetItemsArrayOfObjs.map((m_expandedPresetItemObj, m_index) =>
          <PresetEditorOpenCFSPresetFieldItem
            key={m_expandedPresetItemObj.id}
            p_presetObj={c_presetEditorOpenPresetObj}
            p_expandedPresetItemObj={m_expandedPresetItemObj}
            p_isOnlyItemTF={(c_presetEditorOpenPresetObj.numPresetItems === 1)}
            p_isLastItemTF={(m_index === (c_presetEditorOpenPresetObj.numPresetItems - 1))}
          />
        )
      );
    }
    else {
      fieldItemsListComponent = (
        <div>
          <font className="fontItalic fontTextLighter">
            {"No " + c_presetEditorOpenPresetObj.presetLabel + "s have been added to this preset yet"}
          </font>
        </div>
      );
    }

    return(
      <>
        {addPresetItemsTopRowComponent}
        {fieldItemsListComponent}
      </>
    );
  }
}));


const PresetEditorOpenCFSPresetFieldItem = inject("CaptureExecMobx", "CapturesMobx", "DatabaseMobx")(observer(
class PresetEditorOpenCFSPresetFieldItem extends Component { //props: p_presetObj, p_expandedPresetItemObj, p_isOnlyItemTF, p_isLastItemTF
  onswitch_cst_column_cst_sum_row = () => {
    const p_presetObj = this.props.p_presetObj;
    const p_expandedPresetItemObj = this.props.p_expandedPresetItemObj;
    const updatedCstSumRowValue01 = ((p_expandedPresetItemObj.cst_sum_row_01 === 1) ? (0) : (1));
    this.props.CapturesMobx.a_update_cfs_field_item_field(p_presetObj.presetType, p_expandedPresetItemObj.id, "cst_sum_row_01", updatedCstSumRowValue01, "i");
  }

  onchange_filter_operator_or_values = (i_updatedOperatorAndValuesObj) => {
    const p_presetObj = this.props.p_presetObj;
    const p_expandedPresetItemObj = this.props.p_expandedPresetItemObj;

    var fieldNameOrFieldNamesArray = [];
    var valueOrValuesArray = [];
    var valueIdsbOrIdsbArray = [];

    if(i_updatedOperatorAndValuesObj.updatedOperator !== undefined) {
      fieldNameOrFieldNamesArray.push("operator");
      valueOrValuesArray.push(i_updatedOperatorAndValuesObj.updatedOperator);
      valueIdsbOrIdsbArray.push("s");
    }

    if(i_updatedOperatorAndValuesObj.updatedValueOrValuesString !== undefined) {
      fieldNameOrFieldNamesArray.push("value");
      valueOrValuesArray.push(i_updatedOperatorAndValuesObj.updatedValueOrValuesString);
      valueIdsbOrIdsbArray.push("s");
    }

    this.props.CapturesMobx.a_update_cfs_field_item_field(p_presetObj.presetType, p_expandedPresetItemObj.id, fieldNameOrFieldNamesArray, valueOrValuesArray, valueIdsbOrIdsbArray);
  }

  onselect_sort_direction = (i_newValue) => {
    const p_presetObj = this.props.p_presetObj;
    const p_expandedPresetItemObj = this.props.p_expandedPresetItemObj;
    this.props.CapturesMobx.a_update_cfs_field_item_field(p_presetObj.presetType, p_expandedPresetItemObj.id, "is_asc_01", i_newValue, "i");
  }

  onremove_field_item = () => {
    const p_presetObj = this.props.p_presetObj;
    const p_expandedPresetItemObj = this.props.p_expandedPresetItemObj;
    const presetItemsHaveSortTF = (p_presetObj.isCstColumnsTF || p_presetObj.isSortTF);
    this.props.CapturesMobx.a_remove_cfs_field_item_from_preset(p_presetObj.presetType, p_expandedPresetItemObj.id, presetItemsHaveSortTF, p_presetObj.id);
  }

  render() {
    const p_presetObj = this.props.p_presetObj;
    const p_expandedPresetItemObj = this.props.p_expandedPresetItemObj;
    const p_isOnlyItemTF = this.props.p_isOnlyItemTF;
    const p_isLastItemTF = this.props.p_isLastItemTF;

    if(p_presetObj === undefined) {
      return(null);
    }

    const c_isMobileOrTabletTF = this.props.CaptureExecMobx.c_isMobileOrTabletTF;

    const canResortRowsTF = (p_presetObj.isPresetOwnerCanEditTF && (p_presetObj.isCstColumnsTF || p_presetObj.isSortTF));

    var itemContainerHeight = undefined; //fit height of content (used for fitlers)
    var itemNameTextMaxHeight = "2.5em";
    var lastItemExtraDropZoneHeight = undefined; //no drag to resort for filters
    if(p_presetObj.isCstColumnsTF) {
      itemContainerHeight = "2em"; //small for columns because there's usually 30+ and resorting is difficult when scrolling
      itemNameTextMaxHeight = "1.7em";
      lastItemExtraDropZoneHeight = "2em";
    }
    else if(p_presetObj.isSortTF) {
      itemContainerHeight = "2.8em"; //sort needs to fit the Asc/Desc select box
      itemNameTextMaxHeight = "2.5em";
      lastItemExtraDropZoneHeight = "2.8em";
    }

    //filter sum row switch edit/view
    var columnSumRowSwitchComponent = null;
    if(p_presetObj.isCstColumnsTF && p_expandedPresetItemObj.canCalculateCstSumRowTF) {
      columnSumRowSwitchComponent = (
        <div
          className="flex00a displayFlexRow borderL1ddd lrPad"
          style={{flexBasis:"6em"}}
          title="Use this switch to display a calculated sum of this column's data under the column header in the Capture Summary Table">
          <div className="flex00a displayFlexColumnVc">
            <font className="fontItalic fontTextLighter">
              {"sum:"}
            </font>
          </div>
          <div className="flex11a displayFlexColumnVc lrPad">
            <LibraryReact.Switch
              p_isOnTF={(p_expandedPresetItemObj.cst_sum_row_01 === 1)}
              p_sizeEm={2.4}
              p_onColor="090"
              f_onClick={this.onswitch_cst_column_cst_sum_row}
            />
          </div>
        </div>
      );
    }

    //sort direction edit/view
    var sortDirectionComponent = null;
    if(p_presetObj.isSortTF) {
      const sortedAscTF = (p_expandedPresetItemObj.is_asc_01 === 1);

      var sortDirectionContainerWidthEm = 10;
      var selectOrDisplaySortDirectionComponent = null;
      if(p_presetObj.isPresetOwnerCanEditTF) {
        sortDirectionContainerWidthEm = 12.5;

        const valueArray = [1, 0];
        const displayArray = ["\u25bc Asc", "\u25b2 Desc"];
        const swsOptionsObj = undefined;
        const selectWithSearchDataObj = this.props.DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("Asc/Desc", valueArray, false, displayArray, swsOptionsObj);
        const selectAscDescFieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("select", selectWithSearchDataObj);

        selectOrDisplaySortDirectionComponent = (
          <div className="lrPad">
            <CEGeneralReact.GenericInputOrSelectFromInputType
              p_fieldTypeObj={selectAscDescFieldTypeObj}
              p_valueRaw={p_expandedPresetItemObj.is_asc_01}
              p_title="Choose whether this Capture Summary Table column sorts ascending (Asc) or descending (Desc)"
              f_onChangeOrOnSelect={this.onselect_sort_direction}
            />
          </div>
        );
      }
      else {
        selectOrDisplaySortDirectionComponent = (
          <font>
            {((sortedAscTF) ? ("Asc") : ("Desc"))}
          </font>
        );
      }

      sortDirectionComponent = (
        <div className="flex00a displayFlexRowVc borderL1ddd" style={{flexBasis:sortDirectionContainerWidthEm + "em"}}>
          <div className="flex00a lrPad">
            <font className="fontItalic fontTextLighter">
              {"direction:"}
            </font>
          </div>
          {(!p_presetObj.isPresetOwnerCanEditTF) &&
            <div className="flex00a" style={{flexBasis:"1.3em"}}>
              <CEGeneralReact.HeaderSortArrow
                p_isSortedTF={true}
                p_sortedAscTF={sortedAscTF}
              />
            </div>
          }
          <div className="flex11a">
            {selectOrDisplaySortDirectionComponent}
          </div>
        </div>
      );
    }

    return(
      <CEGeneralReact.CEDragToResortItemWithinDbTbl
        p_canResortTF={canResortRowsTF}
        p_uniqueString="presetItem"
        p_itemID={p_expandedPresetItemObj.id}
        p_itemSort={((p_presetObj.isCstColumnsTF || p_presetObj.isSortTF) ? (p_expandedPresetItemObj.sort) : (undefined))} //filters do not have a sort field, set it to undefined so that the sort is not drawn
        p_itemSortColumnWidth={undefined}
        p_itemSortNumberFontClass={undefined}
        p_isOnlyItemTF={p_isOnlyItemTF}
        p_isLastItemTF={p_isLastItemTF}
        p_outerPadClass="lrPad microTopPad microBottomPad"
        p_itemClass="border bevelBorderColors borderRadius10 bgAlmostWhite hoverLighterBlueGradient"
        p_itemStyleObj={{height:itemContainerHeight}}
        p_lastItemExtraDropZoneHeight={lastItemExtraDropZoneHeight}
        p_dragEntireItemTrueOnlySortNumberFalse={true}
        p_tblName={p_presetObj.presetItemsTblName}
        p_tblSortFieldDbName="sort"
        p_filterFieldNamesArray={[p_presetObj.itemsPresetIDColumnName]}
        p_filterValuesArray={[p_presetObj.id]}>
        <div className="flex11a displayFlexRowVc lrMedPad">
          <LibraryReact.MaxHeightWrap p_maxHeight={itemNameTextMaxHeight} p_fontClass="fontBold fontItalic fontTextLight">
            {p_expandedPresetItemObj.fieldDisplayName}
          </LibraryReact.MaxHeightWrap>
        </div>
        {columnSumRowSwitchComponent}
        {(p_presetObj.isFilterTF) &&
          <div className="flex00a borderL1ddd lrPad" style={{flexBasis:((c_isMobileOrTabletTF) ? ("17em") : ("27em"))}}>
            <SingleCaptureFieldOperatorValuesSelector
              p_fieldTypeObj={p_expandedPresetItemObj.fieldTypeObj}
              p_selectedOperator={p_expandedPresetItemObj.operator}
              p_selectedValueOrValuesString={p_expandedPresetItemObj.value}
              p_canEditTF={p_presetObj.isPresetOwnerCanEditTF}
              f_onChangeOperatorOrValues={this.onchange_filter_operator_or_values}
            />
          </div>
        }
        {sortDirectionComponent}
        {(p_presetObj.isPresetOwnerCanEditTF) &&
          <div className="flex00a borderL1ddd displayFlexColumnHcVc" style={{flexBasis:"2.4em"}}>
            <CEGeneralReact.RemoveItemXWithRedHover
              p_title={"Remove item '" + p_expandedPresetItemObj.fieldDisplayName + "' from this " + p_presetObj.presetLabel + " Preset"}
              f_onClick={this.onremove_field_item}
            />
          </div>
        }
      </CEGeneralReact.CEDragToResortItemWithinDbTbl>
    );
  }
}));


const SingleCaptureFieldOperatorValuesSelector = inject("CapturesMobx", "DatabaseMobx")(observer(
class SingleCaptureFieldOperatorValuesSelector extends Component { //props: p_fieldTypeObj, p_selectedOperator, p_selectedValueOrValuesString, p_canEditTF, f_onChangeOperatorOrValues(i_updatedOperatorAndValuesObj)
  onselect_filter_operator = (i_newValue) => { //when changing the operator, the value(s) are reset to blank so that you can't switch an "equals" with 3 ORs to "greater than", which shouldn't allow more than 1 item (but it does allow switching between all of the lt/gt without reset)
    const p_selectedOperator = this.props.p_selectedOperator;
    const p_selectedValueOrValuesString = this.props.p_selectedValueOrValuesString;
    const f_onChangeOperatorOrValues = this.props.f_onChangeOperatorOrValues;

    if(JSFUNC.is_function(f_onChangeOperatorOrValues)) {
      const gtltOperatorsArray = ["gt","gte","lt","lte"];
      const oldOperatorIsComparisonTF = JSFUNC.in_array(p_selectedOperator, gtltOperatorsArray);
      const newOperatorIsComparisonTF = JSFUNC.in_array(i_newValue, gtltOperatorsArray);
      const updatedValueOrValuesString = ((oldOperatorIsComparisonTF && newOperatorIsComparisonTF) ? (p_selectedValueOrValuesString) : ("")); //keep the original selected value if switching between lt/gt operators, otherwise reset the value when switching operator
      f_onChangeOperatorOrValues({updatedOperator:i_newValue, updatedValueOrValuesString:updatedValueOrValuesString});
    }
  }

  onadd_filter_item_single_value = (i_newValuesComma) => {
    const p_selectedOperator = this.props.p_selectedOperator;
    const p_selectedValueOrValuesString = this.props.p_selectedValueOrValuesString;
    const f_onChangeOperatorOrValues = this.props.f_onChangeOperatorOrValues;

    if(JSFUNC.is_function(f_onChangeOperatorOrValues)) {
      const combinedValuesComma = JSFUNC.add_value_to_comma_list(i_newValuesComma, p_selectedValueOrValuesString);
      f_onChangeOperatorOrValues({updatedOperator:p_selectedOperator, updatedValueOrValuesString:combinedValuesComma});
    }
  }

  onremove_filter_item_single_value = (i_valueRawToRemove) => {
    const p_selectedOperator = this.props.p_selectedOperator;
    const p_selectedValueOrValuesString = this.props.p_selectedValueOrValuesString;
    const f_onChangeOperatorOrValues = this.props.f_onChangeOperatorOrValues;

    if(JSFUNC.is_function(f_onChangeOperatorOrValues)) {
      const valueStringToRemove = JSFUNC.num2str(i_valueRawToRemove);
      const allValuesWithSingleValueRemovedComma = JSFUNC.remove_all_values_from_comma_list(valueStringToRemove, p_selectedValueOrValuesString);
      f_onChangeOperatorOrValues({updatedOperator:p_selectedOperator, updatedValueOrValuesString:allValuesWithSingleValueRemovedComma});
    }
  }

  render() {
    const p_fieldTypeObj = this.props.p_fieldTypeObj;
    const p_selectedOperator = this.props.p_selectedOperator;
    const p_selectedValueOrValuesString = this.props.p_selectedValueOrValuesString;
    const p_canEditTF = this.props.p_canEditTF;
    const f_onChangeOperatorOrValues = this.props.f_onChangeOperatorOrValues;

    const c_selectOperatorFieldTypeObj = this.props.DatabaseMobx.c_selectOperatorFieldTypeObj; //select from ["e", "ne", "gt", "gte", "lt", "lte", "c", "dnc", "is", "ins"] values

    const canEditTF = (p_canEditTF && (p_fieldTypeObj !== undefined));

    const selectedOperatorIsFilledOutTF = this.props.DatabaseMobx.value_is_filled_out_tf_from_value_raw_and_field_type_obj(p_selectedOperator, c_selectOperatorFieldTypeObj);

    //if the field type is a textarea, force it to change to a text so that the edit is not a floating box, if the operator is contains "c" or does not contain "dnc", also force the edit to a text input
    var filterEditingValuesFieldTypeObj = undefined;
    if(JSFUNC.in_array(p_selectedOperator, ["c", "dnc"])) { //contains/does not contain - use "text" input type to compare to field raw value(s)
      filterEditingValuesFieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("text");
    }
    else if((p_fieldTypeObj !== undefined) && (p_fieldTypeObj.selectTF || p_fieldTypeObj.sharedPercentTF) && !p_fieldTypeObj.isMultiSelectTF) { //if field is a single select type field (not multiselect), force the select to be a multiselect when adding values (since you can add multiple values ORed together anyway, checking multiple options at once is faster for the user)
      const forcedSelectMultiOptionsSwsOptionsObj = {isMultiSelectTF:true, hasSearchTF:true, hasClearSelectionTF:true};
      filterEditingValuesFieldTypeObj = this.props.DatabaseMobx.create_new_copy_field_type_obj_from_old_field_type_obj_and_field_input_type_and_sws_options_obj(p_fieldTypeObj, "select", forcedSelectMultiOptionsSwsOptionsObj);
    }
    else { //all other operators - use the original Capture Field fieldTypeObj
      filterEditingValuesFieldTypeObj = p_fieldTypeObj;
    }

    //filter item value is a comma list of either int or string values, convert that to an array and mask each raw value
    var rawValuesAreIntsTF = false;
    if(filterEditingValuesFieldTypeObj !== undefined) {
      if((filterEditingValuesFieldTypeObj.valueRawIsNumericTF || filterEditingValuesFieldTypeObj.selectTF)) {
        rawValuesAreIntsTF = true;
      }
    }
    const valuesArray = ((rawValuesAreIntsTF) ? (JSFUNC.convert_comma_list_to_int_array(p_selectedValueOrValuesString)) : (JSFUNC.convert_comma_list_to_array(p_selectedValueOrValuesString)));
    const numValues = valuesArray.length;

    //can add more values if editable (unless is/is not set operator, which have 0 values always), some operators only allow 1 value max
    var canAddMoreValuesTF = false;
    if(canEditTF) { //can't add values if this cannot be edited
      if(JSFUNC.in_array(p_selectedOperator, ["is", "ins"])) { //can't add values to Is Set or Is Not Set
        canAddMoreValuesTF = false;
      }
      else if(JSFUNC.in_array(p_selectedOperator, ["e", "ne", "c", "dnc"])) {
        canAddMoreValuesTF = true; //can always add more values to equals, not equals, and contains that are ORed together
      }
      else if(JSFUNC.in_array(p_selectedOperator, ["gt", "gte", "lt", "lte"])) { //for gt, gte, lt, lte, only 1 value max can be added, so can only add a value if there are currently 0
        canAddMoreValuesTF = (numValues === 0);
      }
    }

    //operator select (or selected operator display text if not editable)
    var operatorSelectComponent = null;
    if(canEditTF) {
      //determine which operators are available to choose based on the selected field type
      const filterPresetFieldOperatorSelectChoicesObj = this.props.CapturesMobx.filter_preset_field_operator_select_choices_obj_from_field_type_obj(p_fieldTypeObj);

      operatorSelectComponent = (
        <div className="smallFullMargin">
          <CEGeneralReact.GenericInputOrSelectFromInputType
            p_fieldTypeObj={c_selectOperatorFieldTypeObj}
            p_valueRaw={p_selectedOperator}
            p_valuesToNotIncludeArray={filterPresetFieldOperatorSelectChoicesObj.operatorValuesToNotIncludeArray}
            p_title="Choose an operator for how this capture field is related to its value(s)"
            f_onChangeOrOnSelect={this.onselect_filter_operator}
          />
        </div>
      );
    }
    else {
      operatorSelectComponent = (
        <LibraryReact.DivFont p_class="microBottomMargin textCenter" p_fontClass="font11 fontBold fontItalic">
          {this.props.DatabaseMobx.value_mask_from_value_raw_and_field_type_obj(p_selectedOperator, c_selectOperatorFieldTypeObj)}
        </LibraryReact.DivFont>
       );
    }

    //added values list (or message if no values added yet)
    var addedValuesListComponent = null;
    if(!selectedOperatorIsFilledOutTF) {
      addedValuesListComponent = (
        <LibraryReact.DivFont p_class="textCenter" p_fontClass="fontItalic fontTextLighter">
          {"Select an operator before adding value(s) to this filter"}
        </LibraryReact.DivFont>
      );
    }
    else if(numValues === 0) {
      var zeroValuesMessage = "--No values have been added to this filter yet--";
      if(p_selectedOperator === "is") {
        zeroValuesMessage = "This filter will find all captures where this field is set";
      }
      else if(p_selectedOperator === "ins") {
        zeroValuesMessage = "This filter will find all captures where this field is not set or has a selected value that does not exist";
      }

      addedValuesListComponent = (
        <LibraryReact.DivFont p_class="textCenter" p_fontClass="fontItalic fontTextLighter">
          {zeroValuesMessage}
        </LibraryReact.DivFont>
      );
    }
    else {
      addedValuesListComponent = (
        valuesArray.map((m_valueRaw, m_index) =>
          <FilterPresetFieldItemSingleValue
            p_canEditTF={canEditTF}
            p_valueRaw={m_valueRaw}
            p_filterEditingValuesFieldTypeObj={filterEditingValuesFieldTypeObj}
            p_isLastValueTF={(m_index === (numValues - 1))}
            f_onClickRemove={this.onremove_filter_item_single_value}
          />
        )
      );
    }

    //add more values button (force save call even if value is unchanged as the Integer type field initializes with a 0, and it becomes impossible to save it as 0 without forcing an unchanged value save call)
    var addFilterValuesButtonComponent = null;
    if(canAddMoreValuesTF) {
      addFilterValuesButtonComponent = (
        <div className="tbMargin">
          <CEGeneralReact.CaptureExecFieldAddNewItemsButton
            p_buttonType="add"
            p_buttonText="Add Filter Value(s)"
            p_addInstructions="Add value(s) to this filter field"
            p_fieldTypeObj={filterEditingValuesFieldTypeObj}
            p_valuesToNotIncludeArray={valuesArray}
            p_forceSaveCallEvenIfValueNotChangedTF={true}
            f_onAddSelectedItems={this.onadd_filter_item_single_value}
          />
        </div>
      );
    }

    return(
      <>
        {operatorSelectComponent}
        {addedValuesListComponent}
        {addFilterValuesButtonComponent}
      </>
    );
  }
}));


const FilterPresetFieldItemSingleValue = inject("DatabaseMobx")(observer(
class FilterPresetFieldItemSingleValue extends Component { //props: p_canEditTF, p_valueRaw, p_isLastValueTF, f_onClickRemove(i_valueRaw)
  onremove_filter_single_value = () => {
    const p_valueRaw = this.props.p_valueRaw;
    const f_onClickRemove = this.props.f_onClickRemove;
    if(JSFUNC.is_function(f_onClickRemove)) {
      f_onClickRemove(p_valueRaw);
    }
  }

  render() {
    const p_canEditTF = JSFUNC.prop_value(this.props.p_canEditTF, false);
    const p_valueRaw = this.props.p_valueRaw;
    const p_filterEditingValuesFieldTypeObj = this.props.p_filterEditingValuesFieldTypeObj;
    const p_isLastValueTF = JSFUNC.prop_value(this.props.p_isLastValueTF, false);
    const f_onClickRemove = this.props.f_onClickRemove;
    
    const valueMaskSortIfoObj = this.props.DatabaseMobx.value_mask_sort_ifo_obj_from_value_raw_and_field_type_obj(p_valueRaw, p_filterEditingValuesFieldTypeObj);

    return(
      <div className="displayFlexRowVc microTopMargin microBottomMargin">
        {(p_canEditTF) &&
          <div className="flex00a displayFlexRowVc" style={{flexBasis:"2em"}}>
            <CEGeneralReact.RemoveItemXWithRedHover
              p_title={"Remove value '" + valueMaskSortIfoObj.valueMaskPlainText + "' from this filter"}
              p_heightEm={0.5}
              p_fontClass="font09"
              f_onClick={this.onremove_filter_single_value}
            />
          </div>
        }
        <div className="flex11a">
          {valueMaskSortIfoObj.valueMask}
        </div>
        {(!p_isLastValueTF) &&
          <LibraryReact.DivFont p_class="flex00a lrMargin" p_fontClass="fontItalic fontTextLighter">
            {"or"}
          </LibraryReact.DivFont>
        }
      </div>
    );
  }
}));



const PresetEditorOpenFilterPresetMatchingCapturesList = inject("CapturesMobx")(observer(
class PresetEditorOpenFilterPresetMatchingCapturesList extends Component { //props:
  onclick_show_all_captures = () => {
    this.props.CapturesMobx.a_set_preset_editor_open_filter_preset_matching_captures_list_max_num_captures_drawn_or_m1(-1);
  }
  
  render() {
    const o_presetEditorOpenFilterPresetMatchingCapturesListMaxNumCapturesDrawnOrM1 = this.props.CapturesMobx.o_presetEditorOpenFilterPresetMatchingCapturesListMaxNumCapturesDrawnOrM1;
    const c_presetEditorOpenPresetObj = this.props.CapturesMobx.c_presetEditorOpenPresetObj;
    const c_presetEditorOpenFilterPresetMatchingCapturesDisplayColumnsArrayOfObjs = this.props.CapturesMobx.c_presetEditorOpenFilterPresetMatchingCapturesDisplayColumnsArrayOfObjs;
    const c_presetEditorOpenFilterPresetMatchingCapturesTableTotalWidthEm = this.props.CapturesMobx.c_presetEditorOpenFilterPresetMatchingCapturesTableTotalWidthEm;
    const c_presetEditorOpenFilterPresetCstFilteredMaskedCaptureValuesArrayOfObjs = this.props.CapturesMobx.c_presetEditorOpenFilterPresetCstFilteredMaskedCaptureValuesArrayOfObjs;

    const numCapturesMatchingFilter = c_presetEditorOpenFilterPresetCstFilteredMaskedCaptureValuesArrayOfObjs.length;
    const showAllCapturesTF = (!JSFUNC.is_number_not_nan_gt_0(o_presetEditorOpenFilterPresetMatchingCapturesListMaxNumCapturesDrawnOrM1));

    return(
      <>
        <div className="flex00a displayFlexColumnVc borderT1bbb lrMedPad textRight" style={{height:"1.8em"}}>
          <font className="font11">
            {numCapturesMatchingFilter + " " + JSFUNC.plural(numCapturesMatchingFilter, "Capture matches", "Captures matching") + " filter '" + c_presetEditorOpenPresetObj.name + "'"}
          </font>
        </div>
        <div className="flex11a displayFlexColumn xyScrollAlways overflowHidden" style={{flexBasis:"100em"}}>
          <div className="flex00a displayFlexRow bgLightGrayGradient" style={{width:c_presetEditorOpenFilterPresetMatchingCapturesTableTotalWidthEm + "em", height:"1.4em"}}>
            {c_presetEditorOpenFilterPresetMatchingCapturesDisplayColumnsArrayOfObjs.map((m_displayColumnObj) =>
              <div
                className="flex00a displayFlexColumnHcVc lrPad textCenter"
                style={{flexBasis:m_displayColumnObj.widthEm + "em"}}
                title={m_displayColumnObj.displayName}>
                <LibraryReact.NowrapEllipsis p_fontClass="fontBold fontTextLight">
                  {m_displayColumnObj.displayName}
                </LibraryReact.NowrapEllipsis>
              </div>
            )}
          </div>
          {c_presetEditorOpenFilterPresetCstFilteredMaskedCaptureValuesArrayOfObjs.map((m_cstMaskedCaptureValueObj, m_index) =>
            (showAllCapturesTF || (m_index <= o_presetEditorOpenFilterPresetMatchingCapturesListMaxNumCapturesDrawnOrM1)) &&
            <div className="flex00a displayFlexRow hoverLighterBlueGradient" style={{height:"1.2em"}}>
              {c_presetEditorOpenFilterPresetMatchingCapturesDisplayColumnsArrayOfObjs.map((m_displayColumnObj) =>
                <div
                  className={"flex00a displayFlexRowVc lrPad " + m_displayColumnObj.cstCellAlignClass}
                  style={{flexBasis:m_displayColumnObj.widthEm + "em"}}
                  title={m_cstMaskedCaptureValueObj[m_displayColumnObj.fieldID + "MASKPT"]}>
                  <LibraryReact.NowrapEllipsis p_fontClass="fontTextLight">
                    {m_cstMaskedCaptureValueObj[m_displayColumnObj.fieldID + "MASKNCL"]}
                  </LibraryReact.NowrapEllipsis>
                </div>
              )}
            </div>
          )}
          {(!showAllCapturesTF && (numCapturesMatchingFilter > o_presetEditorOpenFilterPresetMatchingCapturesListMaxNumCapturesDrawnOrM1)) &&
            <div className="flex00a tbPad lrMedPad">
              <CEGeneralReact.CEButton
                p_type="blue"
                p_text={"Show All " + numCapturesMatchingFilter + " Captures"}
                f_onClick={this.onclick_show_all_captures}
              />
            </div>
          }
          <div className="medBottomPad" />
        </div>
      </>
    );
  }
}));










//-------------------------------------------------------------------------------------------------------------------------------------
//Gantt Preset Editor
//-------------------------------------------------------------------------------------------------------------------------------------
const GanttPresetEditorLeftPresetsList = inject("CapturesMobx", "DatabaseMobx")(observer(
class GanttPresetEditorLeftPresetsList extends Component {
  oncreate_new_gantt_preset_with_name = (i_newGanttPresetName) => {
    this.props.CapturesMobx.a_create_new_gantt_preset(i_newGanttPresetName);
  }

  render() {
    const myPresetsArrayOfObjs = this.props.CapturesMobx.c_ganttDatesPresetMyPresetsArrayOfObjs;
    const publicPresetsArrayOfObjs = this.props.CapturesMobx.c_ganttDatesPresetPublicPresetsArrayOfObjs;

    const presetItemsIndent = "0.4em";
    return(
      <div className="flex11a yScroll yScrollBottomPad lrPad" style={{backgroundColor:"#f8f8f8"}}>
        <div className="medTopMargin medBottomMargin">
          <CEGeneralReact.CaptureExecFieldAddNewItemsButton
            p_buttonType="blue"
            p_buttonText="Create New Gantt Preset"
            p_addInstructions="Enter a name for the new preset"
            p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
            f_onAddSelectedItems={this.oncreate_new_gantt_preset_with_name}
          />
        </div>
        <div className="">
          <font className="font12 fontBold fontTextLighter">
            {"Gantt Date Presets"}
          </font>
        </div>
        <div className="smallTopMargin" style={{marginLeft:presetItemsIndent}}>
          <PresetEditorPresetTypeSubHeading p_label={"My Presets (" + myPresetsArrayOfObjs.length + ")"} />
          {myPresetsArrayOfObjs.map((m_ganttPresetObj) =>
            <GanttPresetItem
              key={m_ganttPresetObj.id}
              p_ganttPresetObj={m_ganttPresetObj}
            />
          )}
          <div className="hugeTopMargin" />
          <PresetEditorPresetTypeSubHeading p_label={"Public Presets (" + publicPresetsArrayOfObjs.length + ")"} />
          {publicPresetsArrayOfObjs.map((m_ganttPresetObj) =>
            <GanttPresetItem
              key={m_ganttPresetObj.id}
              p_ganttPresetObj={m_ganttPresetObj}
            />
          )}
        </div>
      </div>
    );
  }
}));

const GanttPresetItem = inject("CapturesMobx")(observer(
class GanttPresetItem extends Component { //props: p_ganttPresetObj
  onclick_open_gantt_preset_in_editor = () => {
    const p_ganttPresetObj = this.props.p_ganttPresetObj;
    this.props.CapturesMobx.a_set_gantt_dates_preset_editor_open_preset_id(p_ganttPresetObj.id);
    this.props.CapturesMobx.a_select_gantt_dates_preset(p_ganttPresetObj.id);
  }

  ondelete_gantt_preset = () => {
    const p_ganttPresetObj = this.props.p_ganttPresetObj;
    this.props.CapturesMobx.a_delete_gantt_preset(p_ganttPresetObj.id);
  }

  render() {
    const p_ganttPresetObj = this.props.p_ganttPresetObj;
    const o_ganttDatesOpenPresetID = this.props.CapturesMobx.o_ganttDatesOpenPresetID;

    var rowBgClass = "bgAlmostWhite";
    if(p_ganttPresetObj.id === o_ganttDatesOpenPresetID) {
      rowBgClass = "bgCaptureItemEditing";
    }

    return(
      <div
        className={"displayFlexRowVc microTopMargin border bevelBorderColors hoverLighterBlueGradient cursorPointer " + rowBgClass}
        style={{height:"3em"}}
        onClick={this.onclick_open_gantt_preset_in_editor}>
        <div className="flex11a lrMargin">
          <LibraryReact.MaxHeightWrap p_maxHeight="2.5em" p_fontClass="font12 fontTextLight">
            {p_ganttPresetObj.name}
          </LibraryReact.MaxHeightWrap>
        </div>
        {(p_ganttPresetObj.isPresetOwnerCanEditTF) &&
          <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"3em"}}>
            <CEGeneralReact.DeleteMenu
              p_menuItemText="Delete"
              p_message={"Are you sure you want to delete Gantt date preset '" + p_ganttPresetObj.name + "'"}
              f_onDelete={this.ondelete_gantt_preset}
            />
          </div>
        }
      </div>
    );
  }
}));

const GanttPresetEditorRightOpenPreset = inject("CapturesMobx", "DatabaseMobx", "UserMobx")(observer(
class GanttPresetEditorRightOpenPreset extends Component {
  onclick_confirm_create_copied_gantt_dates_preset = (i_newPresetName) => {
    this.props.CapturesMobx.a_copy_gantt_dates_preset_with_new_name(this.props.CapturesMobx.c_ganttPresetEditorOpenPresetObj, i_newPresetName);
  }

  onclick_close_open_gantt_preset = () => {
    this.props.CapturesMobx.a_set_gantt_dates_preset_editor_open_preset_id(undefined);
  }

  onsave_new_preset_name = (i_newPresetName) => {
    const c_ganttPresetEditorOpenPresetObj = this.props.CapturesMobx.c_ganttPresetEditorOpenPresetObj;
    this.props.CapturesMobx.a_update_gantt_preset_field(c_ganttPresetEditorOpenPresetObj.id, "name", i_newPresetName, "s");
  }

  onclick_gantt_preset_public_switch = () => {
    const c_ganttPresetEditorOpenPresetObj = this.props.CapturesMobx.c_ganttPresetEditorOpenPresetObj;
    const newPublic01Value = ((c_ganttPresetEditorOpenPresetObj.public_01 === 1) ? (0) : (1));
    this.props.CapturesMobx.a_update_gantt_preset_field(c_ganttPresetEditorOpenPresetObj.id, "public_01", newPublic01Value, "i");
  }

  onadd_selected_new_date_fields = (i_newDateFieldIDsComma) => {
    const c_ganttPresetEditorOpenPresetObj = this.props.CapturesMobx.c_ganttPresetEditorOpenPresetObj;
    this.props.CapturesMobx.a_add_dates_to_gantt_preset(c_ganttPresetEditorOpenPresetObj.id, i_newDateFieldIDsComma);
  }

  render() {
    const o_ganttDatesOpenPresetID = this.props.CapturesMobx.o_ganttDatesOpenPresetID;
    const c_ganttPresetEditorOpenPresetObj = this.props.CapturesMobx.c_ganttPresetEditorOpenPresetObj;
    const c_ganttPresetEditorSelectMultiCaptureDateFieldsFieldTypeObj = this.props.DatabaseMobx.c_ganttPresetEditorSelectMultiCaptureDateFieldsFieldTypeObj;
    const c_userCanCreatePublicItemsTF = this.props.UserMobx.c_userCanCreatePublicItemsTF;

    if(o_ganttDatesOpenPresetID === undefined) {
      return(
        <CEGeneralReact.EmptyScreenGray>
          {"Select a Gantt Preset to view/edit its components"}
        </CEGeneralReact.EmptyScreenGray>
      );
    }

    if(c_ganttPresetEditorOpenPresetObj === undefined) {
      return(
        <CEGeneralReact.EmptyScreenGray>
          {"--Gantt Preset Does Not Exist (ID: " + o_ganttDatesOpenPresetID + ")--"}
        </CEGeneralReact.EmptyScreenGray>
      );
    }

    const ganttDatesPresetMenuItemsArrayOfObjs = [
      {
        displayName: "Copy this as a new Gantt Dates Preset",
        confirmType: "inputText",
        confirmTitle: "Copy Gantt Dates Preset '" + c_ganttPresetEditorOpenPresetObj.name + "'",
        confirmTextInitialValue: "Copy of " + c_ganttPresetEditorOpenPresetObj.name,
        confirmButton1Name: "Create Copy",
        confirmTextMustBeChangedForSaveTFU: false,
        confirmMessage: "Enter a new name for this copied Gantt Dates Preset",
        functionOnClickConfirmButton: this.onclick_confirm_create_copied_gantt_dates_preset
      }
    ];

    const containerClass = "medTopMargin lrMargin";
    const fieldClass = "fontBlue";
    const fieldWidth = "7em";

    const editSaveCancelOwnerComponent = (
      <CEGeneralReact.CaptureExecFieldEditSaveCancel
        p_ceEditItemString={"ganttPresetID" + c_ganttPresetEditorOpenPresetObj.id + "owner"}
        p_fieldDisplayName="Owner"
        p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
        p_valueRaw={c_ganttPresetEditorOpenPresetObj.user_id}
        p_valueMask={this.props.DatabaseMobx.user_name_mask_from_user_id(c_ganttPresetEditorOpenPresetObj.user_id)}
        p_valueIsEditableTFU={false}
        p_containerClass={containerClass}
        p_fieldClass={fieldClass}
        p_fieldWidth={fieldWidth}
        p_fieldValueVerticallyAlignedTF={true}
        f_onSaveChanged={undefined}
      />
    );

    const editSaveCancelPresetNameComponent = (
      <CEGeneralReact.CaptureExecFieldEditSaveCancel
        p_ceEditItemString={"ganttPresetID" + c_ganttPresetEditorOpenPresetObj.id + "name"}
        p_fieldDisplayName="Preset Name"
        p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
        p_valueRaw={c_ganttPresetEditorOpenPresetObj.name}
        p_valueIsEditableTFU={c_ganttPresetEditorOpenPresetObj.isPresetOwnerCanEditTF}
        p_containerClass={containerClass}
        p_fieldClass={fieldClass}
        p_fieldWidth={fieldWidth}
        p_fieldValueVerticallyAlignedTF={true}
        f_onSaveChanged={this.onsave_new_preset_name}
      />
    );

    return(
      <div className="flex11a displayFlexColumn" style={{backgroundColor:"#f3f6fc"}}>
        <div className="flex00a displayFlexRowVc borderB1bbb">
          <div className="flex11a lrMargin">
            <LibraryReact.NowrapEllipsis p_fontClass="font13 fontBold fontTextLighter">
              {"Preset '" + c_ganttPresetEditorOpenPresetObj.name + "'"}
            </LibraryReact.NowrapEllipsis>
          </div>
          <div className="flex00a displayFlexColumnHcVc borderR1bbb" style={{flexBasis:"2em"}}>
            <CEGeneralReact.VerticalDotsMenu
              p_menuItemsArrayOfObjs={ganttDatesPresetMenuItemsArrayOfObjs}
            />
          </div>
          <div className="flex00a tbPad lrMedPad">
            <CEGeneralReact.CEButton
              p_type="gray"
              p_text="Close"
              f_onClick={this.onclick_close_open_gantt_preset}
            />
          </div>
        </div>
        <div className="flex11a yScroll yScrollBottomPad lrPad">
          {editSaveCancelOwnerComponent}
          {editSaveCancelPresetNameComponent}
          {(c_ganttPresetEditorOpenPresetObj.isPresetOwnerCanEditTF && c_userCanCreatePublicItemsTF) &&
            <div className="displayFlexRowVc medTopMargin medBottomMargin lrMargin">
              <div className="flex00a" style={{flexBasis:fieldWidth}}>
                <font className={fieldClass}>
                  {"Is Public?"}
                </font>
              </div>
              <div className="flex11a">
                <CEGeneralReact.SwitchWithTextAndConfirmBox
                  p_isOnTF={(c_ganttPresetEditorOpenPresetObj.public_01 === 1)}
                  p_sizeEm={3}
                  p_onText="Public to everyone"
                  p_offText="Private to me"
                  p_title="Turn on to make your created Gantt preset public to all users in your company"
                  f_onSwitch={this.onclick_gantt_preset_public_switch}
                />
              </div>
            </div>
          }
          {(c_ganttPresetEditorOpenPresetObj.isPresetOwnerCanEditTF) ? (
            <div className="medFullMargin">
              <CEGeneralReact.CaptureExecFieldAddNewItemsButton
                p_buttonType="blue"
                p_buttonText="Add Date(s)"
                p_addInstructions="Select capture date fields to add to this Gantt Dates Preset"
                p_fieldTypeObj={c_ganttPresetEditorSelectMultiCaptureDateFieldsFieldTypeObj}
                p_valuesToNotIncludeArray={c_ganttPresetEditorOpenPresetObj.addedDateFieldIDsArray}
                f_onAddSelectedItems={this.onadd_selected_new_date_fields}
              />
            </div>
          ) : (
            <LibraryReact.DivFont p_class="medTopMargin medBottomMargin textCenter" p_fontClass="font12 fontBold fontItalic fontTextLighter">
              {"Dates in this Preset"}
            </LibraryReact.DivFont>
          )}
          {(c_ganttPresetEditorOpenPresetObj.numAddedDates === 0) ? (
            <LibraryReact.DivFont p_fontClass="fontItalic fontTextLighter">
              {"No dates have been added to this preset yet"}
            </LibraryReact.DivFont>
          ) : (
            c_ganttPresetEditorOpenPresetObj.ganttDatesArrayOfObjs.map((m_ganttDateObj) =>
              <GanttPresetEditorDateItem
                key={m_ganttDateObj.id}
                p_ganttDateObj={m_ganttDateObj}
                p_isPresetOwnerCanEditTF={c_ganttPresetEditorOpenPresetObj.isPresetOwnerCanEditTF}
                p_isOnlyItemTF={(c_ganttPresetEditorOpenPresetObj.numAddedDates === 1)}
                p_isLastItemTF={(c_ganttPresetEditorOpenPresetObj.numAddedDates === c_ganttPresetEditorOpenPresetObj.ganttDatesArrayOfObjs.length)}
              />
            )
          )}
        </div>
      </div>
    );
  }
}));

const GanttPresetEditorDateItem = inject("CapturesMobx")(observer(
class GanttPresetEditorDateItem extends Component { //props: p_ganttDateObj, p_isPresetOwnerCanEditTF, p_isOnlyItemTF, p_isLastItemTF
  onremove_date_item = () => {
    this.props.CapturesMobx.a_delete_gantt_date_from_preset(this.props.p_ganttDateObj.id);
  }

  onchange_color = (i_newColor) => {
    this.props.CapturesMobx.a_update_gantt_date_color(this.props.p_ganttDateObj.id, i_newColor);
  }

  render() {
    const p_ganttDateObj = this.props.p_ganttDateObj;
    const p_isPresetOwnerCanEditTF = JSFUNC.prop_value(this.props.p_isPresetOwnerCanEditTF, false);
    const p_isOnlyItemTF = JSFUNC.prop_value(this.props.p_isOnlyItemTF, false);
    const p_isLastItemTF = JSFUNC.prop_value(this.props.p_isLastItemTF, false);

    const ganttDateHoverText = "Capture Date Field '" + p_ganttDateObj.fieldDisplayName + "'\nColor: #" + p_ganttDateObj.color;

    return(
      <CEGeneralReact.CEDragToResortItemWithinDbTbl
        p_canResortTF={p_isPresetOwnerCanEditTF}
        p_uniqueString="ganttPresetSingleDate"
        p_itemID={p_ganttDateObj.id}
        p_itemSort={p_ganttDateObj.sort}
        p_itemSortColumnWidth={undefined}
        p_itemSortNumberContainerClass={undefined}
        p_itemSortNumberFontClass={undefined}
        p_isOnlyItemTF={p_isOnlyItemTF}
        p_isLastItemTF={p_isLastItemTF}
        p_outerPadClass="lrPad tbMicroPad"
        p_itemClass="border bevelBorderColors borderRadius10 bgWhite hoverLighterBlueGradient"
        p_itemStyleObj={{height:"3em"}}
        p_lastItemExtraDropZoneHeight={undefined}
        p_dragEntireItemTrueOnlySortNumberFalse={true}
        p_tblName="tbl_f_gantt_dates"
        p_tblSortFieldDbName="sort"
        p_filterFieldNamesArray={["gantt_date_preset_id"]}
        p_filterValuesArray={[p_ganttDateObj.gantt_date_preset_id]}
        f_onDropForeignItem={undefined}>
        <div className="flex11a displayFlexRowVc lrMedMargin" title={ganttDateHoverText}>
          <LibraryReact.MaxHeightWrap p_maxHeight="2.5em" p_fontClass="fontBold fontItalic fontTextLight">
            {p_ganttDateObj.fieldDisplayName}
          </LibraryReact.MaxHeightWrap>
        </div>
        {(p_isPresetOwnerCanEditTF) ? (
          <>
            <div className="flex00a displayFlexRowVc">
              <LibraryReact.Color
                p_value={p_ganttDateObj.color}
                p_styleObj={{width:"7em", height:"2.2em"}}
                p_title={"Click to change the color for Capture Date Field '" + p_ganttDateObj.fieldDisplayName + "'"}
                f_onChange={this.onchange_color}
              />
            </div>
            <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"3em"}}>
              <CEGeneralReact.RemoveItemXWithRedHover
                p_title={"Remove date '" + p_ganttDateObj.fieldDisplayName + "' from this Gantt preset"}
                f_onClick={this.onremove_date_item}
              />
            </div>
          </>
        ) : (
          <div className="flex00a displayFlexRowVc">
            <div className="flex00a border bevelBorderColors" style={{marginRight:"2em", width:"5em", height:"1.5em", backgroundColor:"#" + p_ganttDateObj.color}} />
          </div>
        )}
      </CEGeneralReact.CEDragToResortItemWithinDbTbl>
    );
  }
}));


function PresetEditorPresetTypeSubHeading(props) { //props: p_label
  return(
    <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="fontItalic fontTextLight">
      {props.p_label}
    </LibraryReact.DivFont>
  );
}








//======================================================================================================================================
//======================================================================================================================================
//Create New Capture
//======================================================================================================================================
//======================================================================================================================================

const CreateNewCaptureFloatingBox = inject("CapturesMobx")(observer(
class CreateNewCaptureFloatingBox extends Component {
  oncancel_create_new_capture = () => {
    this.props.CapturesMobx.a_set_create_new_capture_is_open_tf(false);
  }

  render() {
    if(!this.props.CapturesMobx.o_createNewCaptureIsOpenTF) {
      return(null);
    }

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="contactsSystemSelect"
        p_title="Create a New Capture"
        f_onClickCancel={this.oncancel_create_new_capture}>
        <CreateNewCapture />
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));

const CreateNewCapture = inject("CaptureExecMobx", "CapturesMobx", "OpenCaptureMobx", "DatabaseMobx", "UserMobx")(observer(
class CreateNewCapture extends Component {
  constructor(props) {
    super(props);

    const o_userID = this.props.UserMobx.o_userID;
    const c_userDivisionID = this.props.UserMobx.c_userDivisionID;
    const c_fieldMapOfOpportunityName = this.props.DatabaseMobx.c_fieldMapOfOpportunityName;
    const c_fieldMapOfCodename = this.props.DatabaseMobx.c_fieldMapOfCodename;
    const c_fieldMapOfCaptureManagers = this.props.DatabaseMobx.c_fieldMapOfCaptureManagers;
    const c_fieldMapOfDivisionOwners = this.props.DatabaseMobx.c_fieldMapOfDivisionOwners;
    const c_fieldMapOfCaptureType = this.props.DatabaseMobx.c_fieldMapOfCaptureType;
    const c_fieldMapOfStage = this.props.DatabaseMobx.c_fieldMapOfStage;
    const c_fieldMapOfPrimeContactCompanyID = this.props.DatabaseMobx.c_fieldMapOfPrimeContactCompanyID;
    const c_fieldMapOfContractType = this.props.DatabaseMobx.c_fieldMapOfContractType;
    const c_fieldMapOfContractOverallValue = this.props.DatabaseMobx.c_fieldMapOfContractOverallValue;
    const c_fieldMapOfIdiqCaptureIDTOLink = this.props.DatabaseMobx.c_fieldMapOfIdiqCaptureIDTOLink;
    const c_fieldMapOfPeriodOfPerformance = this.props.DatabaseMobx.c_fieldMapOfPeriodOfPerformance;

    var newCaptureObj = {
      added_date: JSFUNC.now_dateYmd(),
      opportunity_name: c_fieldMapOfOpportunityName.get("fieldBlankValue"),
      codename: c_fieldMapOfCodename.get("fieldBlankValue"),
      capture_managers_ids_colon_percent_comma: o_userID + ":100", //yourself as full ownership
      division_owners_ids_colon_percent_comma: c_userDivisionID + ":100", //your division as full ownership
      capture_type_id: c_fieldMapOfCaptureType.get("fieldBlankValue"),
      stage_id: c_fieldMapOfStage.get("fieldBlankValue"),
      prime_contact_company_id: c_fieldMapOfPrimeContactCompanyID.get("fieldBlankValue"),
      contract_type_id: c_fieldMapOfContractType.get("fieldBlankValue"),
      contract_overall_value: c_fieldMapOfContractOverallValue.get("fieldBlankValue"),
      idiq_capture_id_TO_link: c_fieldMapOfIdiqCaptureIDTOLink.get("fieldBlankValue"),
      period_of_performance: c_fieldMapOfPeriodOfPerformance.get("fieldBlankValue"),
      additionalFieldsRawValuesObjOrUndefined: undefined //admin defined additional fields card on Create New Capture form for a specific selected Capture Type, initialized undefined for now, holds each field per capture type, is converted into individual fields in this obj when new capture is being created
    };

    this.state = {
      s_newCaptureObj: newCaptureObj,
      s_showErrorsTF: false //set to true the first time save is pushed, if there are errors from incomplete data, it will now be shown
    }
  }

  componentDidMount() {
    const c_createNewCaptureAdminDefaultCaptureTypeIDOrM1 = this.props.DatabaseMobx.c_createNewCaptureAdminDefaultCaptureTypeIDOrM1;
    const c_fieldMapOfCaptureType = this.props.DatabaseMobx.c_fieldMapOfCaptureType;
    const initialCaptureTypeID = ((c_createNewCaptureAdminDefaultCaptureTypeIDOrM1 === -1) ? (c_fieldMapOfCaptureType.get("fieldBlankValue")) : (c_createNewCaptureAdminDefaultCaptureTypeIDOrM1));
    this.onchange_capture_type(initialCaptureTypeID, true);
  }

  onchange_opportunity_name = (i_newValue) => {
    this.update_new_capture_field("opportunity_name", i_newValue);

    const updatedOpportunityNameLowercase = i_newValue.toLowerCase();
    this.props.CapturesMobx.a_set_create_new_capture_opportunity_name_lowercase(updatedOpportunityNameLowercase);
  }

  onchange_codename = (i_newValue) => { this.update_new_capture_field("codename", i_newValue); }
  onchange_capture_managers = (i_newValue) => { this.update_new_capture_field("capture_managers_ids_colon_percent_comma", i_newValue); }
  onchange_division_owners = (i_newValue) => { this.update_new_capture_field("division_owners_ids_colon_percent_comma", i_newValue); }
  onchange_capture_type = (i_selectedCaptureTypeID, i_initializeAllFieldsTF=false) => {
    const o_tbl_a_create_new_capture_additional_fields = this.props.DatabaseMobx.o_tbl_a_create_new_capture_additional_fields;
    const c_fieldMapOfCaptureType = this.props.DatabaseMobx.c_fieldMapOfCaptureType;
    const c_fieldMapOfOpportunityName = this.props.DatabaseMobx.c_fieldMapOfOpportunityName;
    const c_fieldMapOfCodename = this.props.DatabaseMobx.c_fieldMapOfCodename;
    const c_fieldMapOfCaptureManagers = this.props.DatabaseMobx.c_fieldMapOfCaptureManagers;
    const c_fieldMapOfDivisionOwners = this.props.DatabaseMobx.c_fieldMapOfDivisionOwners;
    const c_fieldMapOfStage = this.props.DatabaseMobx.c_fieldMapOfStage;
    const c_fieldMapOfPrimeContactCompanyID = this.props.DatabaseMobx.c_fieldMapOfPrimeContactCompanyID;
    const c_fieldMapOfContractType = this.props.DatabaseMobx.c_fieldMapOfContractType;
    const c_fieldMapOfContractOverallValue = this.props.DatabaseMobx.c_fieldMapOfContractOverallValue;
    const c_fieldMapOfIdiqCaptureIDTOLink = this.props.DatabaseMobx.c_fieldMapOfIdiqCaptureIDTOLink;
    const c_fieldMapOfPeriodOfPerformance = this.props.DatabaseMobx.c_fieldMapOfPeriodOfPerformance;
    const s_newCaptureObj = this.state.s_newCaptureObj;

    const newCaptureTypeIsFilledOutTF = this.props.DatabaseMobx.value_is_filled_out_tf_from_value_raw_and_field_type_obj(i_selectedCaptureTypeID, c_fieldMapOfCaptureType.get("fieldTypeObj"));

    const captureTypeStageInfoObj = this.get_capture_type_stage_info_obj_from_capture_type_id(i_selectedCaptureTypeID);
    const initialStageFallbackRaw = ((captureTypeStageInfoObj.captureTypeStageIDsArray.length > 0) ? (captureTypeStageInfoObj.firstStageIDOrM1) : (c_fieldMapOfStage.get("fieldBlankValue")));
    const currentStageExistsInSelectedCaptureTypeTF = captureTypeStageInfoObj.captureTypeStageIDsArray.includes(s_newCaptureObj.stage_id);
    const stageFallbackRaw = ((i_initializeAllFieldsTF || !currentStageExistsInSelectedCaptureTypeTF) ? (initialStageFallbackRaw) : (s_newCaptureObj.stage_id));
    const opportunityNameFallbackRaw = ((i_initializeAllFieldsTF) ? (undefined) : (s_newCaptureObj.opportunity_name));
    const codenameFallbackRaw = ((i_initializeAllFieldsTF) ? (undefined) : (s_newCaptureObj.codename));
    const captureManagersFallbackRaw = s_newCaptureObj.capture_managers_ids_colon_percent_comma;
    const divisionOwnersFallbackRaw = s_newCaptureObj.division_owners_ids_colon_percent_comma;
    const primeContactCompanyIDFallbackRaw = ((i_initializeAllFieldsTF) ? (undefined) : (s_newCaptureObj.prime_contact_company_id));
    const contractTypeIDFallbackRaw = ((i_initializeAllFieldsTF) ? (undefined) : (s_newCaptureObj.contract_type_id));
    const contractOverallValueFallbackRaw = ((i_initializeAllFieldsTF) ? (undefined) : (s_newCaptureObj.contract_overall_value));
    const idiqCaptureIDTOLinkFallbackRaw = ((i_initializeAllFieldsTF) ? (undefined) : (s_newCaptureObj.idiq_capture_id_TO_link));
    const periodOfPerformanceFallbackRaw = ((i_initializeAllFieldsTF) ? (undefined) : (s_newCaptureObj.period_of_performance));

    const defaultOrCurrentStageID = this.get_field_default_value_raw_or_field_blank_value_from_capture_type_id_and_expanded_capture_field_map(i_selectedCaptureTypeID, c_fieldMapOfStage, stageFallbackRaw);
    const defaultOrCurrentOpportunityName = this.get_field_default_value_raw_or_field_blank_value_from_capture_type_id_and_expanded_capture_field_map(i_selectedCaptureTypeID, c_fieldMapOfOpportunityName, opportunityNameFallbackRaw);
    const defaultOrCurrentCodename = this.get_field_default_value_raw_or_field_blank_value_from_capture_type_id_and_expanded_capture_field_map(i_selectedCaptureTypeID, c_fieldMapOfCodename, codenameFallbackRaw);
    const defaultOrCurrentCaptureManagers = this.get_field_default_value_raw_or_field_blank_value_from_capture_type_id_and_expanded_capture_field_map(i_selectedCaptureTypeID, c_fieldMapOfCaptureManagers, captureManagersFallbackRaw);
    const defaultOrCurrentDivisionOwners = this.get_field_default_value_raw_or_field_blank_value_from_capture_type_id_and_expanded_capture_field_map(i_selectedCaptureTypeID, c_fieldMapOfDivisionOwners, divisionOwnersFallbackRaw, i_initializeAllFieldsTF);
    const defaultOrCurrentPrimeContactCompanyID = this.get_field_default_value_raw_or_field_blank_value_from_capture_type_id_and_expanded_capture_field_map(i_selectedCaptureTypeID, c_fieldMapOfPrimeContactCompanyID, primeContactCompanyIDFallbackRaw);
    const defaultOrCurrentContractTypeID = this.get_field_default_value_raw_or_field_blank_value_from_capture_type_id_and_expanded_capture_field_map(i_selectedCaptureTypeID, c_fieldMapOfContractType, contractTypeIDFallbackRaw);
    const defaultOrCurrentContractOverallValue = this.get_field_default_value_raw_or_field_blank_value_from_capture_type_id_and_expanded_capture_field_map(i_selectedCaptureTypeID, c_fieldMapOfContractOverallValue, contractOverallValueFallbackRaw);
    const defaultOrCurrentIdiqCaptureIDTOLink = this.get_field_default_value_raw_or_field_blank_value_from_capture_type_id_and_expanded_capture_field_map(i_selectedCaptureTypeID, c_fieldMapOfIdiqCaptureIDTOLink, idiqCaptureIDTOLinkFallbackRaw);
    const defaultOrCurrentPeriodOfPerformance = this.get_field_default_value_raw_or_field_blank_value_from_capture_type_id_and_expanded_capture_field_map(i_selectedCaptureTypeID, c_fieldMapOfPeriodOfPerformance, periodOfPerformanceFallbackRaw);

    var updatedAdditionalFieldsRawValuesObj = undefined; //if the new Capture Type is not filled out, erase the additional fields obj
    if(newCaptureTypeIsFilledOutTF) {
      const captureTypeAdditionalFieldsArrayOfObjs = JSFUNC.filtered_sorted_arrayOfObjs_from_mapOfMaps_matching_field_value(o_tbl_a_create_new_capture_additional_fields, "capture_type_id", i_selectedCaptureTypeID);
      if(captureTypeAdditionalFieldsArrayOfObjs.length > 0) {
        updatedAdditionalFieldsRawValuesObj = {};
        for(let additionalFieldObj of captureTypeAdditionalFieldsArrayOfObjs) {
          var expandedCaptureFieldMap = this.props.DatabaseMobx.fetch_expanded_capture_field_map_from_field_id(additionalFieldObj.capture_field_id);
          var fieldDbName = expandedCaptureFieldMap.get("db_name");
          const currentAdditionalFieldValueRawOrUndefined = ((s_newCaptureObj.additionalFieldsRawValuesObjOrUndefined === undefined) ? (undefined) : (s_newCaptureObj.additionalFieldsRawValuesObjOrUndefined[fieldDbName]));
          updatedAdditionalFieldsRawValuesObj[fieldDbName] = this.get_field_default_value_raw_or_field_blank_value_from_capture_type_id_and_expanded_capture_field_map(i_selectedCaptureTypeID, expandedCaptureFieldMap, currentAdditionalFieldValueRawOrUndefined);
        }
      }
    }

    const updatedNewCaptureObj = JSFUNC.copy_obj(s_newCaptureObj);
    updatedNewCaptureObj.capture_type_id = i_selectedCaptureTypeID;
    updatedNewCaptureObj.opportunity_name = defaultOrCurrentOpportunityName;
    updatedNewCaptureObj.codename = defaultOrCurrentCodename;
    updatedNewCaptureObj.capture_managers_ids_colon_percent_comma = defaultOrCurrentCaptureManagers;
    updatedNewCaptureObj.division_owners_ids_colon_percent_comma = defaultOrCurrentDivisionOwners;
    updatedNewCaptureObj.stage_id = defaultOrCurrentStageID;
    updatedNewCaptureObj.prime_contact_company_id = defaultOrCurrentPrimeContactCompanyID;
    updatedNewCaptureObj.contract_type_id = defaultOrCurrentContractTypeID;
    updatedNewCaptureObj.contract_overall_value = defaultOrCurrentContractOverallValue;
    updatedNewCaptureObj.idiq_capture_id_TO_link = defaultOrCurrentIdiqCaptureIDTOLink;
    updatedNewCaptureObj.period_of_performance = defaultOrCurrentPeriodOfPerformance;
    updatedNewCaptureObj.additionalFieldsRawValuesObjOrUndefined = updatedAdditionalFieldsRawValuesObj;
    this.props.CapturesMobx.a_set_create_new_capture_opportunity_name_lowercase(defaultOrCurrentOpportunityName.toLowerCase());
    this.setState({s_newCaptureObj:updatedNewCaptureObj});
  }
  onchange_stage = (i_newValue) => { this.update_new_capture_field("stage_id", i_newValue); }
  onchange_prime_company = (i_newValue) => { this.update_new_capture_field("prime_contact_company_id", i_newValue); }
  onchange_contract_type = (i_newValue) => {
    this.update_new_capture_field("contract_type_id", i_newValue); //set the newly selected contract type
    this.update_new_capture_field("idiq_capture_id_TO_link", this.props.DatabaseMobx.c_fieldMapOfIdiqCaptureIDTOLink.get("fieldBlankValue")); //reset IDIQ TO link in case you're switching away from a Task Order
  }
  onchange_contract_overall_value = (i_newValue) => { this.update_new_capture_field("contract_overall_value", i_newValue); }
  onchange_idiq_to_link = (i_newValue) => { this.update_new_capture_field("idiq_capture_id_TO_link", i_newValue); }
  onchange_period_of_performance = (i_newValue) => { this.update_new_capture_field("period_of_performance", i_newValue); }
  onchange_additional_field = (i_additionalFieldDbName, i_newValue) => {
    const s_newCaptureObj = this.state.s_newCaptureObj;

    var updatedAdditionalFieldsRawValuesObj = {};
    if(s_newCaptureObj.additionalFieldsRawValuesObjOrUndefined !== undefined) {
      updatedAdditionalFieldsRawValuesObj = JSFUNC.copy_obj(s_newCaptureObj.additionalFieldsRawValuesObjOrUndefined);
    }

    updatedAdditionalFieldsRawValuesObj[i_additionalFieldDbName] = i_newValue;

    this.update_new_capture_field("additionalFieldsRawValuesObjOrUndefined", updatedAdditionalFieldsRawValuesObj);
  }
  onchange_documents_card_folders_preset = (i_newValue) => {
    this.props.CapturesMobx.a_set_create_new_capture_selected_documents_card_folders_preset_id(i_newValue);
  }

  update_new_capture_field = (i_fieldDbName, i_newValue) => {
    const s_newCaptureObj = this.state.s_newCaptureObj;

    var updatedNewCaptureObj = s_newCaptureObj;
    updatedNewCaptureObj[i_fieldDbName] = i_newValue;

    this.setState({s_newCaptureObj:updatedNewCaptureObj});
  }

  onconfirm_create_new_capture = () => {
    const s_newCaptureObj = this.state.s_newCaptureObj;
    
    const o_createNewCaptureSelectedDocumentsCardFoldersPresetID = this.props.CapturesMobx.o_createNewCaptureSelectedDocumentsCardFoldersPresetID;
    const o_tbl_a_create_new_capture_additional_fields = this.props.DatabaseMobx.o_tbl_a_create_new_capture_additional_fields;
    const c_fieldMapOfCaptureManagers = this.props.DatabaseMobx.c_fieldMapOfCaptureManagers;
    const c_fieldMapOfDivisionOwners = this.props.DatabaseMobx.c_fieldMapOfDivisionOwners;
    const c_fieldMapOfCodename = this.props.DatabaseMobx.c_fieldMapOfCodename;
    const c_fieldMapOfOpportunityName = this.props.DatabaseMobx.c_fieldMapOfOpportunityName;
    const c_fieldMapOfCaptureType = this.props.DatabaseMobx.c_fieldMapOfCaptureType;
    const c_fieldMapOfStage = this.props.DatabaseMobx.c_fieldMapOfStage;
    const c_fieldMapOfPrimeContactCompanyID = this.props.DatabaseMobx.c_fieldMapOfPrimeContactCompanyID;
    const c_fieldMapOfContractType = this.props.DatabaseMobx.c_fieldMapOfContractType;
    const c_fieldMapOfContractOverallValue = this.props.DatabaseMobx.c_fieldMapOfContractOverallValue;
    const c_fieldMapOfIdiqCaptureIDTOLink = this.props.DatabaseMobx.c_fieldMapOfIdiqCaptureIDTOLink;
    const c_fieldMapOfPeriodOfPerformance = this.props.DatabaseMobx.c_fieldMapOfPeriodOfPerformance;

    const [isStandardContractTF, isIDIQContractTF, isTaskOrderContractTF] = this.get_contract_type_type_from_selected_contract_type();

    //get all user input errors to display
    const opportunityNameErrorMessageOrUndefined = this.get_field_error_message_or_undefined_from_expanded_capture_field_map(c_fieldMapOfOpportunityName, true);
    const codenameErrorMessageOrUndefined = this.get_field_error_message_or_undefined_from_expanded_capture_field_map(c_fieldMapOfCodename, false);
    const captureManagersErrorMessageOrUndefined = this.get_field_error_message_or_undefined_from_expanded_capture_field_map(c_fieldMapOfCaptureManagers, false);
    const divisionOwnersErrorMessageOrUndefined = this.get_field_error_message_or_undefined_from_expanded_capture_field_map(c_fieldMapOfDivisionOwners, false);
    const captureTypeErrorMessageOrUndefined = this.get_field_error_message_or_undefined_from_expanded_capture_field_map(c_fieldMapOfCaptureType, true);
    const stageErrorMessageOrUndefined = this.get_field_error_message_or_undefined_from_expanded_capture_field_map(c_fieldMapOfStage, false);
    const contractTypeErrorMessageOrUndefined = this.get_field_error_message_or_undefined_from_expanded_capture_field_map(c_fieldMapOfContractType, true);
    const contractOverallValueErrorMessageOrUndefined = this.get_field_error_message_or_undefined_from_expanded_capture_field_map(c_fieldMapOfContractOverallValue, false);
    const idiqCaptureTOLinkErrorMessageOrUndefined = this.get_field_error_message_or_undefined_from_expanded_capture_field_map(c_fieldMapOfIdiqCaptureIDTOLink, false);
    const periodOfPerformanceErrorMessageOrUndefined = this.get_field_error_message_or_undefined_from_expanded_capture_field_map(c_fieldMapOfPeriodOfPerformance, false);

    const onErrTF = (opportunityNameErrorMessageOrUndefined !== undefined);
    const cnErrTF = (codenameErrorMessageOrUndefined !== undefined);
    const cmErrTF = (captureManagersErrorMessageOrUndefined !== undefined);
    const doErrTF = (divisionOwnersErrorMessageOrUndefined !== undefined);
    const catErrTF = (captureTypeErrorMessageOrUndefined !== undefined);
    const sErrTF = (stageErrorMessageOrUndefined !== undefined);
    const cotErrTF = (contractTypeErrorMessageOrUndefined !== undefined);
    const covErrTF = (contractOverallValueErrorMessageOrUndefined !== undefined);
    const itoErrTF = (isTaskOrderContractTF && (idiqCaptureTOLinkErrorMessageOrUndefined !== undefined));
    const popErrTF = (periodOfPerformanceErrorMessageOrUndefined !== undefined);

    var anyAdditionalErrorTF = false;
    const captureTypeAdditionalFieldsArrayOfObjs = JSFUNC.filtered_sorted_arrayOfObjs_from_mapOfMaps_matching_field_value(o_tbl_a_create_new_capture_additional_fields, "capture_type_id", s_newCaptureObj.capture_type_id, "sort", true);
    if(captureTypeAdditionalFieldsArrayOfObjs.length > 0) {
      for(let additionalFieldObj of captureTypeAdditionalFieldsArrayOfObjs) {
        var expandedCaptureFieldMap = this.props.DatabaseMobx.fetch_expanded_capture_field_map_from_field_id(additionalFieldObj.capture_field_id);
        var fieldErrorMessageOrUndefined = this.get_field_error_message_or_undefined_from_expanded_capture_field_map(expandedCaptureFieldMap, false, true);
        if(fieldErrorMessageOrUndefined !== undefined) {
          anyAdditionalErrorTF = true;
          break;
        }
      }
    }

    if(onErrTF || cnErrTF || cmErrTF || doErrTF || catErrTF || sErrTF || cotErrTF || covErrTF || itoErrTF || popErrTF || anyAdditionalErrorTF) {
      this.setState({s_showErrorsTF:true});
    }
    else {
      //copy and modify the s_newCaptureObj to bring additional field values from additionalFieldsRawValuesObjOrUndefined to the base level of the new capture obj
      var additionalFieldsNewCaptureObj = JSFUNC.copy_obj(s_newCaptureObj);
      if(s_newCaptureObj.additionalFieldsRawValuesObjOrUndefined !== undefined) {
        additionalFieldsNewCaptureObj.additionalFieldsRawValuesObjOrUndefined = undefined; //remove the temporary raw value holding for additional fields
        for(var fieldDbName in s_newCaptureObj.additionalFieldsRawValuesObjOrUndefined) { //copy additional fields with raw values to base level of new capture obj
          if(s_newCaptureObj.additionalFieldsRawValuesObjOrUndefined.hasOwnProperty(fieldDbName)) {
            s_newCaptureObj[fieldDbName] = s_newCaptureObj.additionalFieldsRawValuesObjOrUndefined[fieldDbName];
          }
        }
      }

      //create a new capture from the new capture obj
      this.props.CapturesMobx.a_create_new_capture_from_new_capture_process(s_newCaptureObj, o_createNewCaptureSelectedDocumentsCardFoldersPresetID);
    }
  }

  get_field_error_message_or_undefined_from_expanded_capture_field_map = (i_expandedCaptureFieldMap, i_mustBeFilledOutTF=false, i_isNewCaptureAdditionalFieldTF=false) => {
    const s_newCaptureObj = this.state.s_newCaptureObj;

    const fieldDbName = i_expandedCaptureFieldMap.get("db_name");
    const fieldDisplayName = i_expandedCaptureFieldMap.get("display_name");
    const fieldTypeObj = i_expandedCaptureFieldMap.get("fieldTypeObj");

    const newCaptureCaptureTypeID = s_newCaptureObj.capture_type_id;

    var newCaptureValueRaw = undefined;
    if(i_isNewCaptureAdditionalFieldTF) {
      if(s_newCaptureObj.additionalFieldsRawValuesObjOrUndefined !== undefined) {
        newCaptureValueRaw = s_newCaptureObj.additionalFieldsRawValuesObjOrUndefined[fieldDbName];
      }
    }
    else {
      newCaptureValueRaw = s_newCaptureObj[fieldDbName];
    }

    if(i_mustBeFilledOutTF) {
      if(!this.props.DatabaseMobx.value_is_filled_out_tf_from_value_raw_and_field_type_obj(newCaptureValueRaw, fieldTypeObj)) {
        return(fieldDisplayName + " must be filled out");
      }
    }

    if(fieldTypeObj !== undefined) {
      if(fieldTypeObj.sharedPercentTF) {
        if(JSFUNC.sum_of_colon_comma_list_int2(newCaptureValueRaw, 100, -1, 8) !== 100) {
          return(fieldDisplayName + " must add up to 100%");
        }
      }
    }
    
    return(this.props.DatabaseMobx.new_capture_field_admin_error_message_or_undefined(i_expandedCaptureFieldMap, newCaptureValueRaw, newCaptureCaptureTypeID)); //no error with this new capture shared percent field entered value
  }

  get_field_default_value_raw_or_field_blank_value_from_capture_type_id_and_expanded_capture_field_map = (i_captureTypeID, i_expandedCaptureFieldMap, i_fallbackRawOrUndefined, i_useCreateNewCaptureDefaultDivisionTF=true) => {
    const c_tbl_a_capture_types_details_fields = this.props.DatabaseMobx.c_tbl_a_capture_types_details_fields;

    const fieldNamesArray = ["capture_type_id", "field_id"];
    const valuesArray = [i_captureTypeID, i_expandedCaptureFieldMap.get("id")];
    const fieldDefaultValueRawOrUndefined = JSFUNC.get_first_map_value_or_undefined_from_mapOfMaps_matching_field_value(c_tbl_a_capture_types_details_fields, fieldNamesArray, valuesArray, "defaultValueRawOrUndefined");
    if(fieldDefaultValueRawOrUndefined !== undefined) {
      return(fieldDefaultValueRawOrUndefined);
    }

    if(i_useCreateNewCaptureDefaultDivisionTF && (i_expandedCaptureFieldMap.get("db_name") === "division_owners_ids_colon_percent_comma")) {
      const o_loggedInUserMap = this.props.DatabaseMobx.o_tbl_a_users.get(this.props.UserMobx.o_userID);
      if(o_loggedInUserMap !== undefined) {
        const createNewCaptureDefaultDivisionIDOrM1 = o_loggedInUserMap.get("create_new_capture_default_division_id_or_m1");
        if(JSFUNC.is_number_not_nan_gt_0(createNewCaptureDefaultDivisionIDOrM1)) {
          return(createNewCaptureDefaultDivisionIDOrM1 + ":100");
        }
      }
    }

    if(i_fallbackRawOrUndefined !== undefined) {
      return(i_fallbackRawOrUndefined);
    }
    return(i_expandedCaptureFieldMap.get("fieldBlankValue"));
  }

  get_capture_type_stage_info_obj_from_capture_type_id = (i_captureTypeID) => {
    const captureTypeMap = this.props.DatabaseMobx.tbl_row_map_from_id("tbl_a_capture_types", i_captureTypeID);
    const captureTypeStagesArrayOfObjs = this.props.DatabaseMobx.get_nonduplicate_filtered_expanded_stages_arrayOfObjs_from_capture_type_id(i_captureTypeID);
    const captureTypeStageIDsArray = JSFUNC.get_column_vector_from_arrayOfObjs(captureTypeStagesArrayOfObjs, "id");

    var firstStageIDOrM1 = -1;
    if(captureTypeStageIDsArray.length > 0) {
      firstStageIDOrM1 = captureTypeStageIDsArray[0];
    }

    const stagesTblRef = this.props.DatabaseMobx.tbl_ref_from_tbl_name("tbl_a_stages_pool");
    const stagesMapOfMaps = JSFUNC.filtered_mapOfMaps_from_matching_field_value(stagesTblRef, "!id", captureTypeStageIDsArray);
    const stageIDsNotInThisCaptureTypeArray = JSFUNC.get_column_vector_from_mapOfMaps(stagesMapOfMaps, "id");

    //determine prime/sub of this capture type
    const captureTypePrime1Sub2 = captureTypeMap.get("prime1_sub2");
    const isPrimeCaptureTypeTF = (captureTypePrime1Sub2 === 1);
    const isSubCaptureTypeTF = (captureTypePrime1Sub2 === 2);

    return({
      captureTypeStageIDsArray: captureTypeStageIDsArray,
      firstStageIDOrM1: firstStageIDOrM1,
      stageIDsNotInThisCaptureTypeArray: stageIDsNotInThisCaptureTypeArray,
      isPrimeCaptureTypeTF: isPrimeCaptureTypeTF,
      isSubCaptureTypeTF: isSubCaptureTypeTF
    });
  }

  get_contract_type_type_from_selected_contract_type = () => {
    const s_newCaptureObj = this.state.s_newCaptureObj;

    const contractTypeMap = this.props.DatabaseMobx.tbl_row_map_from_id("tbl_a_contract_types", s_newCaptureObj.contract_type_id);
    const contractTypeType123 = contractTypeMap.get("sa1_idiq2_to3");
    const isStandardContractTF = (contractTypeType123 === 1);
    const isIDIQContractTF = (contractTypeType123 === 2);
    const isTaskOrderContractTF = (contractTypeType123 === 3);

    return([isStandardContractTF, isIDIQContractTF, isTaskOrderContractTF]);
  }

  render() {
    const s_newCaptureObj = this.state.s_newCaptureObj;
    const s_showErrorsTF = this.state.s_showErrorsTF;

    const c_isMobileOrTabletTF = this.props.CaptureExecMobx.c_isMobileOrTabletTF;
    const o_createNewCaptureIsOpenTF = this.props.CapturesMobx.o_createNewCaptureIsOpenTF;
    const o_createNewCaptureSelectedDocumentsCardFoldersPresetID = this.props.CapturesMobx.o_createNewCaptureSelectedDocumentsCardFoldersPresetID;
    const c_createNewCaptureFilteredMatchingCaptureIDsAndNamesLowercaseArrayOfObjs = this.props.CapturesMobx.c_createNewCaptureFilteredMatchingCaptureIDsAndNamesLowercaseArrayOfObjs;
    const c_createNewCaptureDocumentsCardFoldersSelectedPresetName = this.props.CapturesMobx.c_createNewCaptureDocumentsCardFoldersSelectedPresetName;
    const c_createNewCaptureDocumentsCardFoldersSortedTreeWithIndentsArrayOfObjs = this.props.CapturesMobx.c_createNewCaptureDocumentsCardFoldersSortedTreeWithIndentsArrayOfObjs;
    const o_tbl_a_create_new_capture_additional_fields = this.props.DatabaseMobx.o_tbl_a_create_new_capture_additional_fields;
    const c_companyUsingCodenameTF = this.props.DatabaseMobx.c_companyUsingCodenameTF;
    const c_companyShortcutPresetsDocumentsCardFoldersOnCreateNewCaptureTF = this.props.DatabaseMobx.c_companyShortcutPresetsDocumentsCardFoldersOnCreateNewCaptureTF;
    const c_cardNameDocuments = this.props.DatabaseMobx.c_cardNameDocuments;
    const c_fieldMapOfCaptureManagers = this.props.DatabaseMobx.c_fieldMapOfCaptureManagers;
    const c_fieldMapOfDivisionOwners = this.props.DatabaseMobx.c_fieldMapOfDivisionOwners;
    const c_fieldMapOfCodename = this.props.DatabaseMobx.c_fieldMapOfCodename;
    const c_fieldMapOfOpportunityName = this.props.DatabaseMobx.c_fieldMapOfOpportunityName;
    const c_fieldMapOfCaptureType = this.props.DatabaseMobx.c_fieldMapOfCaptureType;
    const c_fieldMapOfStage = this.props.DatabaseMobx.c_fieldMapOfStage;
    const c_fieldMapOfPrimeContactCompanyID = this.props.DatabaseMobx.c_fieldMapOfPrimeContactCompanyID;
    const c_fieldMapOfContractType = this.props.DatabaseMobx.c_fieldMapOfContractType;
    const c_fieldMapOfContractOverallValue = this.props.DatabaseMobx.c_fieldMapOfContractOverallValue;
    const c_fieldMapOfIdiqCaptureIDTOLink = this.props.DatabaseMobx.c_fieldMapOfIdiqCaptureIDTOLink;
    const c_fieldMapOfPeriodOfPerformance = this.props.DatabaseMobx.c_fieldMapOfPeriodOfPerformance;
    const c_selectShortcutPresetsDocumentsCardFoldersPresetFieldTypeObj = this.props.DatabaseMobx.c_selectShortcutPresetsDocumentsCardFoldersPresetFieldTypeObj;
    
    if(!o_createNewCaptureIsOpenTF) {
      return(null);
    }
    
    const itemRowMinHeight = "2.3em";
    const typeMargin = ((c_isMobileOrTabletTF) ? ("0") : ("5%"));

    const newCaptureTypeIsFilledOutTF = this.props.DatabaseMobx.value_is_filled_out_tf_from_value_raw_and_field_type_obj(s_newCaptureObj.capture_type_id, c_fieldMapOfCaptureType.get("fieldTypeObj"));

    const numOppNameMatchingCaptures = c_createNewCaptureFilteredMatchingCaptureIDsAndNamesLowercaseArrayOfObjs.length;

    //get contract type type (SA, IDIQ, TO) from the selected contract type (determines if TO Link is valid etc below)
    const [isStandardContractTF, isIDIQContractTF, isTaskOrderContractTF] = this.get_contract_type_type_from_selected_contract_type();

    //get all user input errors to display
    const opportunityNameErrorMessageOrUndefined = this.get_field_error_message_or_undefined_from_expanded_capture_field_map(c_fieldMapOfOpportunityName, true);
    const codenameErrorMessageOrUndefined = this.get_field_error_message_or_undefined_from_expanded_capture_field_map(c_fieldMapOfCodename, false);
    const captureManagersErrorMessageOrUndefined = this.get_field_error_message_or_undefined_from_expanded_capture_field_map(c_fieldMapOfCaptureManagers, false);
    const divisionOwnersErrorMessageOrUndefined = this.get_field_error_message_or_undefined_from_expanded_capture_field_map(c_fieldMapOfDivisionOwners, false);
    const captureTypeErrorMessageOrUndefined = this.get_field_error_message_or_undefined_from_expanded_capture_field_map(c_fieldMapOfCaptureType, true);
    const stageErrorMessageOrUndefined = this.get_field_error_message_or_undefined_from_expanded_capture_field_map(c_fieldMapOfStage, false);
    const contractTypeErrorMessageOrUndefined = this.get_field_error_message_or_undefined_from_expanded_capture_field_map(c_fieldMapOfContractType, true);
    const contractOverallValueErrorMessageOrUndefined = this.get_field_error_message_or_undefined_from_expanded_capture_field_map(c_fieldMapOfContractOverallValue, false);
    const idiqCaptureTOLinkErrorMessageOrUndefined = this.get_field_error_message_or_undefined_from_expanded_capture_field_map(c_fieldMapOfIdiqCaptureIDTOLink, false);
    const periodOfPerformanceErrorMessageOrUndefined = this.get_field_error_message_or_undefined_from_expanded_capture_field_map(c_fieldMapOfPeriodOfPerformance, false);

    //get all stageIDs not in this capture type so that the select for stages is only left with the ones in this type
    var stageIDsNotInThisCaptureTypeArray = [];
    var isSubCaptureTypeTF = false;
    if(newCaptureTypeIsFilledOutTF) { //selected capture type is valid
      const captureTypeStageInfoObj = this.get_capture_type_stage_info_obj_from_capture_type_id(s_newCaptureObj.capture_type_id);
      stageIDsNotInThisCaptureTypeArray = captureTypeStageInfoObj.stageIDsNotInThisCaptureTypeArray;
      isSubCaptureTypeTF = captureTypeStageInfoObj.isSubCaptureTypeTF;
    }

    //add any admin defined Additional Fields for this Create New Capture form
    var captureTypeAdditionalFieldsArrayOfObjs = []; //initialize with 0 additional fields for the selected Capture Type
    var numCaptureTypeAdditionalFields = 0;
    if(newCaptureTypeIsFilledOutTF) {
      captureTypeAdditionalFieldsArrayOfObjs = JSFUNC.filtered_sorted_arrayOfObjs_from_mapOfMaps_matching_field_value(o_tbl_a_create_new_capture_additional_fields, "capture_type_id", s_newCaptureObj.capture_type_id, "sort", true);
      numCaptureTypeAdditionalFields = captureTypeAdditionalFieldsArrayOfObjs.length;
      if(numCaptureTypeAdditionalFields > 0) {
        for(let additionalFieldObj of captureTypeAdditionalFieldsArrayOfObjs) {
          var expandedCaptureFieldMap = this.props.DatabaseMobx.fetch_expanded_capture_field_map_from_field_id(additionalFieldObj.capture_field_id);
          additionalFieldObj.expandedCaptureFieldMap = expandedCaptureFieldMap;
          additionalFieldObj.fieldDbName = expandedCaptureFieldMap.get("db_name");
          additionalFieldObj.fieldDisplayName = expandedCaptureFieldMap.get("display_name");
          additionalFieldObj.fieldBlankValue = expandedCaptureFieldMap.get("fieldBlankValue");
          additionalFieldObj.fieldErrorMessageOrUndefined = this.get_field_error_message_or_undefined_from_expanded_capture_field_map(expandedCaptureFieldMap, false, true);
        }
      }
    }
    const captureTypeHasAnyAdditionalFieldsTF = (numCaptureTypeAdditionalFields > 0)

    var cncBoxIDsToDrawArray = [2, 3, 4, 5];
    if(captureTypeHasAnyAdditionalFieldsTF) { //additional fields cnc card
      cncBoxIDsToDrawArray.push(6);
    }
    if(c_companyShortcutPresetsDocumentsCardFoldersOnCreateNewCaptureTF) { //documents card folders shortcut presets
      cncBoxIDsToDrawArray.push(7);
    }

    var numCncBoxesPerRow = 2;
    if(c_isMobileOrTabletTF) {
      numCncBoxesPerRow = 1;
    }

    const createNewCaptureRCMatrixOfObjs = JSFUNC.get_rc_matrix_from_id_array_and_num_columns(cncBoxIDsToDrawArray, numCncBoxesPerRow);

    const oppNameCodeNameLabelsAndInputsComponent = (
      <>
        <div className="displayFlexRowVc" style={{minHeight:itemRowMinHeight}}>
          <CEGeneralReact.NewCaptureFieldLabel p_widthEm={11} p_label={c_fieldMapOfOpportunityName.get("display_name")} />
          <div className="flex11a">
            <CEGeneralReact.GenericInputOrSelectFromInputType
              p_fieldTypeObj={c_fieldMapOfOpportunityName.get("fieldTypeObj")}
              p_valueRaw={s_newCaptureObj.opportunity_name}
              p_tabIndex={1}
              p_errorTF={(s_showErrorsTF && (opportunityNameErrorMessageOrUndefined !== undefined))}
              f_onChangeOrOnSelect={this.onchange_opportunity_name}
            />
            {(s_showErrorsTF && (opportunityNameErrorMessageOrUndefined !== undefined)) &&
              <CEGeneralReact.ErrorText p_class="tbMicroPad" p_text={opportunityNameErrorMessageOrUndefined} />
            }
          </div>
        </div>
        {(c_companyUsingCodenameTF) &&
          <div className="displayFlexRowVc" style={{minHeight:itemRowMinHeight}}>
            <CEGeneralReact.NewCaptureFieldLabel p_widthEm={11} p_label={c_fieldMapOfCodename.get("display_name")} />
            <div className="flex11a">
              <CEGeneralReact.GenericInputOrSelectFromInputType
                p_fieldTypeObj={c_fieldMapOfCodename.get("fieldTypeObj")}
                p_valueRaw={s_newCaptureObj.codename}
                p_tabIndex={2}
                p_errorTF={(s_showErrorsTF && (codenameErrorMessageOrUndefined !== undefined))}
                f_onChangeOrOnSelect={this.onchange_codename}
              />
              {(s_showErrorsTF && (codenameErrorMessageOrUndefined !== undefined)) &&
                <CEGeneralReact.ErrorText p_class="tbMicroPad" p_text={codenameErrorMessageOrUndefined} />
              }
            </div>
          </div>
        }
      </>
    );

    const oppNameMatchingCaptureNamesBoxComponent = (
      <div className="flex11a displayFlexColumn border1bbb borderRadius05 bgLightesterGray">
        <div className="flex00a bgGray tbMicroPad textCenter">
          <LibraryReact.NowrapEllipsis p_fontClass="fontItalic fontWhite">
            {numOppNameMatchingCaptures + " existing " + JSFUNC.plural(numOppNameMatchingCaptures, "Capture", "Captures") + " match '" + s_newCaptureObj.opportunity_name + "'"}
          </LibraryReact.NowrapEllipsis>
        </div>
        <div className="flex11a displayFlexColumn yScroll">
          {(s_newCaptureObj.opportunity_name === "") ? (
            <div className="flex11a displayFlexColumnHcVc textCenter">
              <font className="fontItalic fontTextLighter">
                {"This will show potentially duplicate Captures that match the new " + c_fieldMapOfOpportunityName.get("display_name")}
              </font>
            </div>
          ) : (
            c_createNewCaptureFilteredMatchingCaptureIDsAndNamesLowercaseArrayOfObjs.map((m_captureIDNamesAndArchiveDateObj) =>
              <div
                className={"lrPad hoverLighterBlueGradient " + ((m_captureIDNamesAndArchiveDateObj.archivedTF || m_captureIDNamesAndArchiveDateObj.userNoAccessTF) ? ("") : ("cursorPointer"))}
                title={m_captureIDNamesAndArchiveDateObj.captureNameWithTag + "\n[Click to open this Capture]"}
                onClick={((m_captureIDNamesAndArchiveDateObj.archivedTF || m_captureIDNamesAndArchiveDateObj.userNoAccessTF) ? (undefined) : (() => this.props.OpenCaptureMobx.a_open_single_capture(m_captureIDNamesAndArchiveDateObj.id)))}>
                {(m_captureIDNamesAndArchiveDateObj.captureTagOrUndefined !== undefined) &&
                  <font className="fontTextLightest">
                    {m_captureIDNamesAndArchiveDateObj.captureTagOrUndefined + " "}
                  </font>
                }
                <font className="">
                  {m_captureIDNamesAndArchiveDateObj.captureName}
                </font>
              </div>
            )
          )}
        </div>
      </div>
    );
  
    return(
      <>
        <div className="flex11a displayFlexColumn yScroll yScrollBottomPad">
          <div className="flex00a displayFlexRow tbMedPad lrMedPad">
            <CEGeneralReact.NewCaptureSectionContainer p_drawBorderTF={true}>
                {(c_isMobileOrTabletTF) ? (
                  <CEGeneralReact.NewCaptureSectionLabel p_label="New Capture Name">
                    <div className="" style={{marginLeft:typeMargin, marginRight:typeMargin}}>
                      {oppNameCodeNameLabelsAndInputsComponent}
                    </div>
                    <div className="displayFlexColumnHcVc smallTopMargin">
                      <div className="flex00a displayFlexColumn" style={{width:"100%", maxWidth:"40em", height:"8em"}}>
                        {oppNameMatchingCaptureNamesBoxComponent}
                      </div>
                    </div>
                  </CEGeneralReact.NewCaptureSectionLabel>
                ) : (
                  <div className="displayFlexRow">
                    <div className="flex11a lrPad" style={{flexBasis:"175em"}}>
                      <CEGeneralReact.NewCaptureSectionLabel p_label="New Capture Name">
                        {oppNameCodeNameLabelsAndInputsComponent}
                      </CEGeneralReact.NewCaptureSectionLabel>
                    </div>
                    <div className="flex11a displayFlexColumn smallFullPad" style={{flexBasis:"100em", height:"9em"}}>
                      {oppNameMatchingCaptureNamesBoxComponent}
                    </div>
                  </div>
                )}
            </CEGeneralReact.NewCaptureSectionContainer>
          </div>
          {createNewCaptureRCMatrixOfObjs.map((m_rowCncBoxIDsArray, m_rowIndex) =>
            <div
              key={JSFUNC.rc_unique_row_key(numCncBoxesPerRow, m_rowIndex)}
              className="flex00a displayFlexRow medBottomPad lrMedPad">
              {m_rowCncBoxIDsArray.map((m_cncBoxIDOrM1, m_colIndex) =>
                <>
                  {(m_colIndex > 0) &&
                    <div className="flex00a medRightMargin" />
                  }
                  <CEGeneralReact.NewCaptureSectionContainer key={"c" + m_cncBoxIDOrM1 + "i" + m_colIndex} p_drawBorderTF={((m_cncBoxIDOrM1 >= 2) && (m_cncBoxIDOrM1 <= 7))}>
                    {(m_cncBoxIDOrM1 === 2) &&
                      <CEGeneralReact.NewCaptureSectionLabel p_label={c_fieldMapOfCaptureManagers.get("display_name")}>
                        <div className="" style={{marginLeft:typeMargin, marginRight:typeMargin}}>
                          <CEGeneralReact.GenericInputOrSelectFromInputType
                            p_fieldTypeObj={c_fieldMapOfCaptureManagers.get("fieldTypeObj")}
                            p_valueRaw={s_newCaptureObj.capture_managers_ids_colon_percent_comma}
                            p_errorTF={(s_showErrorsTF && (captureManagersErrorMessageOrUndefined !== undefined))}
                            f_onChangeOrOnSelect={this.onchange_capture_managers}
                          />
                          {(s_showErrorsTF && (captureManagersErrorMessageOrUndefined !== undefined)) &&
                            <CEGeneralReact.ErrorText p_class="tbMicroPad" p_text={captureManagersErrorMessageOrUndefined} />
                          }
                        </div>
                      </CEGeneralReact.NewCaptureSectionLabel>
                    }
                    {(m_cncBoxIDOrM1 === 3) &&
                      <CEGeneralReact.NewCaptureSectionLabel p_label={c_fieldMapOfDivisionOwners.get("display_name")}>
                        <div className="" style={{marginLeft:typeMargin, marginRight:typeMargin}}>
                          <CEGeneralReact.GenericInputOrSelectFromInputType
                            p_fieldTypeObj={c_fieldMapOfDivisionOwners.get("fieldTypeObj")}
                            p_valueRaw={s_newCaptureObj.division_owners_ids_colon_percent_comma}
                            p_errorTF={(s_showErrorsTF && (divisionOwnersErrorMessageOrUndefined !== undefined))}
                            f_onChangeOrOnSelect={this.onchange_division_owners}
                          />
                          {(s_showErrorsTF && (divisionOwnersErrorMessageOrUndefined !== undefined)) &&
                            <CEGeneralReact.ErrorText p_class="tbMicroPad" p_text={divisionOwnersErrorMessageOrUndefined} />
                          }
                        </div>
                      </CEGeneralReact.NewCaptureSectionLabel>
                    }
                    {(m_cncBoxIDOrM1 === 4) &&
                      <CEGeneralReact.NewCaptureSectionLabel p_label={c_fieldMapOfCaptureType.get("display_name")}>
                        <div className="displayFlexRowVc" style={{minHeight:itemRowMinHeight, marginLeft:typeMargin, marginRight:typeMargin}}>
                          <CEGeneralReact.NewCaptureFieldLabel p_widthEm={10} p_label={c_fieldMapOfCaptureType.get("display_name")} />
                          <div className="flex11a">
                            <CEGeneralReact.GenericInputOrSelectFromInputType
                              p_fieldTypeObj={c_fieldMapOfCaptureType.get("fieldTypeObj")}
                              p_valueRaw={s_newCaptureObj.capture_type_id}
                              p_tabIndex={4}
                              p_errorTF={(s_showErrorsTF && (captureTypeErrorMessageOrUndefined !== undefined))}
                              f_onChangeOrOnSelect={this.onchange_capture_type}
                            />
                            {(s_showErrorsTF && (captureTypeErrorMessageOrUndefined !== undefined)) &&
                              <CEGeneralReact.ErrorText p_class="tbMicroPad" p_text={captureTypeErrorMessageOrUndefined} />
                            }
                          </div>
                        </div>
                        <div className="displayFlexRowVc" style={{minHeight:itemRowMinHeight, marginLeft:typeMargin, marginRight:typeMargin}}>
                          <CEGeneralReact.NewCaptureFieldLabel p_widthEm={10} p_label={c_fieldMapOfStage.get("display_name")} />
                          <div className="flex11a">
                            {(captureTypeErrorMessageOrUndefined !== undefined) ? (
                              <font className="fontItalic fontTextLighter">
                                {"--Select the " + c_fieldMapOfCaptureType.get("display_name") + " before selecting " + c_fieldMapOfStage.get("display_name") + "--"}
                              </font>
                            ) : (
                              <>
                                <CEGeneralReact.GenericInputOrSelectFromInputType
                                  p_fieldTypeObj={c_fieldMapOfStage.get("fieldTypeObj")}
                                  p_valueRaw={s_newCaptureObj.stage_id}
                                  p_valuesToNotIncludeArray={stageIDsNotInThisCaptureTypeArray}
                                  p_tabIndex={5}
                                  p_errorTF={(s_showErrorsTF && (stageErrorMessageOrUndefined !== undefined))}
                                  f_onChangeOrOnSelect={this.onchange_stage}
                                />
                                {(s_showErrorsTF && (stageErrorMessageOrUndefined !== undefined)) &&
                                  <CEGeneralReact.ErrorText p_class="tbMicroPad" p_text={stageErrorMessageOrUndefined} />
                                }
                              </>
                            )}
                          </div>
                        </div>
                        {(false && (captureTypeErrorMessageOrUndefined === undefined) && isSubCaptureTypeTF) &&
                          <div className="displayFlexRowVc" style={{minHeight:itemRowMinHeight, marginLeft:typeMargin, marginRight:typeMargin}}>
                            <CEGeneralReact.CaptureExecFieldEditSaveCancel
                              p_ceEditItemString="newCapturePrimeCompany"
                              p_fieldDisplayName={c_fieldMapOfPrimeContactCompanyID.get("display_name")}
                              p_fieldTypeObj={c_fieldMapOfPrimeContactCompanyID.get("fieldTypeObj")}
                              p_valueRaw={s_newCaptureObj.prime_contact_company_id}
                              p_valueMask={((captureTypeErrorMessageOrUndefined !== undefined) || !isSubCaptureTypeTF) ? ((captureTypeErrorMessageOrUndefined !== undefined) ? ("--Select a " + c_fieldMapOfCaptureType.get("display_name") + " before setting " + c_fieldMapOfPrimeContactCompanyID.get("display_name") + "--") : ("--Only Applicable for 'Sub' Capture Types--")) : (undefined)}
                              p_valueIsEditableTFU={((captureTypeErrorMessageOrUndefined !== undefined) || !isSubCaptureTypeTF) ? (undefined) : (true)}
                              p_valuesToNotIncludeArray={undefined}
                              p_containerClass="width100"
                              p_fieldClass="font11 fontBold fontTextLighter"
                              p_fieldWidth="10em"
                              p_fieldNowrapTF={false}
                              p_valueClass={((captureTypeErrorMessageOrUndefined !== undefined) || !isSubCaptureTypeTF) ? ("fontItalic fontTextLighter") : ("")}
                              p_fieldValueVerticallyAlignedTF={true}
                              p_floatingBoxTitle={"Select " + c_fieldMapOfPrimeContactCompanyID.get("display_name")}
                              f_onSaveChanged={this.onchange_prime_company}
                            />
                          </div>
                        }
                      </CEGeneralReact.NewCaptureSectionLabel>
                    }
                    {(m_cncBoxIDOrM1 === 5) &&
                      <CEGeneralReact.NewCaptureSectionLabel p_label={c_fieldMapOfContractType.get("display_name")}>
                        <div className="displayFlexRowVc" style={{minHeight:itemRowMinHeight, marginLeft:typeMargin, marginRight:typeMargin}}>
                          <CEGeneralReact.NewCaptureFieldLabel p_widthEm={13} p_label={c_fieldMapOfContractType.get("display_name")} />
                          <div className="flex11a">
                            <CEGeneralReact.GenericInputOrSelectFromInputType
                              p_fieldTypeObj={c_fieldMapOfContractType.get("fieldTypeObj")}
                              p_valueRaw={s_newCaptureObj.contract_type_id}
                              p_tabIndex={7}
                              p_errorTF={(s_showErrorsTF && (contractTypeErrorMessageOrUndefined !== undefined))}
                              f_onChangeOrOnSelect={this.onchange_contract_type}
                            />
                            {(s_showErrorsTF && (contractTypeErrorMessageOrUndefined !== undefined)) &&
                              <CEGeneralReact.ErrorText p_class="tbMicroPad" p_text={contractTypeErrorMessageOrUndefined} />
                            }
                          </div>
                        </div>
                        <div className="displayFlexRowVc" style={{minHeight:itemRowMinHeight, marginLeft:typeMargin, marginRight:typeMargin}}>
                          <CEGeneralReact.NewCaptureFieldLabel p_widthEm={13} p_label={c_fieldMapOfContractOverallValue.get("display_name")} />
                          <div className="flex11a">
                            {(contractTypeErrorMessageOrUndefined !== undefined) ? (
                              <font className="fontItalic fontTextLighter">
                                {"--Select the " + c_fieldMapOfContractType.get("display_name") + " before setting " + c_fieldMapOfContractOverallValue.get("display_name") + "--"}
                              </font>
                            ) : (
                              <>
                                <CEGeneralReact.GenericInputOrSelectFromInputType
                                  p_fieldTypeObj={c_fieldMapOfContractOverallValue.get("fieldTypeObj")}
                                  p_valueRaw={s_newCaptureObj.contract_overall_value}
                                  p_tabIndex={8}
                                  p_errorTF={(s_showErrorsTF && (contractOverallValueErrorMessageOrUndefined !== undefined))}
                                  f_onChangeOrOnSelect={this.onchange_contract_overall_value}
                                />
                                {(s_showErrorsTF && (contractOverallValueErrorMessageOrUndefined !== undefined)) &&
                                  <CEGeneralReact.ErrorText p_class="tbMicroPad" p_text={contractOverallValueErrorMessageOrUndefined} />
                                }
                              </>
                            )}
                          </div>
                        </div>
                        {(isTaskOrderContractTF) &&
                          <div className="displayFlexRowVc " style={{minHeight:itemRowMinHeight, marginLeft:typeMargin, marginRight:typeMargin}}>
                            <CEGeneralReact.NewCaptureFieldLabel p_widthEm={13} p_label={c_fieldMapOfIdiqCaptureIDTOLink.get("display_name")} />
                            <div className="flex11a">
                              {(contractTypeErrorMessageOrUndefined !== undefined) ? (
                                <font className="fontItalic fontTextLighter">
                                  {"--Select the " + c_fieldMapOfContractType.get("display_name") + " before setting " + c_fieldMapOfIdiqCaptureIDTOLink.get("display_name") + "--"}
                                </font>
                              ) : (
                                <>
                                  <CEGeneralReact.GenericInputOrSelectFromInputType
                                    p_fieldTypeObj={c_fieldMapOfIdiqCaptureIDTOLink.get("fieldTypeObj")}
                                    p_valueRaw={s_newCaptureObj.idiq_capture_id_TO_link}
                                    p_tabIndex={9}
                                    p_errorTF={(s_showErrorsTF && (idiqCaptureTOLinkErrorMessageOrUndefined !== undefined))}
                                    f_onChangeOrOnSelect={this.onchange_idiq_to_link}
                                  />
                                  {(s_showErrorsTF && (idiqCaptureTOLinkErrorMessageOrUndefined !== undefined)) &&
                                    <CEGeneralReact.ErrorText p_class="tbMicroPad" p_text={idiqCaptureTOLinkErrorMessageOrUndefined} />
                                  }
                                </>
                              )}
                            </div>
                          </div>
                        }
                        <div className="displayFlexRowVc" style={{minHeight:itemRowMinHeight, marginLeft:typeMargin, marginRight:typeMargin}}>
                          <CEGeneralReact.NewCaptureFieldLabel p_widthEm={13} p_label={c_fieldMapOfPeriodOfPerformance.get("display_name")} />
                          <div className="flex11a">
                            <CEGeneralReact.GenericInputOrSelectFromInputType
                              p_fieldTypeObj={c_fieldMapOfPeriodOfPerformance.get("fieldTypeObj")}
                              p_valueRaw={s_newCaptureObj.period_of_performance}
                              p_tabIndex={10}
                              p_errorTF={(s_showErrorsTF && (periodOfPerformanceErrorMessageOrUndefined !== undefined))}
                              f_onChangeOrOnSelect={this.onchange_period_of_performance}
                            />
                            {(s_showErrorsTF && (periodOfPerformanceErrorMessageOrUndefined !== undefined)) &&
                              <CEGeneralReact.ErrorText p_class="tbMicroPad" p_text={periodOfPerformanceErrorMessageOrUndefined} />
                            }
                          </div>
                        </div>
                      </CEGeneralReact.NewCaptureSectionLabel>
                    }
                    {(m_cncBoxIDOrM1 === 6) &&
                      <CEGeneralReact.NewCaptureSectionLabel p_label={"New Capture Additional Fields"}>
                        {captureTypeAdditionalFieldsArrayOfObjs.map((m_additionalFieldObj, m_additionalFieldIndex) =>
                          <div className="displayFlexRowVc" style={{minHeight:itemRowMinHeight, marginLeft:typeMargin, marginRight:typeMargin}}>
                            <CEGeneralReact.NewCaptureFieldLabel p_widthEm={13} p_label={m_additionalFieldObj.fieldDisplayName} />
                            <div className="flex11a">
                              <CEGeneralReact.GenericInputOrSelectFromInputType
                                p_fieldTypeObj={m_additionalFieldObj.expandedCaptureFieldMap.get("fieldTypeObj")}
                                p_valueRaw={((s_newCaptureObj.additionalFieldsRawValuesObjOrUndefined !== undefined) ? (s_newCaptureObj.additionalFieldsRawValuesObjOrUndefined[m_additionalFieldObj.fieldDbName]) : (m_additionalFieldObj.fieldBlankValue))}
                                p_tabIndex={11 + m_additionalFieldIndex}
                                p_forceTextareaToTextTF={true}
                                p_errorTF={(s_showErrorsTF && (m_additionalFieldObj.fieldErrorMessageOrUndefined !== undefined))}
                                f_onChangeOrOnSelect={(i_newValue) => {this.onchange_additional_field(m_additionalFieldObj.fieldDbName, i_newValue);}}
                              />
                              {(s_showErrorsTF && (m_additionalFieldObj.fieldErrorMessageOrUndefined !== undefined)) &&
                                <CEGeneralReact.ErrorText p_class="tbMicroPad" p_text={m_additionalFieldObj.fieldErrorMessageOrUndefined} />
                              }
                            </div>
                          </div>
                        )}
                      </CEGeneralReact.NewCaptureSectionLabel>
                    }
                    {(m_cncBoxIDOrM1 === 7) &&
                      <CEGeneralReact.NewCaptureSectionLabel p_label={c_cardNameDocuments + " Card Preset Folders"}>
                        <div style={{margin:"0 20%"}}>
                          <CEGeneralReact.GenericInputOrSelectFromInputType
                            p_fieldTypeObj={c_selectShortcutPresetsDocumentsCardFoldersPresetFieldTypeObj}
                            p_valueRaw={o_createNewCaptureSelectedDocumentsCardFoldersPresetID}
                            p_tabIndex={11 + numCaptureTypeAdditionalFields}
                            f_onChangeOrOnSelect={this.onchange_documents_card_folders_preset}
                          />
                        </div>
                        <div className="bigTopMargin displayFlexColumnHcVc">
                          <div className="flex00a border1bbb bgLightesterGray medFullPad" style={{width:"100%", maxWidth:"30em"}}>
                            {(JSFUNC.select_int_is_filled_out_tf(o_createNewCaptureSelectedDocumentsCardFoldersPresetID)) ? (
                              <>
                                <div className="smallBottomMargin textCenter">
                                  <font className="fontItalic fontTextLight">
                                    {"Initial folders in " + c_cardNameDocuments + " Card from preset '" + c_createNewCaptureDocumentsCardFoldersSelectedPresetName + "'"}
                                  </font>
                                </div>
                                {c_createNewCaptureDocumentsCardFoldersSortedTreeWithIndentsArrayOfObjs.map((m_treeWithIndentsObj) =>
                                  <div className="displayFlexRow" style={{height:"1.9em", marginLeft:(m_treeWithIndentsObj.indentLevel * 1.5) + "em", backgroundColor:"#f4eef8", border:"solid 1px", borderColor:"#dbe #dbe #bad #dbe"}}>
                                    <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"2.5em"}}>
                                      <CEIconsReact.SvgFolder p_widthEm={2.1} p_heightEm={1.2} p_lineColor="777" />
                                    </div>
                                    <div className="flex11a displayFlexRowVc lrPad">
                                      <LibraryReact.NowrapEllipsis p_fontClass="">
                                        {m_treeWithIndentsObj.display_name}
                                      </LibraryReact.NowrapEllipsis>
                                    </div>
                                  </div>
                                )}
                              </>
                            ) : (
                              <div className="textCenter">
                                <font className="fontItalic fontTextLight">
                                  {"No preset selected, the " + c_cardNameDocuments + " Card will initialize empty with no folders"}
                                </font>
                              </div>
                            )}
                          </div>
                        </div>
                      </CEGeneralReact.NewCaptureSectionLabel>
                    }
                  </CEGeneralReact.NewCaptureSectionContainer>
                </>
              )}
            </div>
          )}
        </div>
        <div className="flex00a displayFlexColumnHcVc border1ddd tbBigPad">
          <div>
            <CEGeneralReact.CEButton
              p_type="captureRed"
              p_text="Create This New Capture"
              p_tabIndex={13 + numCaptureTypeAdditionalFields}
              f_onClick={this.onconfirm_create_new_capture}
            />
          </div>
        </div>
      </>
    );
  }
}));
